var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _g2, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _g3, _g4, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _g5, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 97,
    height: 119,
    viewBox: "0 0 97 119",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2164_2451)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.09,
    d: "M19.1637 77.1499C19.9387 76.747 20.8113 76.5425 21.6953 76.5566C22.074 76.5596 22.451 76.6058 22.8181 76.6942C23.1489 76.7779 23.4672 76.9007 23.7655 77.0597L31.8916 81.7588L32.1772 81.9249C32.5157 82.098 32.7946 82.3596 32.9803 82.6786C33.1661 82.9976 33.251 83.3604 33.225 83.7238C33.1679 84.1344 33.0068 84.5258 32.7554 84.8646C32.504 85.2035 32.1697 85.4798 31.7812 85.6699L20.5724 91.8167C20.5724 91.8167 19.6851 92.2913 19.665 92.2913C18.9116 92.6785 18.0659 92.8762 17.2087 92.8656C16.5083 92.8736 15.8176 92.7101 15.2035 92.391L6.832 87.5543L6.72662 87.4926C6.38464 87.3201 6.10279 87.0575 5.91508 86.7366C5.72737 86.4157 5.64189 86.0501 5.66896 85.6841C5.72496 85.2751 5.88451 84.8849 6.13415 84.5469C6.38379 84.2089 6.71604 83.933 7.10259 83.7428L19.1637 77.1499Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.18,
    d: "M18.8246 77.449C19.5916 77.0503 20.4563 76.8506 21.331 76.8699C21.7055 76.881 22.0773 76.9335 22.4389 77.0266C22.7653 77.1177 23.0798 77.2435 23.3764 77.4015L31.4571 82.0721L31.7379 82.2382C32.0588 82.4175 32.3154 82.684 32.4745 83.0031C32.6336 83.3221 32.6879 83.6791 32.6302 84.0277C32.5428 84.4127 32.369 84.7756 32.1208 85.0916C31.8726 85.4077 31.5557 85.6696 31.1914 85.8598L20.4337 91.793C20.3986 91.793 19.5915 92.2676 19.5514 92.2676C18.822 92.6297 18.0089 92.8141 17.1854 92.804C16.5064 92.8061 15.8382 92.6426 15.2453 92.3293L6.8637 87.4879L6.76347 87.4262C6.43183 87.2516 6.16555 86.9839 6.00125 86.66C5.83696 86.3362 5.7827 85.972 5.84607 85.6178C5.93039 85.2353 6.10084 84.8745 6.34565 84.56C6.59045 84.2455 6.90391 83.9846 7.26476 83.7951L18.8246 77.449Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.27,
    d: "M18.4725 77.7576C19.2384 77.3579 20.1052 77.1642 20.979 77.1975C21.3506 77.2116 21.7191 77.2674 22.0768 77.3637C22.3962 77.4664 22.7048 77.5967 22.9991 77.7529L31.0197 82.395L31.3005 82.5611C31.607 82.7453 31.8437 83.017 31.9762 83.3371C32.1087 83.6571 32.1301 84.0087 32.0374 84.3411C31.8048 85.0642 31.2929 85.6777 30.6038 86.0593L20.262 91.7551C20.2119 91.7789 19.47 92.1776 19.4149 92.1965C18.7089 92.5293 17.9273 92.6923 17.139 92.6712C16.4887 92.6801 15.8468 92.5314 15.2742 92.2392L6.89262 87.4168L6.78737 87.3551C6.44677 87.1957 6.17958 86.9237 6.03641 86.5905C5.89324 86.2573 5.884 85.8859 6.01034 85.5467C6.01034 84.9628 6.75229 84.2129 7.42402 83.8474L18.4725 77.7576Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.36,
    d: "M18.1316 78.0612C18.8975 77.6629 19.7653 77.474 20.638 77.5154C21.0089 77.5347 21.376 77.5968 21.7309 77.7005C22.0441 77.8103 22.3474 77.9436 22.6382 78.0992L30.6239 82.7128L30.8995 82.8789C31.2172 83.0476 31.4546 83.3251 31.5628 83.6545C31.671 83.9838 31.6417 84.3398 31.4811 84.6494C31.4811 85.162 30.6338 85.9357 30.0523 86.2537L20.1418 91.7502C20.0766 91.7881 19.4049 92.1441 19.3247 92.1679C18.6473 92.4908 17.8974 92.6537 17.139 92.6425C16.5149 92.6477 15.8996 92.504 15.3495 92.2248L6.95287 87.3739L6.84248 87.3074C6.67448 87.2298 6.52456 87.1211 6.40152 86.9879C6.27847 86.8546 6.18487 86.6994 6.12603 86.5314C6.06719 86.3634 6.04438 86.1859 6.05896 86.0095C6.07354 85.833 6.12513 85.661 6.21084 85.5037C6.21084 84.9911 7.02296 84.2364 7.60947 83.9184L18.1316 78.0612Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.45,
    d: "M17.7893 78.3652C18.5458 77.9718 19.4039 77.7876 20.2656 77.8336C20.6325 77.8588 20.9946 77.9274 21.3435 78.0377C21.6523 78.1536 21.9522 78.29 22.2408 78.4459L30.1762 83.031C30.2213 83.031 30.4168 83.1734 30.4519 83.2019C30.6061 83.2868 30.7404 83.4007 30.8462 83.5367C30.9521 83.6727 31.0272 83.8279 31.0671 83.9925C31.1071 84.1571 31.1109 84.3278 31.0784 84.4939C31.0459 84.66 30.9777 84.818 30.8781 84.9581C30.8781 85.3948 29.9556 86.1732 29.4543 86.4485L19.98 91.7266C19.8947 91.7741 19.2882 92.0921 19.1929 92.1253C18.5368 92.4185 17.8178 92.5631 17.0925 92.5478C16.4965 92.5473 15.9096 92.4088 15.383 92.1443L6.97636 87.2839C6.9378 87.2645 6.90093 87.2423 6.86609 87.2174C6.69724 87.1406 6.54807 87.03 6.42881 86.8932C6.30955 86.7565 6.22302 86.5968 6.17535 86.4252C6.12767 86.2537 6.12 86.0744 6.15271 85.8998C6.18541 85.7251 6.25775 85.5593 6.3648 85.4138C6.3648 84.9771 7.24708 84.2224 7.74837 83.9471L17.7893 78.3652Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.55,
    d: "M17.4232 78.6688C17.9561 78.3843 18.547 78.2106 19.1563 78.159C19.7656 78.1075 20.3796 78.1793 20.9573 78.3697C21.2588 78.4962 21.5533 78.6372 21.8396 78.7922L29.7299 83.3488C29.7801 83.3773 29.9606 83.4865 30.0007 83.5197C30.1525 83.6075 30.282 83.726 30.3801 83.8665C30.4781 84.0071 30.5423 84.1663 30.5682 84.333C30.594 84.4997 30.5808 84.6697 30.5295 84.831C30.4782 84.9923 30.39 85.141 30.2712 85.2664C30.2712 85.6319 29.2687 86.4151 28.8477 86.6429L19.8244 91.7074C19.7241 91.7596 19.1827 92.0397 19.0674 92.0777C18.4382 92.3473 17.7527 92.4787 17.0623 92.4621C16.4936 92.4616 15.934 92.3279 15.4331 92.0729L7.01135 87.2077L6.90108 87.1413C6.73365 87.0618 6.58798 86.9466 6.47567 86.8046C6.36335 86.6627 6.28745 86.498 6.2539 86.3236C6.22036 86.1491 6.23014 85.9696 6.28242 85.7993C6.33471 85.6291 6.42811 85.4726 6.55522 85.3424C6.55522 84.9769 7.50766 84.2222 7.92374 83.9896L17.4232 78.6688Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.64,
    d: "M17.1044 78.9725C17.8532 78.5849 18.7048 78.4117 19.5556 78.4741C19.9169 78.5107 20.2721 78.5888 20.6134 78.7067C20.7388 78.7447 21.3804 79.0817 21.4807 79.1386L29.3208 83.6668C29.4152 83.7177 29.5057 83.7748 29.5915 83.8377C29.7408 83.9302 29.8653 84.0544 29.955 84.2005C30.0448 84.3465 30.0973 84.5104 30.1085 84.679C30.1197 84.8476 30.0892 85.0164 30.0195 85.1719C29.9498 85.3274 29.8427 85.4654 29.7068 85.5749C29.7068 85.8645 28.624 86.6571 28.2881 86.8375L19.681 91.6884C19.5657 91.7501 19.0945 91.9922 18.9591 92.0349C18.3524 92.2842 17.6952 92.4041 17.0341 92.3862C16.4914 92.3802 15.9583 92.2499 15.4802 92.0065L7.05346 87.1413L6.93817 87.0748C6.7704 86.9916 6.62683 86.8705 6.52022 86.7223C6.41362 86.574 6.34729 86.4032 6.32698 86.2249C6.30666 86.0466 6.33296 85.8663 6.40371 85.7C6.47447 85.5336 6.58741 85.3863 6.73256 85.2711C6.73256 84.9769 7.73513 84.2222 8.09606 84.0418L17.1044 78.9725Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.73,
    d: "M16.7548 79.2717C17.5017 78.8899 18.3509 78.7248 19.1962 78.7971C19.5536 78.8386 19.9041 78.9231 20.2389 79.0486C20.3342 79.0771 21.0209 79.4473 21.0961 79.4901L28.8911 83.9898C28.9831 84.0418 29.0719 84.0988 29.1568 84.1606C29.7884 84.6353 29.7685 85.3283 29.1168 85.8884C29.1168 86.1067 27.9538 86.8994 27.7031 87.037L19.532 91.6649C19.3069 91.7873 19.0743 91.8966 18.8353 91.9924C18.2537 92.2172 17.6282 92.3224 17.0005 92.3009C16.4858 92.294 15.9804 92.1703 15.5267 91.9402L7.08992 87.0655L6.97463 86.9991C6.22269 86.5244 6.21273 85.7792 6.90952 85.1954C6.90952 84.977 8.00732 84.2461 8.25797 84.0847L16.7548 79.2717Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.82,
    d: "M16.4196 79.5755C17.1631 79.1942 18.0089 79.0291 18.8509 79.1009C19.2052 79.1497 19.5519 79.239 19.8835 79.3667C19.9437 79.3904 20.6756 79.7891 20.7258 79.8413L28.4707 84.3173C28.5635 84.3681 28.6523 84.4252 28.7364 84.4882C29.348 84.9628 29.2727 85.67 28.5408 86.2064C28.5408 86.3488 27.2977 87.1557 27.1323 87.2411L19.3923 91.6507C19.1798 91.767 18.9587 91.8686 18.7306 91.9544C18.1746 92.1558 17.5809 92.2478 16.986 92.225C16.4956 92.2178 16.0143 92.0989 15.5825 91.8785L7.1357 86.9991L7.02041 86.9326C6.27348 86.458 6.31354 85.6985 7.10057 85.1337C7.10057 84.9865 8.26866 84.2319 8.43409 84.1369L16.4196 79.5755Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.91,
    d: "M16.0669 79.8792C16.8057 79.5014 17.6486 79.3458 18.4832 79.4331C18.8287 79.4852 19.1657 79.5794 19.4858 79.7131C19.5159 79.7131 20.2878 80.1593 20.3179 80.1878L28.0126 84.6353C28.1051 84.686 28.1924 84.7448 28.2733 84.8109C28.8699 85.2855 28.7396 86.0023 27.9225 86.5101C27.4772 86.8555 27.0082 87.1726 26.5188 87.4594L19.2101 91.6553C19.0082 91.7641 18.7969 91.8562 18.5784 91.9307C18.0486 92.1112 17.4866 92.1918 16.9241 92.168C16.4619 92.155 16.0091 92.0413 15.6008 91.8357L7.14392 86.9516L7.02362 86.8803C6.2817 86.4057 6.37191 85.6273 7.24917 85.0814C7.6688 84.7621 8.11104 84.4703 8.57265 84.2081L16.0669 79.8792Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6638 91.7266L7.20201 86.8377C6.32475 86.3631 6.43502 85.5229 7.44262 84.9723L15.719 80.1831C16.237 79.9087 16.8159 79.7537 17.409 79.7306C18.0021 79.7075 18.5926 79.817 19.1327 80.0502L27.5996 84.9391C28.4768 85.4138 28.3665 86.2539 27.3539 86.8045L19.0826 91.5937C18.5637 91.8682 17.9838 92.0232 17.3899 92.0463C16.796 92.0694 16.2047 91.9599 15.6638 91.7266Z",
    fill: "black"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.9836 83.4058H27.773C27.6496 83.2613 27.4982 83.1405 27.3269 83.0499L19.0807 78.5454C18.1082 78.0091 16.4037 78.0708 15.2758 78.6926L7.65121 82.86C7.38915 82.999 7.15765 83.1843 6.9694 83.4058H6.71875V86.1303C6.75366 86.3081 6.83414 86.475 6.953 86.6165C7.07185 86.758 7.22551 86.8698 7.40056 86.942L15.6418 91.4465C16.6193 91.9828 18.3237 91.9211 19.4516 91.2993L27.0763 87.1319C27.2951 87.0326 27.4894 86.8909 27.6466 86.7159C27.8038 86.5409 27.9203 86.3366 27.9887 86.1161L27.9836 83.4058Z",
    fill: "url(#paint0_linear_2164_2451)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6148 88.8835L7.39366 84.379C6.41614 83.8474 6.54149 82.9124 7.66438 82.2953L15.289 78.1279C16.4169 77.5156 18.1214 77.4491 19.0939 77.9807L27.3401 82.4852C28.3176 83.0215 28.1923 83.9518 27.0694 84.5689L19.4247 88.7363C18.2968 89.3534 16.5923 89.4198 15.6148 88.8835Z",
    fill: "url(#paint1_linear_2164_2451)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M27.9786 86.7664C27.9408 87.0181 27.8358 87.2566 27.6735 87.4593C27.5112 87.662 27.297 87.8221 27.0512 87.9245L19.4266 92.0967C18.2986 92.709 16.5942 92.7754 15.6167 92.2438L7.37547 87.7346C7.18101 87.6532 7.01553 87.5202 6.89902 87.3518C6.78251 87.1834 6.71991 86.9867 6.71875 86.7853V88.2662C6.74754 88.4439 6.8221 88.6122 6.93574 88.7563C7.04938 88.9003 7.19865 89.0156 7.37045 89.0922L15.6117 93.6014C16.5892 94.133 18.2936 94.076 19.4215 93.4495L27.0462 89.282C27.265 89.1828 27.4593 89.041 27.6165 88.866C27.7737 88.6911 27.8902 88.4867 27.9585 88.2662V86.7853L27.9786 86.7664Z",
    fill: "url(#paint2_linear_2164_2451)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M27.0487 84.4074L19.4241 88.5748C18.2961 89.1919 16.5917 89.2583 15.6142 88.722L7.39304 84.2175C7.22782 84.143 7.08334 84.033 6.97106 83.8962C6.85877 83.7594 6.78177 83.5996 6.74636 83.4296C6.72645 83.6438 6.77815 83.8585 6.8942 84.0433C7.01025 84.2282 7.18479 84.3738 7.39304 84.4596L15.6343 88.964C16.6118 89.5004 18.3162 89.4387 19.4441 88.8169L27.0688 84.6494C27.7405 84.2792 28.0714 83.7998 27.9862 83.3584C27.9234 83.5888 27.8064 83.8028 27.6441 83.9844C27.4818 84.166 27.2782 84.3106 27.0487 84.4074Z",
    fill: "url(#paint3_radial_2164_2451)"
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1897 80.7337H26.9942C26.8796 80.5998 26.7382 80.4885 26.5781 80.4062L18.9535 76.234C18.3976 75.997 17.7909 75.886 17.1817 75.9099C16.5726 75.9338 15.9778 76.0919 15.4444 76.3717L8.40127 80.2306C8.1581 80.3577 7.94353 80.5286 7.76964 80.7337H7.53906V83.2541C7.567 83.4186 7.63678 83.5741 7.74247 83.7072C7.84815 83.8404 7.98655 83.9472 8.14561 84.0183L15.7702 88.1857C16.3262 88.4228 16.9329 88.5337 17.542 88.5098C18.1512 88.4859 18.746 88.3278 19.2793 88.0481L26.3325 84.1939C26.5362 84.1017 26.7168 83.9693 26.8621 83.8055C27.0073 83.6418 27.1138 83.4506 27.1746 83.2446L27.1897 80.7337Z",
    fill: "url(#paint4_linear_2164_2451)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1897 80.2971H26.9942C26.8782 80.1644 26.737 80.0534 26.5781 79.9696L18.9535 75.8021C18.3976 75.5651 17.7909 75.4541 17.1817 75.478C16.5726 75.5019 15.9778 75.66 15.4444 75.9398L8.40127 79.8224C8.1581 79.9495 7.94353 80.1205 7.76964 80.3255H7.53906V82.8507C7.56652 83.0147 7.63619 83.1698 7.74198 83.3023C7.84777 83.4347 7.98641 83.5404 8.14561 83.6101L15.7702 87.7823C16.3262 88.0193 16.9329 88.1303 17.542 88.1064C18.1512 88.0825 18.746 87.9244 19.2793 87.6447L26.3325 83.7857C26.536 83.6932 26.7165 83.5607 26.8617 83.3971C27.0069 83.2334 27.1135 83.0422 27.1746 82.8364L27.1897 80.2971Z",
    fill: "url(#paint5_linear_2164_2451)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9836 79.0914H27.773C27.6483 78.9482 27.4972 78.8276 27.3269 78.7355L19.0807 74.231C18.1082 73.6994 16.4037 73.7564 15.2758 74.3781L7.65121 78.5503C7.38843 78.6863 7.15665 78.8702 6.9694 79.0914H6.71875V81.8159C6.74754 81.9936 6.8221 82.1619 6.93574 82.3059C7.04938 82.4499 7.19865 82.5653 7.37045 82.6418L15.6117 87.151C16.5892 87.6826 18.2936 87.6257 19.4215 86.9991L27.0462 82.8317C27.265 82.7325 27.4593 82.5907 27.6165 82.4157C27.7737 82.2407 27.8902 82.0364 27.9585 81.8159L27.9836 79.0914Z",
    fill: "url(#paint6_linear_2164_2451)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6192 84.5689L7.37804 80.0597C6.40052 79.5281 6.52586 78.5978 7.64875 77.9807L15.2734 73.8133C16.4013 73.1963 18.1057 73.1298 19.0782 73.6614L27.3245 78.1706C28.302 78.7022 28.1766 79.6325 27.0537 80.2496L19.4291 84.4218C18.3012 85.0436 16.5968 85.1053 15.6192 84.5689Z",
    fill: "url(#paint7_linear_2164_2451)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M27.0531 80.0929L19.4285 84.2604C18.3006 84.8774 16.5961 84.9439 15.6186 84.4123L7.37741 79.9031C7.21172 79.8292 7.06682 79.7194 6.95445 79.5824C6.84207 79.4455 6.76538 79.2854 6.73073 79.1152C6.71082 79.3294 6.76264 79.5441 6.87869 79.7289C6.99474 79.9138 7.16916 80.0594 7.37741 80.1451L15.6186 84.6543C16.5961 85.1859 18.3006 85.129 19.4285 84.5024L27.0531 80.335C27.7249 79.9648 28.0557 79.4854 27.9705 79.0439C27.9105 79.2728 27.7969 79.4859 27.6381 79.6674C27.4793 79.849 27.2794 79.9945 27.0531 80.0929Z",
    fill: "url(#paint8_radial_2164_2451)"
  }), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1897 76.4191H26.9942C26.8796 76.2852 26.7382 76.1739 26.5781 76.0916L18.9535 71.9242C18.3976 71.6872 17.7909 71.5762 17.1817 71.6001C16.5726 71.624 15.9778 71.7821 15.4444 72.0618L8.40127 75.916C8.1581 76.0431 7.94353 76.214 7.76964 76.4191H7.53906V78.9395C7.56575 79.1044 7.63504 79.2605 7.74088 79.3938C7.84671 79.5271 7.98577 79.6336 8.14561 79.7037L15.7702 83.8759C16.3263 84.1133 16.9333 84.2241 17.5426 84.1993C18.152 84.1746 18.7468 84.0151 19.2793 83.7335L26.3325 79.8793C26.5362 79.7871 26.7168 79.6547 26.8621 79.4909C27.0073 79.3272 27.1138 79.136 27.1746 78.93L27.1897 76.4191Z",
    fill: "url(#paint9_linear_2164_2451)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1897 75.9918H26.9942C26.8798 75.8564 26.7384 75.7435 26.5781 75.6595L18.9535 71.4921C18.3976 71.2551 17.7909 71.1441 17.1817 71.168C16.5726 71.1919 15.9778 71.35 15.4444 71.6297L8.40127 75.4886C8.15704 75.6143 7.94218 75.7854 7.76964 75.9918H7.53906V78.5122C7.567 78.6766 7.63678 78.8321 7.74247 78.9653C7.84815 79.0984 7.98655 79.2052 8.14561 79.2763L15.7702 83.4438C16.3262 83.6808 16.9329 83.7918 17.542 83.7679C18.1512 83.744 18.746 83.5859 19.2793 83.3062L26.3325 79.452C26.5362 79.3597 26.7168 79.2273 26.8621 79.0636C27.0073 78.8998 27.1138 78.7086 27.1746 78.5027L27.1897 75.9918Z",
    fill: "url(#paint10_linear_2164_2451)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9836 74.7815H27.773C27.651 74.6357 27.4994 74.5146 27.3269 74.4255L19.0807 69.9163C18.1082 69.3847 16.4037 69.4417 15.2758 70.0682L7.65121 74.2357C7.38812 74.3732 7.15636 74.5587 6.9694 74.7815H6.71875V77.506C6.74789 77.683 6.82258 77.8505 6.93623 77.9937C7.04988 78.1369 7.19902 78.2514 7.37045 78.3272L15.6117 82.8363C16.5892 83.368 18.2936 83.311 19.4215 82.6845L27.0462 78.517C27.2646 78.4185 27.4588 78.2776 27.616 78.1034C27.7732 77.9293 27.8899 77.7257 27.9585 77.506L27.9836 74.7815Z",
    fill: "url(#paint11_linear_2164_2451)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6148 80.2591L7.39366 75.7546C6.41614 75.2183 6.54149 74.2879 7.66438 73.6709L15.289 69.5035C16.4169 68.8864 18.1214 68.82 19.0939 69.3563L27.3401 73.8608C28.3176 74.3924 28.1923 75.3274 27.0694 75.9397L19.4247 80.1119C18.2968 80.7242 16.5923 80.7717 15.6148 80.2591Z",
    fill: "url(#paint12_linear_2164_2451)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M27.0485 75.783L19.4239 79.9504C18.296 80.5627 16.5915 80.6292 15.614 80.0976L7.39288 75.5931C7.22705 75.5182 7.08211 75.4074 6.96979 75.2697C6.85747 75.132 6.78088 74.9713 6.74619 74.8004C6.72673 75.0152 6.77859 75.2304 6.89452 75.4159C7.01046 75.6014 7.18469 75.748 7.39288 75.8352L15.6341 80.3396C16.6116 80.8712 18.316 80.8143 19.444 80.1925L27.0686 76.0203C27.7403 75.6548 28.0712 75.1707 27.986 74.7292C27.9235 74.9603 27.8067 75.1751 27.6444 75.3576C27.4821 75.54 27.2784 75.6854 27.0485 75.783Z",
    fill: "url(#paint13_radial_2164_2451)"
  }), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1897 72.1092H26.9942C26.8798 71.9738 26.7384 71.8609 26.5781 71.7769L18.9535 67.6095C18.3976 67.3725 17.7909 67.2615 17.1817 67.2854C16.5726 67.3093 15.9778 67.4674 15.4444 67.7471L8.40127 71.6013C8.1578 71.73 7.94323 71.9026 7.76964 72.1092H7.53906V74.6296C7.56652 74.7936 7.63619 74.9487 7.74198 75.0812C7.84777 75.2136 7.98641 75.3193 8.14561 75.389L15.7702 79.5612C16.3262 79.7982 16.9329 79.9092 17.542 79.8853C18.1512 79.8614 18.746 79.7033 19.2793 79.4236L26.3325 75.5647C26.5364 75.4727 26.7171 75.3403 26.8624 75.1766C27.0077 75.0128 27.1141 74.8214 27.1746 74.6154L27.1897 72.1092Z",
    fill: "url(#paint14_linear_2164_2451)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1897 71.6773H26.9942C26.8796 71.5434 26.7382 71.4321 26.5781 71.3498L18.9535 67.1776C18.3976 66.9406 17.7909 66.8296 17.1817 66.8535C16.5726 66.8774 15.9778 67.0355 15.4444 67.3153L8.40127 71.1742C8.1581 71.3013 7.94353 71.4722 7.76964 71.6773H7.53906V74.1977C7.56575 74.3626 7.63504 74.5186 7.74088 74.652C7.84671 74.7853 7.98577 74.8918 8.14561 74.9619L15.7702 79.1293C16.3262 79.3663 16.9329 79.4773 17.542 79.4534C18.1512 79.4295 18.746 79.2714 19.2793 78.9917L26.3325 75.1375C26.5362 75.0453 26.7168 74.9128 26.8621 74.7491C27.0073 74.5854 27.1138 74.3941 27.1746 74.1882L27.1897 71.6773Z",
    fill: "url(#paint15_linear_2164_2451)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9836 70.4669H27.773C27.6496 70.3224 27.4982 70.2015 27.3269 70.1109L19.0807 65.6065C18.1082 65.0701 16.4037 65.1318 15.2758 65.7536L7.65121 69.921C7.38915 70.06 7.15765 70.2453 6.9694 70.4669H6.71875V73.1772C6.74837 73.3546 6.8233 73.5225 6.93684 73.6664C7.05039 73.8103 7.19916 73.9258 7.37045 74.003L15.6117 78.5075C16.5892 79.0438 18.2936 78.9821 19.4215 78.3603L27.0462 74.1929C27.264 74.0931 27.4574 73.9512 27.6137 73.7762C27.77 73.6012 27.8858 73.3972 27.9535 73.1772L27.9836 70.4669Z",
    fill: "url(#paint16_linear_2164_2451)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6148 75.9445L7.39366 71.4401C6.41614 70.9037 6.54149 69.9734 7.66438 69.3563L15.289 65.1889C16.4169 64.5766 18.1214 64.5101 19.0939 65.0417L27.3401 69.5462C28.3176 70.0825 28.1923 71.0129 27.0694 71.6299L19.4247 75.7974C18.2968 76.4144 16.5923 76.4999 15.6148 75.9445Z",
    fill: "url(#paint17_linear_2164_2451)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M27.0487 71.4684L19.4241 75.6359C18.2961 76.2529 16.5917 76.3194 15.6142 75.783L7.39304 71.2786C7.22782 71.2041 7.08334 71.094 6.97106 70.9572C6.85877 70.8204 6.78177 70.6606 6.74636 70.4906C6.72645 70.7049 6.77815 70.9195 6.8942 71.1044C7.01025 71.2892 7.18479 71.4348 7.39304 71.5206L15.6142 76.0251C16.5917 76.5614 18.2961 76.4997 19.4241 75.8779L27.0487 71.7105C27.7204 71.3402 28.0513 70.8609 27.9661 70.4194C27.9048 70.6477 27.7906 70.8602 27.632 71.0416C27.4733 71.223 27.2741 71.3688 27.0487 71.4684Z",
    fill: "url(#paint18_radial_2164_2451)"
  }), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1897 67.7945H26.9942C26.8796 67.6605 26.7382 67.5492 26.5781 67.467L18.9535 63.2948C18.3976 63.0578 17.7909 62.9468 17.1817 62.9707C16.5726 62.9946 15.9778 63.1527 15.4444 63.4324L8.40127 67.2913C8.1581 67.4185 7.94353 67.5894 7.76964 67.7945H7.53906V70.3291C7.567 70.4936 7.63678 70.6491 7.74247 70.7822C7.84815 70.9154 7.98655 71.0222 8.14561 71.0933L15.7702 75.2608C16.3262 75.4978 16.9329 75.6087 17.542 75.5848C18.1512 75.5609 18.746 75.4028 19.2793 75.1231L26.3325 71.2689C26.5362 71.1767 26.7168 71.0442 26.8621 70.8805C27.0073 70.7168 27.1138 70.5255 27.1746 70.3196L27.1897 67.7945Z",
    fill: "url(#paint19_linear_2164_2451)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1897 67.3627H26.9942C26.8782 67.2301 26.737 67.1191 26.5781 67.0352L18.9535 62.8678C18.3976 62.6308 17.7909 62.5198 17.1817 62.5437C16.5726 62.5676 15.9778 62.7257 15.4444 63.0054L8.40127 66.8596C8.1581 66.9867 7.94353 67.1576 7.76964 67.3627H7.53906V69.8879C7.56652 70.0519 7.63619 70.207 7.74198 70.3395C7.84777 70.4719 7.98641 70.5776 8.14561 70.6473L15.7702 74.8195C16.3262 75.0565 16.9329 75.1675 17.542 75.1436C18.1512 75.1197 18.746 74.9616 19.2793 74.6819L26.3325 70.8229C26.536 70.7304 26.7165 70.5979 26.8617 70.4342C27.0069 70.2706 27.1135 70.0794 27.1746 69.8736L27.1897 67.3627Z",
    fill: "url(#paint20_linear_2164_2451)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9836 66.1523H27.773C27.6496 66.0078 27.4982 65.8869 27.3269 65.7963L19.0807 61.3108C18.1082 60.7792 16.4037 60.8362 15.2758 61.458L7.65121 65.6254C7.38915 65.7644 7.15765 65.9497 6.9694 66.1713H6.71875V68.8958C6.74754 69.0735 6.8221 69.2417 6.93574 69.3858C7.04938 69.5298 7.19865 69.6451 7.37045 69.7216L15.6117 74.2308C16.5892 74.7624 18.2936 74.7055 19.4215 74.079L27.0462 69.9115C27.265 69.8123 27.4593 69.6706 27.6165 69.4956C27.7737 69.3206 27.8902 69.1162 27.9585 68.8958L27.9836 66.1523Z",
    fill: "url(#paint21_linear_2164_2451)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6192 71.6346L7.37804 67.1254C6.40052 66.5938 6.52586 65.6635 7.64875 65.0464L15.2734 60.879C16.4013 60.2619 18.1057 60.1955 19.0782 60.7271L27.3245 65.2363C28.302 65.7679 28.1766 66.6982 27.0537 67.3153L19.4291 71.4827C18.3012 72.0997 16.5968 72.1662 15.6192 71.6346Z",
    fill: "url(#paint22_linear_2164_2451)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M27.0531 67.154L19.4285 71.3214C18.3006 71.9385 16.5961 72.0049 15.6186 71.4733L7.37741 66.9641C7.21219 66.8896 7.06771 66.7796 6.95543 66.6428C6.84314 66.506 6.76614 66.3462 6.73073 66.1762C6.71082 66.3904 6.76264 66.6051 6.87869 66.79C6.99474 66.9748 7.16916 67.1204 7.37741 67.2062L15.6186 71.7154C16.5961 72.247 18.3006 72.19 19.4285 71.5635L27.0531 67.396C27.7249 67.0258 28.0557 66.5464 27.9705 66.105C27.9099 66.3335 27.796 66.5463 27.6373 66.7278C27.4785 66.9093 27.2789 67.0549 27.0531 67.154Z",
    fill: "url(#paint23_radial_2164_2451)"
  }), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1897 63.4799H26.9942C26.8796 63.346 26.7382 63.2347 26.5781 63.1524L18.9535 58.9802C18.3969 58.745 17.7902 58.6354 17.1812 58.6602C16.5723 58.6849 15.9777 58.8432 15.4444 59.1226L8.40127 62.9768C8.1581 63.1039 7.94353 63.2748 7.76964 63.4799H7.53906V66.0003C7.56575 66.1652 7.63504 66.3212 7.74088 66.4546C7.84671 66.5879 7.98577 66.6944 8.14561 66.7645L15.7702 70.9367C16.3268 71.1719 16.9336 71.2815 17.5425 71.2567C18.1515 71.232 18.746 71.0737 19.2793 70.7943L26.3325 66.9401C26.5362 66.8479 26.7168 66.7154 26.8621 66.5517C27.0073 66.388 27.1138 66.1967 27.1746 65.9908L27.1897 63.4799Z",
    fill: "url(#paint24_linear_2164_2451)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1897 63.0528H26.9942C26.8798 62.9174 26.7384 62.8045 26.5781 62.7205L18.9535 58.5531C18.3976 58.3161 17.7909 58.2051 17.1817 58.229C16.5726 58.2529 15.9778 58.411 15.4444 58.6907L8.40127 62.5449C8.1578 62.6736 7.94323 62.8462 7.76964 63.0528H7.53906V65.5827C7.567 65.7471 7.63678 65.9027 7.74247 66.0358C7.84815 66.169 7.98655 66.2757 8.14561 66.3469L15.7702 70.5143C16.3262 70.7513 16.9329 70.8623 17.542 70.8384C18.1512 70.8145 18.746 70.6564 19.2793 70.3767L26.3325 66.5225C26.5362 66.4302 26.7168 66.2978 26.8621 66.1341C27.0073 65.9704 27.1138 65.7791 27.1746 65.5732L27.1897 63.0528Z",
    fill: "url(#paint25_linear_2164_2451)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9836 61.8567H27.773C27.651 61.7109 27.4994 61.5898 27.3269 61.5007L19.0807 56.9915C18.1082 56.4599 16.4037 56.5169 15.2758 57.1434L7.65121 61.3109C7.38703 61.4469 7.15497 61.6327 6.9694 61.8567H6.71875V64.5812C6.74872 64.7579 6.82378 64.925 6.93733 65.0681C7.05088 65.2112 7.19953 65.3259 7.37045 65.4024L15.6117 69.9116C16.5892 70.4432 18.2936 70.3862 19.4215 69.7597L27.0462 65.5922C27.2646 65.4938 27.4588 65.3528 27.616 65.1787C27.7732 65.0045 27.8899 64.8009 27.9585 64.5812L27.9836 61.8567Z",
    fill: "url(#paint26_linear_2164_2451)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6192 67.3343L7.37804 62.8251C6.40052 62.2935 6.52586 61.3631 7.64875 60.7461L15.2734 56.5787C16.4013 55.9616 18.1057 55.8951 19.0782 56.4315L27.3245 60.936C28.302 61.4676 28.1766 62.4026 27.0537 63.0149L19.4291 67.1824C18.3012 67.7994 16.5968 67.8659 15.6192 67.3343Z",
    fill: "url(#paint27_linear_2164_2451)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M27.0487 62.8534L19.4241 67.0066C18.2961 67.6189 16.5917 67.6854 15.6142 67.1538L7.39304 62.6683C7.22769 62.5928 7.08317 62.4818 6.97094 62.3442C6.8587 62.2066 6.78179 62.0462 6.74636 61.8757C6.72645 62.0899 6.77815 62.3046 6.8942 62.4894C7.01025 62.6743 7.18479 62.8199 7.39304 62.9056L15.6343 67.4148C16.6118 67.9464 18.3162 67.8895 19.4441 67.2629L27.0688 63.0955C27.7405 62.73 28.0714 62.2459 27.9862 61.8044C27.924 62.0351 27.8073 62.2494 27.6449 62.4311C27.4826 62.6129 27.2787 62.7573 27.0487 62.8534Z",
    fill: "url(#paint28_radial_2164_2451)"
  }), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1897 59.1796H26.9942C26.8782 59.0469 26.737 58.9359 26.5781 58.8521L18.9535 54.6656C18.3976 54.4286 17.7909 54.3177 17.1817 54.3416C16.5726 54.3655 15.9778 54.5235 15.4444 54.8033L8.40127 58.6764C8.1581 58.8036 7.94353 58.9745 7.76964 59.1796H7.53906V61.7047C7.56652 61.8687 7.63619 62.0238 7.74198 62.1563C7.84777 62.2887 7.98641 62.3945 8.14561 62.4642L15.7702 66.6363C16.3262 66.8733 16.9329 66.9843 17.542 66.9604C18.1512 66.9365 18.746 66.7784 19.2793 66.4987L26.3325 62.6398C26.536 62.5473 26.7165 62.4148 26.8617 62.2511C27.0069 62.0874 27.1135 61.8963 27.1746 61.6905L27.1897 59.1796Z",
    fill: "url(#paint29_linear_2164_2451)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1897 58.7525H26.9942C26.8796 58.6186 26.7382 58.5073 26.5781 58.425L18.9535 54.2528C18.3976 54.0158 17.7909 53.9048 17.1817 53.9287C16.5726 53.9526 15.9778 54.1107 15.4444 54.3904L8.40127 58.2494C8.1581 58.3765 7.94353 58.5474 7.76964 58.7525H7.53906V61.2729C7.567 61.4374 7.63678 61.5929 7.74247 61.726C7.84815 61.8592 7.98655 61.966 8.14561 62.0371L15.7702 66.2045C16.3262 66.4416 16.9329 66.5525 17.542 66.5286C18.1512 66.5047 18.746 66.3466 19.2793 66.0669L26.3325 62.2127C26.5362 62.1205 26.7168 61.9881 26.8621 61.8243C27.0073 61.6606 27.1138 61.4694 27.1746 61.2634L27.1897 58.7525Z",
    fill: "url(#paint30_linear_2164_2451)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9836 57.5421H27.773C27.651 57.3963 27.4994 57.2752 27.3269 57.1861L19.0807 52.6816C18.1082 52.1453 16.4037 52.207 15.2758 52.8288L7.65121 56.9962C7.38915 57.1352 7.15765 57.3205 6.9694 57.5421H6.71875V60.2666C6.74837 60.444 6.8233 60.6119 6.93684 60.7558C7.05039 60.8997 7.19916 61.0153 7.37045 61.0925L15.6217 65.5827C16.5992 66.119 18.3037 66.0573 19.4316 65.4355L27.0562 61.2681C27.2745 61.1681 27.4683 61.0261 27.6254 60.8513C27.7825 60.6764 27.8994 60.4724 27.9686 60.2524L27.9836 57.5421Z",
    fill: "url(#paint31_linear_2164_2451)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6148 63.0197L7.39366 58.5152C6.41614 57.9789 6.54149 57.0485 7.66438 56.4315L15.289 52.2641C16.4169 51.6518 18.1214 51.5806 19.0939 52.1169L27.3401 56.6214C28.3176 57.1577 28.1923 58.088 27.0694 58.7051L19.4247 62.8725C18.2968 63.4896 16.5923 63.556 15.6148 63.0197Z",
    fill: "url(#paint32_linear_2164_2451)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M27.0487 58.5437L19.4241 62.7349C18.2961 63.3519 16.5917 63.4184 15.6142 62.882L7.39304 58.3539C7.22782 58.2794 7.08334 58.1693 6.97106 58.0325C6.85877 57.8957 6.78177 57.7359 6.74636 57.5659C6.72645 57.7801 6.77815 57.9948 6.8942 58.1797C7.01025 58.3645 7.18479 58.5102 7.39304 58.5959L15.6343 63.1004C16.6118 63.6367 18.3162 63.575 19.4441 62.9532L27.0688 58.7858C27.7405 58.4156 28.0714 57.9362 27.9862 57.49C27.9237 57.7211 27.8069 57.9359 27.6446 58.1183C27.4823 58.3007 27.2786 58.4462 27.0487 58.5437Z",
    fill: "url(#paint33_radial_2164_2451)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M18.2023 60.4423C21.2394 60.4423 23.7015 59.2544 23.7015 57.789C23.7015 56.3237 21.2394 55.1357 18.2023 55.1357C15.1652 55.1357 12.7031 56.3237 12.7031 57.789C12.7031 59.2544 15.1652 60.4423 18.2023 60.4423Z",
    fill: "url(#paint34_radial_2164_2451)"
  }), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9306 56.0042H12.9375V57.6939C12.9375 59.0657 14.9427 60.1716 17.4491 60.1716C19.9556 60.1716 21.9608 59.0657 21.9608 57.6939V57.6607L21.9306 56.0042Z",
    fill: "url(#paint35_linear_2164_2451)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9531 56.0233C12.9531 57.3903 14.9583 58.501 17.4648 58.501C19.9712 58.501 21.9764 57.3903 21.9764 56.0233C21.9764 54.6563 19.9712 53.5457 17.4648 53.5457C14.9583 53.5457 12.9531 54.6658 12.9531 56.0233Z",
    fill: "url(#paint36_linear_2164_2451)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4523 57.5944C19.0138 57.5944 20.2796 56.8952 20.2796 56.0328C20.2796 55.1703 19.0138 54.4712 17.4523 54.4712C15.8908 54.4712 14.625 55.1703 14.625 56.0328C14.625 56.8952 15.8908 57.5944 17.4523 57.5944Z",
    fill: "#6B24D6"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4529 55.952C18.3702 55.9011 19.2715 56.1963 19.9594 56.7732C20.1683 56.5768 20.2886 56.3114 20.2952 56.0327C20.2952 55.1736 19.032 54.4758 17.468 54.4758C15.9039 54.4758 14.6406 55.1736 14.6406 56.0327C14.6472 56.3114 14.7677 56.5768 14.9766 56.7732C15.6569 56.2035 16.5458 55.9087 17.4529 55.952Z",
    fill: "url(#paint37_linear_2164_2451)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M17.4491 58.4914C14.9928 58.4914 12.9977 57.4044 12.9375 56.0564V56.1039C12.9375 57.4709 14.9427 58.5815 17.4491 58.5815C19.9556 58.5815 21.9608 57.4709 21.9608 56.1039C21.9635 56.0882 21.9635 56.0721 21.9608 56.0564C21.9006 57.4044 19.9255 58.4914 17.4491 58.4914Z",
    fill: "url(#paint38_radial_2164_2451)"
  }), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.09,
    d: "M43.6112 92.8706L56.9105 88.0245C57.714 87.61 58.6175 87.4006 59.5323 87.4169C59.9209 87.42 60.3079 87.4661 60.6852 87.5545C61.0345 87.6442 61.3711 87.7732 61.6878 87.939L71.5633 93.3928L71.844 93.5494C72.1981 93.7346 72.489 94.0116 72.6826 94.3479C72.8762 94.6842 72.9643 95.0659 72.9368 95.448C72.8755 95.8824 72.7074 96.2972 72.4463 96.659C72.1851 97.0209 71.8381 97.3198 71.4329 97.5317L63.2518 104.922C62.4608 105.337 61.5697 105.552 60.6652 105.544C59.9233 105.566 59.1883 105.402 58.5347 105.069L43.3806 96.7343C43.0297 96.5633 42.7337 96.3061 42.5238 95.9896C42.3139 95.6731 42.1977 95.309 42.1875 94.9354C42.2103 94.5026 42.3541 94.0834 42.6042 93.7206C42.8544 93.3578 43.2019 93.0645 43.6112 92.8706Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.18,
    d: "M43.6711 92.9654L56.9703 88.1192C58.1175 87.5165 59.4663 87.3567 60.735 87.6731C61.0841 87.7693 61.4205 87.9031 61.7376 88.0718L71.5328 93.5018C71.5328 93.5018 71.7935 93.6489 71.8086 93.6632C72.1439 93.8494 72.4122 94.127 72.5785 94.4597C72.7448 94.7925 72.8015 95.1649 72.741 95.5286C72.6466 95.9476 72.4615 96.3436 72.1975 96.6916C71.9335 97.0396 71.5963 97.332 71.207 97.5506L63.1864 104.808C62.42 105.211 61.5567 105.421 60.6799 105.416C59.9561 105.433 59.2401 105.269 58.6045 104.941L43.4504 96.606C43.1148 96.4446 42.8317 96.2 42.6313 95.8983C42.4309 95.5965 42.3207 95.2489 42.3125 94.8925C42.3428 94.4873 42.484 94.0965 42.7222 93.7586C42.9604 93.4207 43.2875 93.1474 43.6711 92.9654Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.27,
    d: "M43.7324 93.0602L57.0267 88.214C57.8271 87.7988 58.7314 87.5971 59.6434 87.6302C60.0251 87.6459 60.4036 87.7032 60.7713 87.8011C61.1189 87.9057 61.4547 88.0424 61.7739 88.2093L71.514 93.6108C71.544 93.6108 71.7697 93.7532 71.7897 93.7722C72.1103 93.9635 72.358 94.2466 72.4968 94.5804C72.6357 94.9142 72.6585 95.2812 72.5617 95.6281C72.3075 96.4349 71.7607 97.1308 71.0177 97.5932L63.1374 104.713C62.3843 105.108 61.5367 105.312 60.6761 105.306C59.9756 105.315 59.2846 105.152 58.6709 104.832L43.4918 96.5205C43.1724 96.3693 42.903 96.1379 42.7129 95.8517C42.5229 95.5654 42.4195 95.2352 42.4141 94.8972C42.4448 94.5085 42.5827 94.1342 42.814 93.8119C43.0454 93.4895 43.362 93.2304 43.7324 93.0602Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.36,
    d: "M43.7895 93.1554L57.0888 88.3092C57.8842 87.8967 58.7847 87.7012 59.6905 87.7444C60.07 87.7633 60.4455 87.8271 60.8083 87.9343C61.1422 88.0468 61.4657 88.1849 61.7758 88.3472L71.4608 93.7203C71.4959 93.7203 71.7064 93.8579 71.7315 93.8816C72.0604 94.0599 72.3061 94.349 72.4194 94.6914C72.5328 95.0337 72.5055 95.4039 72.3431 95.728C72.3431 96.2644 71.4006 97.2991 70.789 97.6267L63.0441 104.618C62.3116 105.004 61.486 105.204 60.6479 105.197C59.9622 105.217 59.2831 105.066 58.6778 104.761L43.5338 96.4353C43.2341 96.2903 42.9822 96.0702 42.8054 95.7991C42.6286 95.5279 42.5338 95.2161 42.5312 94.8974C42.5617 94.5282 42.6939 94.173 42.9147 93.8674C43.1355 93.5617 43.4372 93.3162 43.7895 93.1554Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.45,
    d: "M43.8509 93.2503L57.1452 88.4042C57.9378 87.995 58.8356 87.8043 59.7368 87.8536C60.1136 87.8809 60.4857 87.951 60.8448 88.0624C61.1718 88.1831 61.49 88.3242 61.7972 88.4849L71.427 93.8294C71.5204 93.8783 71.6108 93.9321 71.6977 93.9908C71.8606 94.0782 72.0025 94.1966 72.1146 94.3385C72.2266 94.4805 72.3064 94.6429 72.3488 94.8156C72.3912 94.9882 72.3953 95.1673 72.3609 95.3415C72.3265 95.5157 72.2543 95.6813 72.1488 95.8277C72.1488 96.3024 71.1062 97.3846 70.5849 97.6694L63.0002 104.504C62.2865 104.877 61.4844 105.071 60.6693 105.069C59.9997 105.09 59.3359 104.944 58.7443 104.647L43.5953 96.3119C43.3122 96.1811 43.0726 95.9791 42.9028 95.7279C42.733 95.4767 42.6396 95.1861 42.6328 94.8879C42.6682 94.5383 42.7991 94.2034 43.0127 93.9163C43.2263 93.6292 43.5152 93.3996 43.8509 93.2503Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.55,
    d: "M43.9002 93.3452L57.1995 88.4991C57.9871 88.0925 58.8812 87.908 59.7761 87.9674C60.1502 87.9993 60.5189 88.0743 60.8739 88.1905C61.1961 88.3198 61.5108 88.4656 61.8164 88.6272L71.391 93.9386C71.4461 93.967 71.6166 94.0715 71.6567 94.1C71.8169 94.1906 71.9539 94.3137 72.0579 94.4604C72.1618 94.6071 72.2302 94.7739 72.258 94.9486C72.2858 95.1234 72.2724 95.3018 72.2187 95.471C72.165 95.6402 72.0724 95.7961 71.9475 95.9274C71.9475 96.3118 70.8095 97.47 70.3733 97.7121L62.9342 104.428C62.241 104.792 61.4609 104.982 60.6684 104.979C60.0182 105 59.3735 104.859 58.7986 104.571L43.6445 96.2359C43.375 96.1123 43.1475 95.9195 42.9879 95.6795C42.8284 95.4395 42.7432 95.1619 42.7422 94.8784C42.7809 94.5505 42.9076 94.2374 43.1103 93.969C43.313 93.7006 43.585 93.4859 43.9002 93.3452Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.64,
    d: "M43.9622 93.4402L57.2565 88.594C58.0414 88.1909 58.9328 88.0112 59.8231 88.0766C60.1946 88.1164 60.5597 88.1977 60.9109 88.3187C61.0412 88.3614 61.7281 88.7032 61.8383 88.7649L71.3629 94.0477C71.4532 94.0981 71.5403 94.1536 71.6236 94.2139C71.7809 94.309 71.9125 94.4378 72.0077 94.5898C72.103 94.7419 72.1592 94.913 72.1719 95.0893C72.1845 95.2657 72.1533 95.4424 72.0807 95.6053C72.0081 95.7681 71.8961 95.9126 71.7538 96.027C71.7538 96.3356 70.5156 97.5602 70.1647 97.75L62.8809 104.333C62.2058 104.687 61.4467 104.872 60.6753 104.87C60.043 104.89 59.416 104.754 58.8556 104.476L43.7065 96.141C43.454 96.0249 43.2409 95.8443 43.0912 95.6195C42.9415 95.3947 42.8611 95.1347 42.8594 94.8689C42.9008 94.5619 43.0236 94.2699 43.2165 94.0201C43.4093 93.7703 43.6659 93.5708 43.9622 93.4402Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.73,
    d: "M44.0193 93.5351L57.3186 88.6889C58.1015 88.297 58.9888 88.1319 59.8701 88.2142C60.239 88.258 60.601 88.344 60.9479 88.4705C61.0432 88.5038 61.78 88.8835 61.8602 88.9452L71.3297 94.1996C71.4216 94.25 71.5103 94.3055 71.5954 94.3657C72.2621 94.8404 72.247 95.5903 71.5653 96.1742C71.5653 96.402 70.2218 97.6883 69.9612 97.8307L62.8228 104.281C62.1669 104.623 61.4307 104.802 60.6822 104.803C60.0693 104.823 59.4613 104.693 58.9177 104.424L43.7636 96.0887C43.5273 95.9831 43.3277 95.8157 43.1883 95.6063C43.0489 95.397 42.9754 95.1543 42.9766 94.9069C43.0122 94.6129 43.1268 94.3325 43.3093 94.0924C43.4919 93.8523 43.7363 93.6604 44.0193 93.5351Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.82,
    d: "M44.0814 93.6299L57.3756 88.7837C57.9201 88.4893 58.5288 88.3174 59.1546 88.2811C59.7805 88.2449 60.4066 88.3454 60.9849 88.5748C61.0501 88.5748 61.8321 89.0115 61.8873 89.0495L71.3015 94.2707C71.3919 94.3211 71.4789 94.3765 71.5622 94.4368C72.2139 94.9352 72.1388 95.6756 71.3718 96.2357C70.8961 96.821 70.3548 97.3557 69.7575 97.8306L62.7696 104.148C62.1318 104.479 61.4166 104.654 60.6892 104.656C60.094 104.677 59.5031 104.551 58.9747 104.291L43.8257 95.9604C43.6049 95.8641 43.4183 95.7094 43.2884 95.5148C43.1585 95.3202 43.0909 95.0942 43.0938 94.864C43.1373 94.5968 43.2504 94.3441 43.4228 94.1287C43.5952 93.9132 43.8215 93.7418 44.0814 93.6299Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.91,
    d: "M44.1343 93.7249L57.4336 88.8787C58.1991 88.484 59.0731 88.3185 59.9401 88.4041C60.3044 88.4593 60.6598 88.5582 60.9977 88.6984C61.0278 88.6984 61.855 89.173 61.885 89.173L71.2442 94.3657C71.3353 94.415 71.4223 94.4705 71.5048 94.5318C72.1414 95.035 72.0061 95.7802 71.1539 96.3213C70.6515 96.8601 70.1194 97.3734 69.5598 97.8591L62.7173 104.03C62.1009 104.343 61.4117 104.506 60.7121 104.504C60.1346 104.526 59.561 104.405 59.0478 104.153L43.8937 95.8182C43.6903 95.7313 43.5184 95.5894 43.3998 95.4104C43.2812 95.2313 43.221 95.0232 43.227 94.8119C43.2767 94.5757 43.3849 94.354 43.5426 94.1651C43.7003 93.9762 43.9031 93.8253 44.1343 93.7249Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.0851 104.096L43.9359 95.7613C43.0236 95.2629 43.1389 94.3942 44.1916 93.8152L57.4859 88.9737C58.0259 88.6922 58.6279 88.5336 59.2439 88.5105C59.86 88.4874 60.4732 88.6005 61.0351 88.8408L71.2163 94.4892C72.1287 94.9876 72.0134 95.8562 70.9607 96.4353L62.6291 103.958C62.0907 104.242 61.4898 104.402 60.8744 104.426C60.2589 104.45 59.6462 104.337 59.0851 104.096Z",
    fill: "black"
  }))), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M59.086 104.077L43.9369 95.7421C43.7656 95.6678 43.6182 95.5518 43.5099 95.4058C43.4015 95.2598 43.3361 95.0892 43.3203 94.9114V93.8293C43.3203 93.4495 43.6211 94.1093 44.1926 93.796L57.4868 88.9546C58.0281 88.6696 58.6323 88.5083 59.2511 88.4836C59.87 88.4588 60.4863 88.5714 61.0511 88.8122L71.2323 94.4653C71.5381 94.6314 71.7336 93.9242 71.8339 94.1473C71.8639 94.2232 71.8339 95.2152 71.8339 95.2912C71.8062 95.5343 71.7109 95.7661 71.5576 95.9629C71.4044 96.1597 71.1987 96.3145 70.9616 96.4114L62.6301 103.935C62.0921 104.219 61.4914 104.38 60.8759 104.404C60.2605 104.429 59.6475 104.317 59.086 104.077Z",
    fill: "url(#paint39_linear_2164_2451)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M59.0851 103.014L43.9359 94.6788C43.0236 94.2042 43.1389 93.3071 44.1916 92.7328L57.4859 87.8913C58.0268 87.6053 58.631 87.4433 59.2501 87.4186C59.8691 87.3939 60.4857 87.507 61.0501 87.7489L71.2314 93.3973C72.1437 93.9004 72.0284 94.769 70.9757 95.3434L62.6442 102.871C62.1039 103.157 61.5005 103.318 60.8824 103.343C60.2644 103.368 59.6489 103.255 59.0851 103.014Z",
    fill: "url(#paint40_linear_2164_2451)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M71.8409 95.7659C71.8108 96.0053 71.7149 96.233 71.5627 96.4262C71.4105 96.6195 71.2074 96.7715 70.9737 96.8671L62.6421 104.395C62.1014 104.68 61.4978 104.84 60.8798 104.864C60.2617 104.888 59.6464 104.775 59.083 104.533L43.9339 96.2026C43.7487 96.1243 43.592 95.9961 43.4833 95.8341C43.3745 95.672 43.3185 95.4832 43.3223 95.2913C43.3196 95.3118 43.3196 95.3324 43.3223 95.3529V96.4352C43.3381 96.6129 43.4035 96.7836 43.5119 96.9295C43.6202 97.0755 43.7676 97.1915 43.9389 97.2658L59.088 105.596C59.6511 105.839 60.2666 105.953 60.8849 105.929C61.5032 105.905 62.1069 105.744 62.6472 105.458L70.9787 97.9303C71.2157 97.8346 71.4214 97.6808 71.5747 97.4848C71.728 97.2887 71.8234 97.0574 71.8509 96.8149C71.8409 96.7484 71.8559 96.0365 71.8409 95.7659Z",
    fill: "url(#paint41_linear_2164_2451)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.82,
    d: "M71.2312 93.3974L61.0349 87.749C60.4705 87.5067 59.8539 87.3934 59.2348 87.4181C58.6157 87.4429 58.0114 87.605 57.4706 87.8914L50.7734 90.3311C50.838 90.3807 50.9067 90.4252 50.9789 90.464L66.148 98.8084C66.3754 98.9278 66.6204 99.0141 66.8749 99.0647L70.9755 95.3529C72.0282 94.7691 72.1435 93.9005 71.2312 93.3974Z",
    fill: "url(#paint42_linear_2164_2451)"
  }), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M70.9747 95.1631L62.6432 102.691C62.1029 102.976 61.4995 103.138 60.8814 103.163C60.2634 103.187 59.6478 103.075 59.0841 102.833L43.9349 94.4986C43.7759 94.4267 43.6375 94.3198 43.531 94.1869C43.4246 94.0539 43.3534 93.8987 43.3234 93.7344C43.3069 93.9334 43.3572 94.1323 43.467 94.3027C43.5768 94.4731 43.7405 94.6064 43.9349 94.6837L59.0841 103.019C59.6478 103.26 60.2634 103.372 60.8814 103.348C61.4995 103.323 62.1029 103.161 62.6432 102.876L70.9747 95.3482C71.5913 95.0112 71.882 94.5745 71.8369 94.171C71.7832 94.3879 71.6774 94.5902 71.5279 94.7622C71.3784 94.9343 71.1891 95.0714 70.9747 95.1631Z",
    fill: "white"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M78.8814 103.08L41.6705 82.7225C39.7706 81.683 38.2266 78.892 38.2266 76.4903V49.5206C38.2266 47.1188 39.7706 46.0129 41.6705 47.0524L78.8814 67.415C80.7863 68.4544 82.3252 71.2454 82.3252 73.6471V100.593C82.3252 102.995 80.7863 104.096 78.8814 103.08Z",
    fill: "url(#paint43_linear_2164_2451)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M79.3234 101.182L42.6339 81.1134C41.8513 80.5897 41.2162 79.8922 40.7845 79.082C40.3528 78.2719 40.1375 77.3739 40.1575 76.4666V49.345C40.1609 49.2451 40.1917 49.1477 40.247 49.0625C40.3023 48.9774 40.3802 48.9073 40.4729 48.8594C40.5656 48.8114 40.6698 48.7872 40.7753 48.7892C40.8809 48.7911 40.9842 48.8191 41.0748 48.8703L41.1851 48.9273L77.9097 69.0241C79.7344 70.0161 80.3862 71.7865 80.3862 73.6709V100.726C80.3886 100.838 80.3591 100.948 80.3008 101.046C80.2425 101.143 80.1574 101.224 80.0548 101.279C79.9521 101.334 79.8356 101.362 79.7175 101.36C79.5994 101.358 79.484 101.326 79.3836 101.267L79.3234 101.182Z",
    fill: "url(#paint44_linear_2164_2451)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M77.9097 69.0002L41.1851 48.9034L41.0748 48.8464C40.9842 48.7951 40.8809 48.7672 40.7753 48.7652C40.6698 48.7633 40.5656 48.7875 40.4729 48.8355C40.3802 48.8834 40.3023 48.9534 40.247 49.0386C40.1917 49.1238 40.1609 49.2211 40.1575 49.3211V76.4427C40.1375 77.3499 40.3528 78.248 40.7845 79.0581C41.2162 79.8683 41.8513 80.5658 42.6339 81.0895L79.3234 101.182L79.4036 101.224C79.504 101.283 79.6194 101.315 79.7376 101.317C79.8557 101.32 79.9722 101.291 80.0749 101.236C80.1775 101.181 80.2624 101.1 80.3207 101.003C80.3791 100.905 80.4086 100.795 80.4062 100.683V73.6517C80.3861 71.7531 79.7344 69.9922 77.9097 69.0002ZM80.0002 100.683C80.0002 100.752 79.9718 100.817 79.9211 100.866C79.8705 100.915 79.8017 100.943 79.7295 100.944C79.6817 100.943 79.6351 100.93 79.5941 100.906L42.8293 80.7952C42.1038 80.3054 41.5161 79.6547 41.1176 78.9001C40.7192 78.1455 40.522 77.3099 40.5434 76.4664V49.3448C40.5434 49.2881 40.5672 49.2338 40.6095 49.1938C40.6518 49.1537 40.7093 49.1312 40.7691 49.1312C40.8079 49.1311 40.846 49.141 40.8794 49.1597L77.7193 69.3182C79.6042 70.3482 80.0002 72.2373 80.0002 73.647V100.683Z",
    fill: "#BCBEC0"
  }))), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M42.647 46.5636C42.3571 46.3761 42.0259 46.2534 41.6785 46.2049C41.3311 46.1564 40.9767 46.1833 40.6419 46.2836C40.5667 46.2836 39.6092 46.7914 39.5391 46.8294C39.8871 46.6943 40.2654 46.6439 40.6393 46.6829C41.0132 46.7218 41.3708 46.8489 41.6795 47.0525L78.8905 67.4151C80.7954 68.4546 82.3343 71.2455 82.3343 73.6472V100.593C82.3343 102.093 81.7378 103.085 80.8304 103.365C80.9382 103.362 81.0427 103.329 81.1312 103.27C81.1764 103.27 82.2191 102.691 82.2592 102.663C82.9158 102.226 83.3218 101.334 83.3218 100.1V73.1773C83.3218 70.7756 81.7779 67.9846 79.878 66.9452",
    fill: "url(#paint45_linear_2164_2451)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M79.044 67.3342L41.8331 46.9764C41.5335 46.7807 41.1888 46.6557 40.8277 46.612C40.4667 46.5682 40.0998 46.6069 39.7578 46.7248C40.3413 46.6597 40.9302 46.7907 41.422 47.095L78.633 67.4528C80.5329 68.4923 82.0768 71.2833 82.0768 73.685V100.631C82.0768 102.055 81.5355 103.004 80.7083 103.346C81.7711 103.189 82.4879 102.155 82.4879 100.498V73.5664C82.4879 71.1646 80.9489 68.3737 79.044 67.3342Z",
    fill: "url(#paint46_radial_2164_2451)"
  }), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.09,
    d: "M43.3792 88.1334C43.4694 88.0859 43.5846 88.0337 43.6849 87.991C44.1681 87.7944 44.6879 87.6911 45.2139 87.6872C45.7359 87.6731 46.2532 87.7841 46.7177 88.01C46.7177 88.01 47.585 88.4846 47.6 88.4846L55.0342 92.5524L55.8412 92.9938C56.0934 93.1183 56.3084 93.301 56.4661 93.525C56.6239 93.749 56.7192 94.0071 56.7436 94.2754C56.7477 94.5702 56.668 94.8606 56.5128 95.1162C56.3575 95.3717 56.1325 95.583 55.8613 95.7278L53.2496 98.1438C53.3097 98.177 51.1692 99.9902 51.099 100.042C51.0288 100.095 50.8936 100.142 50.7933 100.185C50.3099 100.381 49.7902 100.484 49.2643 100.489C48.7423 100.503 48.2248 100.392 47.7605 100.166C47.7605 100.166 46.8932 99.6912 46.8782 99.6912L39.444 95.6234L38.637 95.182C38.3842 95.0582 38.1688 94.8757 38.011 94.6516C37.8531 94.4274 37.758 94.1689 37.7346 93.9004C37.7294 93.6054 37.8086 93.3146 37.964 93.0589C38.1193 92.8031 38.345 92.592 38.6169 92.448L41.2236 90.032C41.1684 89.9846 43.309 88.1714 43.3792 88.1334Z",
    fill: "#25054D"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.18,
    d: "M42.9253 88.6081C43.0055 88.5654 43.1308 88.5132 43.2211 88.4752C43.6838 88.28 44.1833 88.175 44.6898 88.1667C45.1956 88.152 45.6978 88.2529 46.1537 88.461C46.1938 88.461 46.9758 88.8882 47.0109 88.9071L54.1744 92.823L54.9464 93.2502C55.1875 93.3682 55.3958 93.5385 55.5544 93.7472C55.7129 93.9559 55.8171 94.197 55.8586 94.4511C55.8862 94.7165 55.8369 94.9841 55.7159 95.2249C55.5949 95.4658 55.4068 95.6709 55.1719 95.8181L53.0414 98.1154C53.1617 98.1771 51.2217 99.8716 51.0863 99.9476C50.9886 99.9982 50.8882 100.044 50.7856 100.085C50.322 100.277 49.8227 100.38 49.3167 100.389C48.8121 100.408 48.3105 100.307 47.858 100.095C47.8129 100.095 47.0309 99.6675 47.0008 99.6533L39.8323 95.7326L39.0603 95.3102C38.8188 95.1914 38.6104 95.0203 38.4518 94.8108C38.2933 94.6013 38.1892 94.3594 38.1481 94.1046C38.1204 93.8386 38.1703 93.5706 38.2922 93.3295C38.4142 93.0885 38.6035 92.8838 38.8398 92.7376L40.9653 90.445C40.85 90.3786 42.7849 88.6841 42.9253 88.6081Z",
    fill: "#25054D"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.27,
    d: "M42.4882 89.0828C42.5634 89.0448 42.6988 88.9926 42.779 88.9594C43.2221 88.7686 43.701 88.6637 44.1876 88.6508C44.6741 88.6293 45.1589 88.7189 45.6012 88.9119C45.6614 88.9119 46.3833 89.3011 46.4284 89.3296L53.3212 93.0983L54.0681 93.5066C54.2971 93.6215 54.4972 93.782 54.6547 93.9769C54.8122 94.1719 54.9232 94.3968 54.9804 94.6362C54.9804 95.0729 54.9804 95.6425 54.4791 95.9178L52.8298 98.0869C53.0103 98.1866 51.2759 99.7625 51.0704 99.8764C51.0002 99.9143 50.8598 99.9666 50.7846 99.9998C50.3398 100.191 49.8591 100.295 49.371 100.308C48.886 100.33 48.4027 100.241 47.9623 100.047C47.9021 100.047 47.1803 99.6533 47.1302 99.6295L40.2374 95.8608L39.4955 95.4526C39.2654 95.3384 39.0641 95.1783 38.9058 94.9832C38.7474 94.7882 38.6355 94.5629 38.5781 94.3229C38.5781 93.8863 38.5781 93.3167 39.0794 93.0414L40.7287 90.8722C40.5382 90.7726 42.2677 89.1967 42.4882 89.0828Z",
    fill: "#25054D"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.36,
    d: "M42.0195 89.5575C42.0847 89.5243 42.23 89.4721 42.3001 89.4389C42.725 89.257 43.1828 89.1539 43.6487 89.1351C44.1141 89.1103 44.5791 89.1883 45.0072 89.3629C45.0924 89.3629 45.749 89.7189 45.8142 89.7521L52.4364 93.3737L53.1482 93.7677C53.5091 93.9623 54.0706 94.4702 54.0706 94.8167C54.0706 95.1632 54.2109 95.766 53.7748 96.0128L52.6067 98.0633C52.8423 98.1962 51.3185 99.6534 51.0428 99.8005C50.9515 99.8449 50.8578 99.8845 50.762 99.9192C50.338 100.103 49.8798 100.207 49.4136 100.223C48.9464 100.25 48.4792 100.172 48.0501 99.9951C47.9699 99.9951 47.3131 99.6439 47.2479 99.6059L40.6259 95.9843L39.9141 95.5951C39.5532 95.3958 38.9917 94.8926 38.9917 94.5414C38.9917 94.1901 38.8463 93.5921 39.2875 93.3453L40.4554 91.2948C40.2198 91.1666 41.7438 89.7094 42.0195 89.5575Z",
    fill: "#25054D"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.45,
    d: "M41.5687 90.0321C41.6188 90.0036 41.7792 89.9467 41.8394 89.9229C42.2461 89.7444 42.6851 89.6413 43.1328 89.6191C43.5772 89.5896 44.0228 89.6561 44.4361 89.8137C44.7032 89.9193 44.9628 90.0414 45.2131 90.1792L51.5645 93.6537L52.2462 94.0239C52.557 94.1948 53.1737 94.7026 53.1737 95.0017C53.1737 95.3007 53.4543 95.9083 53.0783 96.1124L52.3866 98.0395C52.6824 98.2008 51.384 99.5394 51.0231 99.7292C50.968 99.7577 50.8075 99.8099 50.7524 99.8384C50.3451 100.015 49.9064 100.118 49.459 100.142C49.013 100.172 48.5657 100.105 48.1507 99.9476C47.8835 99.842 47.6239 99.7199 47.3737 99.5821L41.0223 96.1076L40.3405 95.7374C40.0297 95.5665 39.4132 95.0586 39.4132 94.7596C39.4132 94.4606 39.1325 93.853 39.5084 93.6489L40.2002 91.7218C39.9044 91.5605 41.2228 90.2219 41.5687 90.0321Z",
    fill: "#25054D"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.55,
    d: "M41.1141 90.5069C41.1592 90.5069 41.3297 90.4262 41.3798 90.4072C41.7673 90.2333 42.1853 90.1287 42.613 90.0987C43.0385 90.068 43.466 90.1246 43.8662 90.2648C44.126 90.3579 44.3774 90.4706 44.6181 90.6018L50.6988 93.9244L51.3454 94.2756C51.6061 94.418 52.2829 94.9306 52.2829 95.1822C52.2829 95.4338 52.694 96.0318 52.3832 96.2027L52.1676 98.0111C52.5286 98.2057 51.4157 99.4351 50.9996 99.6487C50.9545 99.6724 50.789 99.7294 50.7389 99.7531C50.3503 99.9233 49.9327 100.026 49.5057 100.057C49.0785 100.09 48.6489 100.033 48.2475 99.8908C47.9895 99.7993 47.7397 99.6882 47.5006 99.5585L41.42 96.2359L40.7683 95.88C40.5076 95.7376 39.8358 95.2249 39.8358 94.9781C39.8358 94.7313 39.4198 94.1237 39.7356 93.9529L39.9461 92.1492C39.5902 91.9546 40.7031 90.7395 41.1141 90.5069Z",
    fill: "#25054D"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.64,
    d: "M40.6648 90.9813C40.6999 90.9813 40.8803 90.9054 40.9154 90.8864C41.2865 90.7212 41.6851 90.6184 42.0934 90.5826C42.4998 90.547 42.9097 90.5923 43.2966 90.7155C43.5471 90.7961 43.7888 90.8994 44.0184 91.024L49.8283 94.2042L50.4499 94.5412C50.6554 94.6551 51.3874 95.1677 51.3874 95.3671C51.3874 95.5664 51.9338 96.1692 51.6882 96.3164L51.9538 98.0014C52.3698 98.2245 51.4525 99.3257 50.9813 99.5915C50.9462 99.5915 50.7657 99.6674 50.7256 99.6817C50.3577 99.8511 49.9602 99.9557 49.5527 99.9902C49.1463 100.024 48.7369 99.9784 48.3495 99.8573C48.099 99.7767 47.8572 99.6734 47.6277 99.5488L41.8177 96.3686L41.1961 96.0316C40.9905 95.9177 40.2587 95.405 40.2587 95.2057C40.2587 95.0063 39.7072 94.4035 39.9579 94.2564L39.6922 92.5714C39.2761 92.3435 40.1835 91.2471 40.6648 90.9813Z",
    fill: "#25054D"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.73,
    d: "M40.2134 91.456C40.2385 91.456 40.4289 91.3848 40.454 91.3706C40.8059 91.2105 41.1839 91.1078 41.5719 91.0668C41.9594 91.026 42.3516 91.0599 42.7249 91.1665C42.9665 91.2375 43.2 91.3313 43.4217 91.4465L48.936 94.4796L49.5224 94.7976C49.6778 94.883 50.4698 95.4004 50.4698 95.5523C50.4698 95.7042 51.1516 96.3022 50.9711 96.4019L51.718 97.9635C52.1943 98.2245 51.4925 99.2071 50.9461 99.5061L50.7004 99.5916C50.3505 99.7566 49.9716 99.8595 49.5825 99.8953C49.1953 99.9347 48.8039 99.9024 48.4296 99.8004C48.1871 99.7298 47.9534 99.6343 47.7328 99.5156L42.2186 96.4873L41.6321 96.1646C41.4767 96.0791 40.6896 95.5618 40.6896 95.4099C40.6896 95.258 40.0028 94.6647 40.1883 94.5602L39.4414 92.9986C38.9802 92.7376 39.662 91.7551 40.2134 91.456Z",
    fill: "#25054D"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.82,
    d: "M39.7582 91.9308L39.9938 91.8549C40.3255 91.6971 40.6832 91.5944 41.0515 91.5511C41.4202 91.5076 41.7945 91.5301 42.1544 91.6175C42.3884 91.6727 42.6127 91.759 42.8211 91.8739L48.0896 94.755L48.6461 95.0588C48.9921 95.2449 49.312 95.4714 49.5985 95.7328C49.5985 95.8467 50.4157 96.4305 50.2904 96.5017L51.5185 97.9257C52.0499 98.22 51.5587 99.0791 50.9371 99.4208L50.7013 99.4968C50.3691 99.6531 50.0117 99.7557 49.6437 99.8006C49.2749 99.844 48.9009 99.8214 48.5409 99.7341C48.308 99.676 48.0839 99.5898 47.8741 99.4778L42.6055 96.5967L42.0492 96.2929C41.7046 96.1051 41.3862 95.8771 41.1017 95.6141C41.1017 95.505 40.2846 94.9164 40.4049 94.8499L39.1817 93.426C38.6453 93.1127 39.1416 92.2678 39.7582 91.9308Z",
    fill: "#25054D"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.91,
    d: "M39.3016 92.4053L39.5273 92.3389C39.8417 92.1854 40.1803 92.0812 40.5299 92.0303C40.8787 91.9848 41.2333 91.9977 41.5775 92.0683C41.8023 92.1131 42.0187 92.1899 42.2191 92.2961L47.2321 95.0301L47.7334 95.3149C48.0646 95.4982 48.3842 95.6994 48.6908 95.9177C48.6908 95.9747 49.6382 96.5633 49.5781 96.5965L51.2825 97.916C51.8791 98.2388 51.5883 98.984 50.9016 99.34L50.676 99.4112C50.3614 99.5631 50.0228 99.6657 49.6734 99.7149C49.3248 99.7615 48.9702 99.7503 48.6257 99.6817C48.4006 99.6354 48.1842 99.557 47.984 99.4491L42.9711 96.7199L42.4848 96.4351C42.1525 96.2535 41.8328 96.0522 41.5274 95.8323C41.5274 95.7801 40.58 95.1868 40.6401 95.1535L38.9357 93.834C38.3241 93.5255 38.6148 92.7803 39.3016 92.4053Z",
    fill: "#25054D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.1158 99.4492L43.3887 96.8623L38.6614 94.2755C38.0047 93.9195 38.09 93.293 38.8419 92.88L39.0625 92.8183C39.451 92.6143 39.8845 92.4991 40.3283 92.4818C40.7722 92.4645 41.2142 92.5456 41.6191 92.7186L46.3412 95.3055L51.0684 97.8923C51.7251 98.2483 51.645 98.8749 50.888 99.2878L50.6675 99.3495C50.2798 99.5534 49.8471 99.6686 49.4041 99.6859C48.961 99.7033 48.5199 99.6222 48.1158 99.4492Z",
    fill: "#25054D"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.09,
    d: "M21.4312 88.2568C22.2764 87.8166 23.2288 87.594 24.1933 87.6113C24.5733 87.6154 24.9517 87.66 25.3212 87.7442C25.7157 87.8336 26.0952 87.9742 26.4491 88.1619L50.5111 101.31C50.8874 101.491 51.2011 101.771 51.4152 102.116C51.6292 102.461 51.7347 102.856 51.7192 103.256C51.7014 103.475 51.6509 103.691 51.5689 103.897C51.2555 104.541 50.7271 105.07 50.065 105.401L36.5651 112.787C36.3947 112.877 36.1692 112.981 35.9837 113.057C35.304 113.32 34.5773 113.457 33.8432 113.461C33.059 113.48 32.2832 113.305 31.5924 112.953L7.4552 99.7576C7.07821 99.5759 6.76433 99.2954 6.55102 98.9495C6.33771 98.6037 6.23388 98.207 6.25203 97.8068C6.26939 97.6179 6.30975 97.4316 6.37234 97.2515C6.66606 96.5713 7.19676 96.0069 7.87621 95.6519L21.4312 88.2568Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.18,
    d: "M21.4842 88.3659C22.6666 87.7511 24.0505 87.5816 25.3592 87.8912C25.747 87.995 26.1205 88.1415 26.472 88.3279L50.4238 101.419C50.7921 101.59 51.0962 101.863 51.2952 102.203C51.4942 102.542 51.5784 102.931 51.5367 103.317C51.5036 103.528 51.4412 103.734 51.3511 103.93C51.0041 104.537 50.4827 105.039 49.8472 105.377L36.533 112.654C36.3477 112.753 36.1568 112.844 35.9615 112.924C35.2939 113.187 34.5791 113.326 33.8561 113.333C33.0863 113.362 32.322 113.198 31.6404 112.858L7.50813 99.6626C7.13559 99.4885 6.82941 99.2091 6.63185 98.863C6.43429 98.5169 6.35512 98.1213 6.40531 97.7308C6.43597 97.5507 6.4864 97.3741 6.55573 97.2039C6.89438 96.5581 7.43059 96.0238 8.0946 95.6708L21.4842 88.3659Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.27,
    d: "M21.5406 88.4562C22.3804 88.0196 23.3305 87.8095 24.2877 87.8486C24.6623 87.865 25.0338 87.9208 25.3955 88.0148C25.7781 88.1278 26.1477 88.2773 26.4984 88.4609L50.3599 101.504C50.724 101.673 51.0194 101.95 51.2007 102.293C51.3819 102.636 51.4387 103.026 51.3624 103.403C51.3139 103.605 51.2417 103.8 51.1469 103.987C50.7708 104.557 50.2549 105.032 49.643 105.373L36.5243 112.545C36.3889 112.616 36.1132 112.754 35.9628 112.815C35.3072 113.079 34.6045 113.221 33.8925 113.233C33.1322 113.263 32.3774 113.099 31.7068 112.758L7.57466 99.5631C7.21053 99.3948 6.91496 99.1176 6.73375 98.7745C6.55254 98.4313 6.49579 98.0412 6.57208 97.6644C6.62042 97.4925 6.68235 97.3244 6.75749 97.1613C7.13767 96.5525 7.67616 96.0459 8.32158 95.6899L21.5406 88.4562Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.36,
    d: "M21.6038 88.5558C22.4415 88.1243 23.3883 87.919 24.3408 87.9625C24.7148 87.9865 25.0847 88.0502 25.4436 88.1523C25.82 88.2805 26.1839 88.4394 26.5314 88.627L50.3027 101.623C50.6621 101.784 50.9504 102.06 51.1179 102.401C51.2855 102.743 51.3216 103.129 51.22 103.493C51.1518 103.683 51.0662 103.868 50.9643 104.044C50.563 104.577 50.0514 105.028 49.4605 105.368L36.5323 112.436C36.417 112.502 36.1161 112.649 35.9858 112.706C35.3415 112.968 34.6512 113.113 33.9505 113.133C33.2001 113.16 32.4558 112.996 31.7949 112.659L7.6628 99.4633C7.29805 99.3009 7.00685 99.0199 6.84221 98.6716C6.67756 98.3232 6.65036 97.9305 6.76547 97.5647C6.82773 97.4027 6.89967 97.2443 6.98099 97.09C7.39827 96.5126 7.94204 96.0269 8.57519 95.6661L21.6038 88.5558Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.45,
    d: "M21.6599 88.6556C22.4938 88.2251 23.439 88.026 24.3869 88.0813C24.7596 88.1117 25.1277 88.1802 25.4849 88.2854C25.855 88.4206 26.215 88.5791 26.5626 88.7601L50.2386 101.704C50.5937 101.858 50.8748 102.133 51.0262 102.474C51.1775 102.815 51.1881 103.197 51.0558 103.545C50.9745 103.726 50.879 103.901 50.77 104.068C50.332 104.567 49.8104 104.995 49.226 105.335L36.4932 112.293C36.393 112.35 36.0671 112.516 35.9518 112.559C35.32 112.828 34.6388 112.976 33.9466 112.996C33.2093 113.037 32.4742 112.886 31.8211 112.559L7.689 99.3638C7.33005 99.2078 7.0478 98.9274 6.90047 98.5805C6.75314 98.2335 6.75191 97.8462 6.89692 97.4984C6.95708 97.3465 7.06234 97.2088 7.14255 97.0237C7.59513 96.4897 8.14316 96.0351 8.76171 95.6805L21.6599 88.6556Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.55,
    d: "M21.7209 88.7552C22.5532 88.3269 23.498 88.1341 24.4428 88.1998C24.8113 88.2363 25.1744 88.3111 25.5256 88.4229C25.8911 88.5611 26.2477 88.7196 26.5934 88.8976L50.1541 101.794C50.3282 101.868 50.485 101.973 50.6155 102.105C50.746 102.237 50.8476 102.392 50.9143 102.561C50.981 102.73 51.0115 102.91 51.0041 103.09C50.9967 103.271 50.9514 103.448 50.8709 103.612C50.7888 103.784 50.6808 103.944 50.5502 104.086C50.4549 104.362 49.327 105.102 48.9911 105.287L36.4588 112.141C36.3736 112.189 36.0176 112.369 35.9274 112.407C35.3084 112.673 34.6414 112.824 33.9624 112.853C33.238 112.894 32.5156 112.748 31.872 112.431L7.75983 99.2829C7.58335 99.2087 7.42466 99.1013 7.29342 98.9671C7.16218 98.833 7.0611 98.675 6.99639 98.5027C6.93168 98.3305 6.90465 98.1475 6.91696 97.965C6.92927 97.7826 6.98076 97.6044 7.06811 97.4413C7.14398 97.2891 7.23809 97.1458 7.34874 97.0141C7.43396 96.7198 8.64208 95.9224 8.99299 95.7326L21.7209 88.7552Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.64,
    d: "M21.7794 88.8406C22.6078 88.4127 23.5514 88.2261 24.4914 88.3043C24.8593 88.3457 25.2208 88.427 25.5692 88.5463C25.7196 88.5891 26.5016 88.9735 26.6219 89.021L50.1174 101.87C50.2896 101.941 50.444 102.046 50.5705 102.177C50.697 102.309 50.7927 102.464 50.8514 102.633C50.9101 102.802 50.9303 102.98 50.911 103.157C50.8916 103.334 50.833 103.505 50.739 103.659C50.6451 103.833 50.5253 103.993 50.3831 104.134C50.3029 104.357 49.0748 105.126 48.8041 105.273L36.4673 112.046C36.4021 112.084 36.0211 112.284 35.966 112.312C35.3605 112.585 34.7053 112.746 34.0359 112.787C33.3227 112.832 32.6101 112.69 31.9757 112.379L7.84343 99.1833C7.66768 99.1121 7.51046 99.0054 7.38277 98.8707C7.25508 98.7359 7.16008 98.5765 7.10422 98.4033C7.04837 98.2302 7.03304 98.0477 7.05943 97.8684C7.08582 97.6891 7.15325 97.5174 7.25696 97.3654C7.34135 97.2185 7.44591 97.0829 7.56782 96.9619C7.638 96.7293 8.95632 95.8987 9.23704 95.7421L21.7794 88.8406Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.73,
    d: "M21.845 88.9545C22.6721 88.5291 23.6152 88.3489 24.5519 88.4372C24.917 88.4837 25.2753 88.5697 25.6197 88.6935C25.73 88.7314 26.5671 89.1681 26.6573 89.2061L50.0627 102.022C50.2324 102.092 50.3831 102.198 50.5039 102.331C50.6247 102.464 50.7123 102.621 50.7604 102.791C50.8085 102.96 50.8158 103.138 50.7818 103.31C50.7478 103.483 50.6734 103.646 50.564 103.787C50.4556 103.948 50.324 104.093 50.173 104.219C49.682 104.631 49.1477 104.993 48.5788 105.302L36.4275 111.947C36.3773 111.975 35.9713 112.189 35.9262 112.212C35.3348 112.486 34.6929 112.647 34.0363 112.687C33.3427 112.735 32.6486 112.601 32.0311 112.298L7.89898 99.0693C7.72233 99.0014 7.56487 98.8955 7.43893 98.76C7.313 98.6245 7.22212 98.4631 7.17348 98.2885C7.12484 98.114 7.11974 97.9311 7.15867 97.7544C7.19759 97.5777 7.27942 97.412 7.39769 97.2704C7.49396 97.1322 7.60848 97.0061 7.73853 96.8954C7.79367 96.7151 9.24248 95.8512 9.43798 95.7326L21.845 88.9545Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.82,
    d: "M21.9351 89.0496C22.758 88.6283 23.6971 88.4544 24.6271 88.5513C24.9901 88.6048 25.345 88.6988 25.6847 88.8313C25.7599 88.8313 26.6522 89.306 26.7124 89.3534L50.0074 102.098C50.178 102.165 50.3293 102.27 50.4485 102.403C50.5677 102.537 50.6513 102.695 50.6925 102.866C50.7338 103.036 50.7312 103.214 50.6853 103.383C50.6394 103.553 50.5514 103.709 50.4286 103.84C50.3065 103.99 50.165 104.126 50.0074 104.243C49.4951 104.619 48.9558 104.96 48.3933 105.264L36.4374 111.804L35.9361 112.066C35.356 112.335 34.7262 112.497 34.0814 112.54C33.389 112.598 32.6936 112.467 32.0762 112.165L7.93904 98.9746C7.76433 98.9056 7.61006 98.7972 7.48988 98.6587C7.36971 98.5203 7.28724 98.356 7.24964 98.1804C7.21204 98.0047 7.22048 97.823 7.27424 97.6512C7.328 97.4793 7.42549 97.3226 7.55805 97.1947C7.66948 97.0664 7.79557 96.9502 7.93402 96.8482C8.48133 96.4453 9.0575 96.079 9.65844 95.7517L21.9351 89.0496Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.91,
    d: "M21.9681 89.1492C22.7903 88.7317 23.729 88.5659 24.6549 88.6745C25.0155 88.7342 25.3673 88.8346 25.7027 88.9736C25.7378 88.9736 26.7052 89.4909 26.7052 89.5099L49.9301 102.202C50.1002 102.267 50.25 102.373 50.3656 102.507C50.4812 102.642 50.5589 102.803 50.5914 102.974C50.6239 103.145 50.6101 103.321 50.5515 103.486C50.4928 103.65 50.3912 103.798 50.2559 103.916C50.1207 104.06 49.9656 104.186 49.7948 104.291C49.7948 104.348 48.2358 105.24 48.1706 105.24L36.4003 111.676L35.899 111.937C35.3281 112.204 34.7088 112.365 34.0742 112.412C33.3985 112.47 32.7191 112.347 32.1142 112.056L7.97693 98.8605C7.8013 98.7933 7.6473 98.6838 7.5301 98.5429C7.41289 98.402 7.33656 98.2345 7.3087 98.0571C7.28085 97.8797 7.30239 97.6984 7.37124 97.5313C7.44009 97.3642 7.55394 97.217 7.70131 97.1043C7.82205 96.9813 7.95835 96.8728 8.10727 96.7816C8.10727 96.7199 9.78659 95.7848 9.85677 95.7468L21.9681 89.1492Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.2018 111.966L8.06469 98.7704C7.11223 98.2483 7.23256 97.3465 8.33039 96.7389L22.0306 89.2489C22.5947 88.9516 23.2244 88.7834 23.8695 88.7578C24.5145 88.7323 25.1569 88.8501 25.7453 89.1018L49.8824 102.297C50.8349 102.819 50.7146 103.721 49.6167 104.329L35.9164 111.819C35.3523 112.116 34.7226 112.284 34.0775 112.31C33.4325 112.335 32.7902 112.217 32.2018 111.966Z",
    fill: "black"
  }))), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2007 111.942L8.06354 98.7514C7.88476 98.6737 7.73108 98.5522 7.6183 98.3995C7.50553 98.2469 7.43773 98.0685 7.42188 97.8828V96.7484C7.42188 96.3544 7.73772 97.0427 8.32924 96.7152L22.0295 89.2299C22.593 88.9311 23.2229 88.7621 23.8682 88.7366C24.5135 88.711 25.1562 88.8296 25.7441 89.0828L49.8813 102.278C50.2021 102.449 50.4327 101.713 50.5129 101.946C50.5129 102.027 50.5129 103.061 50.5129 103.142C50.486 103.396 50.3875 103.638 50.2279 103.843C50.0683 104.049 49.8533 104.21 49.6055 104.31L35.9053 111.8C35.3423 112.095 34.714 112.262 34.0708 112.286C33.4276 112.311 32.7872 112.193 32.2007 111.942Z",
    fill: "url(#paint47_linear_2164_2451)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2018 110.831L8.06469 97.6359C7.11223 97.1185 7.23256 96.2119 8.33039 95.6043L22.0306 88.1191C22.5942 87.8203 23.224 87.6513 23.8693 87.6257C24.5146 87.6002 25.1573 87.7187 25.7453 87.9719L49.8824 101.167C50.8349 101.685 50.7146 102.591 49.6167 103.199L35.9164 110.675C35.3536 110.975 34.7242 111.145 34.0789 111.173C33.4336 111.2 32.7905 111.083 32.2018 110.831Z",
    fill: "url(#paint48_linear_2164_2451)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M50.5045 103.749C50.4741 104 50.3741 104.238 50.2147 104.44C50.0553 104.642 49.8422 104.8 49.5971 104.898L35.8969 112.388C35.3328 112.685 34.7031 112.854 34.058 112.879C33.413 112.905 32.7706 112.787 32.1822 112.535L8.04507 99.3399C7.85202 99.2586 7.68861 99.1252 7.57535 98.9563C7.4621 98.7874 7.40402 98.5906 7.40842 98.3906C7.40553 98.4111 7.40553 98.4319 7.40842 98.4523V99.582C7.42376 99.7678 7.49141 99.9464 7.60424 100.099C7.71707 100.252 7.87099 100.373 8.05009 100.451L32.1873 113.646C32.7752 113.899 33.4177 114.018 34.0631 113.992C34.7084 113.967 35.3384 113.798 35.9019 113.499L49.6021 106.009C49.8492 105.909 50.0637 105.749 50.2232 105.545C50.3828 105.34 50.4817 105.099 50.5095 104.846C50.5045 104.775 50.5295 104.029 50.5045 103.749Z",
    fill: "url(#paint49_linear_2164_2451)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M33.818 110.727C33.3417 110.742 32.8692 110.642 32.4445 110.437L8.30731 97.2421C8.15692 97.1614 7.90625 96.9905 7.90625 96.7674C7.90625 96.5443 8.15694 96.2453 8.57301 96.0127L22.2732 88.5275C22.8433 88.2333 23.4838 88.0829 24.133 88.0908C24.6093 88.0761 25.0819 88.1757 25.5067 88.3803L49.6438 101.576C49.7942 101.656 50.0449 101.832 50.0449 102.05C50.0449 102.269 49.7942 102.572 49.3781 102.805L35.6778 110.29C35.1077 110.584 34.4672 110.735 33.818 110.727Z",
    fill: "url(#paint50_linear_2164_2451)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M49.6128 103.009L35.9124 110.499C35.3481 110.796 34.7182 110.964 34.0731 110.988C33.428 111.013 32.7857 110.894 32.1979 110.641L8.06072 97.4508C7.89459 97.3751 7.74999 97.2627 7.63922 97.1231C7.52844 96.9836 7.4547 96.8208 7.42406 96.6487C7.41004 96.8553 7.46361 97.0609 7.57754 97.2376C7.69147 97.4143 7.86023 97.5534 8.06072 97.636L32.1979 110.831C32.7858 111.084 33.4284 111.203 34.0737 111.177C34.719 111.152 35.3489 110.983 35.9124 110.684L49.6128 103.199C50.2544 102.848 50.5602 102.387 50.5151 101.965C50.4577 102.192 50.3467 102.404 50.1904 102.585C50.0341 102.766 49.8367 102.911 49.6128 103.009Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M27.183 91.01C27.8196 92.7662 25.7894 95.0256 22.6413 96.0508C19.4932 97.0761 16.4253 96.478 15.7886 94.7171C15.152 92.9561 17.1823 90.7015 20.3254 89.6763C23.4685 88.651 26.5414 89.2491 27.183 91.01Z",
    fill: "url(#paint51_radial_2164_2451)"
  }), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M36.4734 105.971L16.8729 95.258C16.4819 95.0444 16.5321 94.6695 16.9833 94.4226L24.3422 90.3976C24.5752 90.2751 24.8352 90.2058 25.1015 90.1951C25.3677 90.1844 25.633 90.2326 25.8762 90.3359L45.4967 101.054C45.8927 101.267 45.8426 101.642 45.3914 101.889L38.0225 105.928C37.7859 106.05 37.5224 106.117 37.2533 106.125C36.9842 106.132 36.717 106.079 36.4734 105.971Z",
    fill: "url(#paint52_linear_2164_2451)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.3,
    d: "M24.7834 91.1808L26.0366 91.869C26.1262 91.9113 26.2248 91.9332 26.3248 91.9332C26.4249 91.9332 26.5236 91.9113 26.6132 91.869C26.6474 91.8576 26.6769 91.8364 26.6979 91.8083C26.7188 91.7803 26.7302 91.7468 26.7302 91.7124C26.7302 91.678 26.7188 91.6445 26.6979 91.6165C26.6769 91.5884 26.6474 91.5672 26.6132 91.5558L25.3599 90.8675C25.2711 90.8231 25.1721 90.7998 25.0716 90.7998C24.9711 90.7998 24.8722 90.8231 24.7834 90.8675C24.7492 90.879 24.7195 90.9002 24.6986 90.9282C24.6776 90.9563 24.6664 90.9898 24.6664 91.0242C24.6664 91.0585 24.6776 91.092 24.6986 91.1201C24.7195 91.1481 24.7492 91.1693 24.7834 91.1808ZM26.9339 92.3579L27.5304 92.6807C27.6193 92.7252 27.7183 92.7484 27.8188 92.7484C27.9193 92.7484 28.0182 92.7252 28.107 92.6807C28.1412 92.6693 28.1709 92.648 28.1918 92.62C28.2128 92.5919 28.224 92.5584 28.224 92.5241C28.224 92.4897 28.2128 92.4562 28.1918 92.4281C28.1709 92.4001 28.1412 92.3789 28.107 92.3674L27.5154 92.0447C27.4253 92.0013 27.3258 91.9787 27.2247 91.9787C27.1237 91.9787 27.024 92.0013 26.9339 92.0447C26.7735 92.1301 26.7735 92.2677 26.944 92.3579H26.9339ZM28.4378 93.1696L29.0343 93.4971C29.1239 93.5393 29.2226 93.5613 29.3227 93.5613C29.4227 93.5613 29.5213 93.5393 29.6109 93.4971C29.6451 93.4857 29.6747 93.4644 29.6957 93.4364C29.7166 93.4083 29.7279 93.3748 29.7279 93.3405C29.7279 93.3061 29.7166 93.2726 29.6957 93.2445C29.6747 93.2165 29.6451 93.1953 29.6109 93.1838L29.0193 92.8563C28.9297 92.8141 28.8311 92.7921 28.7311 92.7921C28.631 92.7921 28.5324 92.8141 28.4428 92.8563C28.4088 92.8683 28.3795 92.8899 28.359 92.9182C28.3385 92.9466 28.3277 92.9803 28.3283 93.0146C28.3288 93.049 28.3406 93.0824 28.3621 93.1101C28.3835 93.1379 28.4134 93.1586 28.4479 93.1696H28.4378ZM29.9417 93.986L30.5382 94.3088C30.6274 94.3521 30.7263 94.3747 30.8265 94.3747C30.9268 94.3747 31.0256 94.3521 31.1148 94.3088C31.2702 94.2186 31.2702 94.0809 31.1148 93.9907L30.5231 93.668C30.4339 93.6247 30.3352 93.6021 30.2349 93.6021C30.1347 93.6021 30.0359 93.6247 29.9467 93.668C29.7512 93.7582 29.7512 93.8958 29.9116 93.986H29.9417ZM31.4456 94.7976L32.0421 95.1252C32.1316 95.1674 32.2304 95.1894 32.3304 95.1894C32.4304 95.1894 32.5291 95.1674 32.6186 95.1252C32.779 95.0397 32.774 94.8973 32.6186 94.8119L32.027 94.4844C31.9375 94.4422 31.8388 94.4202 31.7388 94.4202C31.6388 94.4202 31.5401 94.4422 31.4506 94.4844C31.4137 94.4899 31.3797 94.5063 31.3534 94.5313C31.3271 94.5564 31.3098 94.5887 31.3042 94.6236C31.2986 94.6585 31.305 94.6942 31.3223 94.7255C31.3396 94.7568 31.3669 94.7821 31.4004 94.7976H31.4456ZM32.9494 95.6141L33.546 95.9368C33.6351 95.9801 33.734 96.0027 33.8343 96.0027C33.9345 96.0027 34.0333 95.9801 34.1225 95.9368C34.2829 95.8466 34.2779 95.709 34.1225 95.6188L33.5259 95.296C33.4367 95.2527 33.3379 95.2301 33.2377 95.2301C33.1374 95.2301 33.0386 95.2527 32.9494 95.296C32.7289 95.3862 32.7289 95.5239 32.8894 95.6141H32.9494ZM34.4533 96.4257L35.0498 96.7532C35.1394 96.7954 35.2381 96.8174 35.3382 96.8174C35.4382 96.8174 35.5368 96.7954 35.6264 96.7532C35.6606 96.7418 35.6902 96.7206 35.7112 96.6925C35.7322 96.6645 35.7434 96.6309 35.7434 96.5966C35.7434 96.5622 35.7322 96.5287 35.7112 96.5006C35.6902 96.4726 35.6606 96.4514 35.6264 96.4399L35.0298 96.1124C34.9402 96.0702 34.8416 96.0482 34.7415 96.0482C34.6415 96.0482 34.5429 96.0702 34.4533 96.1124C34.4102 96.1077 34.3667 96.1183 34.3313 96.1422C34.2959 96.1661 34.2713 96.2015 34.2619 96.2417C34.2526 96.2818 34.2593 96.3239 34.2808 96.3596C34.3022 96.3954 34.3369 96.4223 34.3782 96.4352L34.4533 96.4257ZM35.9572 97.2421L36.5537 97.5649C36.6429 97.6082 36.7418 97.6308 36.842 97.6308C36.9423 97.6308 37.0411 97.6082 37.1303 97.5649C37.2907 97.4747 37.2907 97.337 37.1303 97.2469L36.4685 96.9098C36.3797 96.8654 36.2808 96.8421 36.1803 96.8421C36.0798 96.8421 35.9809 96.8654 35.8921 96.9098C35.8456 96.9067 35.7996 96.9212 35.7643 96.9501C35.7291 96.979 35.7074 97.0201 35.7041 97.0641C35.7008 97.1082 35.716 97.1517 35.7466 97.1851C35.7771 97.2184 35.8205 97.239 35.867 97.2421H35.9572ZM37.4611 98.0537L38.0526 98.3813C38.1421 98.4235 38.2409 98.4455 38.3409 98.4455C38.4409 98.4455 38.5396 98.4235 38.6291 98.3813C38.6633 98.3698 38.693 98.3486 38.7139 98.3206C38.7349 98.2925 38.7461 98.259 38.7461 98.2246C38.7461 98.1903 38.7349 98.1568 38.7139 98.1287C38.693 98.1007 38.6633 98.0794 38.6291 98.068L38.0326 97.7405C37.9431 97.6983 37.8443 97.6763 37.7443 97.6763C37.6442 97.6763 37.5456 97.6983 37.4561 97.7405C37.4156 97.7372 37.3751 97.7473 37.3416 97.7691C37.3081 97.7909 37.2837 97.8231 37.2725 97.8601C37.2612 97.897 37.2638 97.9366 37.2799 97.9719C37.2961 98.0072 37.3247 98.0362 37.3608 98.0537H37.4611ZM38.9649 98.8702L39.5564 99.1977C39.646 99.2399 39.7447 99.2619 39.8448 99.2619C39.9448 99.2619 40.0435 99.2399 40.133 99.1977C40.2934 99.1075 40.2934 98.9698 40.133 98.8797L39.5365 98.5569C39.4477 98.5124 39.3486 98.4892 39.2481 98.4892C39.1477 98.4892 39.0487 98.5124 38.9599 98.5569C38.9177 98.5483 38.8737 98.5548 38.8362 98.5751C38.7987 98.5954 38.7704 98.628 38.7568 98.6668C38.7431 98.7056 38.745 98.7478 38.7622 98.7853C38.7793 98.8228 38.8105 98.853 38.8497 98.8702H38.9649ZM40.4688 99.6866L41.0603 100.009C41.1495 100.053 41.2484 100.075 41.3487 100.075C41.4489 100.075 41.5477 100.053 41.6369 100.009C41.6711 99.9979 41.7007 99.9767 41.7217 99.9486C41.7426 99.9206 41.7539 99.8871 41.7539 99.8527C41.7539 99.8183 41.7426 99.7848 41.7217 99.7568C41.7007 99.7287 41.6711 99.7075 41.6369 99.6961L41.0404 99.3685C40.9508 99.3263 40.8521 99.3043 40.752 99.3043C40.652 99.3043 40.5534 99.3263 40.4638 99.3685C40.1781 99.454 40.1781 99.5964 40.3385 99.6866H40.4688ZM41.9727 100.498L42.5692 100.826C42.6588 100.868 42.7575 100.89 42.8575 100.89C42.9576 100.89 43.0562 100.868 43.1458 100.826C43.3012 100.74 43.3012 100.598 43.1458 100.508L42.5542 100.185C42.4653 100.14 42.3664 100.117 42.2659 100.117C42.1655 100.117 42.0665 100.14 41.9777 100.185C41.9338 100.166 41.8838 100.164 41.8387 100.18C41.7936 100.196 41.757 100.229 41.7371 100.27C41.7172 100.312 41.7154 100.359 41.7323 100.402C41.7493 100.445 41.7834 100.479 41.8273 100.498H41.9727ZM43.4766 101.329L44.0731 101.656C44.1626 101.699 44.2614 101.721 44.3614 101.721C44.4615 101.721 44.5601 101.699 44.6496 101.656C44.8101 101.571 44.805 101.429 44.6496 101.338L44.053 101.016C43.9638 100.972 43.865 100.95 43.7648 100.95C43.6646 100.95 43.5658 100.972 43.4766 101.016C43.4549 101.007 43.4316 101.004 43.4083 101.004C43.3849 101.004 43.3619 101.009 43.3405 101.018C43.3191 101.027 43.2998 101.039 43.2836 101.055C43.2674 101.071 43.2546 101.09 43.246 101.111C43.2374 101.131 43.2332 101.153 43.2336 101.175C43.234 101.197 43.239 101.219 43.2483 101.239C43.2576 101.26 43.2711 101.278 43.2879 101.293C43.3047 101.309 43.3245 101.321 43.3462 101.329H43.4766ZM23.4349 91.9592L23.9362 92.2393C24.0379 92.2884 24.1504 92.3141 24.2646 92.3141C24.3787 92.3141 24.4913 92.2884 24.5929 92.2393L25.0942 91.9592C25.1326 91.9457 25.1657 91.9215 25.1891 91.8896C25.2125 91.8578 25.2249 91.82 25.2249 91.7812C25.2249 91.7425 25.2125 91.7046 25.1891 91.6728C25.1657 91.641 25.1326 91.6167 25.0942 91.6032L24.5929 91.3184C24.4913 91.2693 24.3787 91.2437 24.2646 91.2437C24.1504 91.2437 24.0379 91.2693 23.9362 91.3184L23.4349 91.5985C23.2595 91.6887 23.2595 91.8596 23.4349 91.9592ZM26.0918 93.0557L26.5931 92.7756C26.7736 92.6759 26.7685 92.5146 26.5931 92.4149L26.0918 92.1349C25.9901 92.0857 25.8776 92.06 25.7634 92.06C25.6493 92.06 25.5367 92.0857 25.4351 92.1349L24.9338 92.4149C24.7533 92.5098 24.7583 92.6712 24.9338 92.7709L25.4351 93.0509C25.5378 93.102 25.6519 93.1291 25.7678 93.13C25.8838 93.1308 25.9984 93.1053 26.1018 93.0557H26.0918ZM26.4427 93.5873L26.944 93.8673C27.0456 93.9165 27.1582 93.9421 27.2723 93.9421C27.3865 93.9421 27.499 93.9165 27.6007 93.8673L28.102 93.5873C28.2825 93.4876 28.2774 93.331 28.102 93.2313L27.6007 92.9465C27.4999 92.8974 27.3881 92.8717 27.2748 92.8717C27.1614 92.8717 27.0498 92.8974 26.949 92.9465L26.4477 93.2265C26.2372 93.3262 26.2422 93.4876 26.4427 93.5873ZM27.9466 94.3989L28.4479 94.679C28.5495 94.7281 28.6621 94.7538 28.7762 94.7538C28.8904 94.7538 29.0029 94.7281 29.1046 94.679L29.6059 94.3989C29.7863 94.2993 29.7863 94.1379 29.6059 94.0382L29.1046 93.7582C29.0029 93.709 28.8904 93.6834 28.7762 93.6834C28.6621 93.6834 28.5495 93.709 28.4479 93.7582L27.9466 94.0382C27.731 94.1379 27.731 94.2993 27.9114 94.3989H27.9466ZM31.1148 94.8736L30.6135 94.5888C30.5118 94.5396 30.3993 94.514 30.2851 94.514C30.1709 94.514 30.0584 94.5396 29.9567 94.5888L29.4555 94.8689C29.4153 94.8813 29.3803 94.9055 29.3556 94.9379C29.3308 94.9703 29.3175 95.0092 29.3175 95.0492C29.3175 95.0892 29.3308 95.1282 29.3556 95.1606C29.3803 95.1929 29.4153 95.2171 29.4555 95.2296L29.9567 95.5096C30.0584 95.5588 30.1709 95.5844 30.2851 95.5844C30.3993 95.5844 30.5118 95.5588 30.6135 95.5096L31.1148 95.2296C31.2651 95.1157 31.2651 94.959 31.0796 94.8593L31.1148 94.8736ZM32.6186 95.6852L32.1173 95.4052C32.0157 95.356 31.9031 95.3304 31.789 95.3304C31.6748 95.3304 31.5623 95.356 31.4606 95.4052L30.9593 95.6852C30.7789 95.7802 30.7789 95.9416 30.9593 96.0412L31.4606 96.326C31.5626 96.3741 31.675 96.3991 31.789 96.3991C31.9029 96.3991 32.0153 96.3741 32.1173 96.326L32.6186 96.046C32.6667 96.0356 32.7091 96.0088 32.7376 95.9707C32.7661 95.9325 32.7789 95.8858 32.7733 95.8394C32.7677 95.793 32.7442 95.7501 32.7074 95.719C32.6705 95.688 32.6228 95.6709 32.5735 95.671L32.6186 95.6852ZM34.1225 96.5017L33.6212 96.2168C33.5192 96.1688 33.4068 96.1438 33.2929 96.1438C33.1789 96.1438 33.0665 96.1688 32.9645 96.2168L32.4632 96.4969C32.4231 96.5094 32.3881 96.5336 32.3633 96.5659C32.3386 96.5983 32.3253 96.6373 32.3253 96.6773C32.3253 96.7173 32.3386 96.7562 32.3633 96.7886C32.3881 96.821 32.4231 96.8452 32.4632 96.8576L32.9645 97.1377C33.0662 97.1868 33.1787 97.2125 33.2929 97.2125C33.407 97.2125 33.5196 97.1868 33.6212 97.1377L34.1225 96.8576C34.2428 96.7485 34.2428 96.5871 34.0623 96.4874L34.1225 96.5017ZM35.6264 97.3133L35.1251 97.0333C35.0234 96.9841 34.9109 96.9585 34.7967 96.9585C34.6826 96.9585 34.57 96.9841 34.4684 97.0333L33.9671 97.3133C33.9287 97.3268 33.8956 97.3511 33.8722 97.3829C33.8489 97.4147 33.8364 97.4525 33.8364 97.4913C33.8364 97.53 33.8489 97.5679 33.8722 97.5997C33.8956 97.6315 33.9287 97.6558 33.9671 97.6693L34.4684 97.9541C34.57 98.0033 34.6826 98.0289 34.7967 98.0289C34.9109 98.0289 35.0234 98.0033 35.1251 97.9541L35.6264 97.674C35.6789 97.6646 35.7253 97.6358 35.7554 97.594C35.7855 97.5521 35.7967 97.5007 35.7867 97.451C35.7767 97.4012 35.7463 97.3573 35.7021 97.3288C35.658 97.3003 35.6036 97.2896 35.5511 97.2991L35.6264 97.3133ZM37.1303 98.1297L36.629 97.8497C36.5273 97.8005 36.4148 97.7748 36.3006 97.7748C36.1865 97.7748 36.0739 97.8005 35.9722 97.8497L35.471 98.1297C35.4308 98.1422 35.3959 98.1664 35.3711 98.1987C35.3463 98.2311 35.333 98.2701 35.333 98.3101C35.333 98.3501 35.3463 98.389 35.3711 98.4214C35.3959 98.4538 35.4308 98.478 35.471 98.4904L35.9722 98.7705C36.0739 98.8196 36.1865 98.8453 36.3006 98.8453C36.4148 98.8453 36.5273 98.8196 36.629 98.7705L37.1303 98.4904C37.2205 98.3765 37.2204 98.2151 37.0399 98.1155L37.1303 98.1297ZM38.6341 98.9414L38.1328 98.6613C38.0312 98.6122 37.9186 98.5865 37.8045 98.5865C37.6903 98.5865 37.5778 98.6122 37.4761 98.6613L36.9748 98.9414C36.7944 99.041 36.7944 99.1977 36.9748 99.2974L37.4761 99.5821C37.5778 99.6313 37.6903 99.6569 37.8045 99.6569C37.9186 99.6569 38.0312 99.6313 38.1328 99.5821L38.6341 99.3021C38.6867 99.2889 38.7315 99.2564 38.7587 99.2119C38.786 99.1674 38.7935 99.1145 38.7795 99.0648C38.7656 99.015 38.7313 98.9726 38.6843 98.9468C38.6373 98.921 38.5814 98.9139 38.5289 98.9271L38.6341 98.9414ZM38.4436 100.114L38.9449 100.394C39.0465 100.443 39.1591 100.469 39.2732 100.469C39.3874 100.469 39.4999 100.443 39.6016 100.394L40.1029 100.114C40.2834 100.019 40.2834 99.8574 40.1029 99.7578L39.6016 99.4777C39.4996 99.4296 39.3872 99.4046 39.2732 99.4046C39.1593 99.4046 39.0469 99.4296 38.9449 99.4777L38.4436 99.7578C38.1528 99.8385 38.1529 99.9998 38.3383 100.099L38.4436 100.114ZM41.6118 100.588L41.1105 100.308C41.0097 100.259 40.8981 100.234 40.7847 100.234C40.6714 100.234 40.5596 100.259 40.4588 100.308L39.9575 100.588C39.777 100.688 39.782 100.845 39.9575 100.944L40.4588 101.229C40.5596 101.278 40.6714 101.304 40.7847 101.304C40.8981 101.304 41.0097 101.278 41.1105 101.229L41.6118 100.949C41.692 100.816 41.687 100.655 41.5065 100.555L41.6118 100.588ZM43.7925 101.785L42.6194 101.139C42.5177 101.09 42.4052 101.064 42.291 101.064C42.1769 101.064 42.0643 101.09 41.9627 101.139L41.4614 101.419C41.4213 101.432 41.3864 101.456 41.3616 101.488C41.3369 101.52 41.3234 101.559 41.3234 101.599C41.3234 101.639 41.3369 101.678 41.3616 101.711C41.3864 101.743 41.4213 101.767 41.4614 101.78L42.6395 102.421C42.7411 102.47 42.8537 102.495 42.9678 102.495C43.082 102.495 43.1945 102.47 43.2962 102.421L43.7975 102.141C43.8727 102.008 43.8726 101.851 43.6871 101.751L43.7925 101.785ZM22.1666 92.7424L23.3447 93.3879C23.4464 93.4371 23.5589 93.4627 23.6731 93.4627C23.7872 93.4627 23.8997 93.4371 24.0013 93.3879L24.5026 93.1079C24.541 93.0944 24.5741 93.0701 24.5975 93.0383C24.6208 93.0065 24.6335 92.9686 24.6335 92.9299C24.6335 92.8911 24.6208 92.8533 24.5975 92.8215C24.5741 92.7897 24.541 92.7654 24.5026 92.7519L23.3247 92.1064C23.223 92.0572 23.1105 92.0316 22.9963 92.0316C22.8821 92.0316 22.7696 92.0572 22.6679 92.1064L22.1666 92.3864C22.1303 92.3925 22.0965 92.4079 22.0689 92.431C22.0412 92.4541 22.0209 92.484 22.01 92.5173C21.9991 92.5507 21.9981 92.5863 22.0072 92.6201C22.0163 92.6539 22.035 92.6848 22.0614 92.7092L22.1666 92.7424ZM24.3172 93.9195L24.8185 94.1996C24.9205 94.2476 25.0329 94.2727 25.1469 94.2727C25.2608 94.2727 25.3732 94.2476 25.4752 94.1996L25.9765 93.9195C26.0166 93.9071 26.0515 93.8829 26.0763 93.8505C26.101 93.8181 26.1144 93.7792 26.1144 93.7392C26.1144 93.6992 26.101 93.6602 26.0763 93.6278C26.0515 93.5955 26.0166 93.5713 25.9765 93.5588L25.4752 93.2787C25.3736 93.2296 25.261 93.2039 25.1469 93.2039C25.0327 93.2039 24.9202 93.2296 24.8185 93.2787L24.3172 93.5588C24.0315 93.6253 24.0315 93.7866 24.212 93.8863L24.3172 93.9195ZM26.3224 95.016C26.424 95.0652 26.5366 95.0908 26.6507 95.0908C26.7649 95.0908 26.8774 95.0652 26.9791 95.016L27.4804 94.7359C27.5188 94.7224 27.5519 94.6982 27.5752 94.6663C27.5986 94.6345 27.6111 94.5967 27.6111 94.5579C27.6111 94.5192 27.5986 94.4814 27.5752 94.4495C27.5519 94.4177 27.5188 94.3934 27.4804 94.3799L26.9791 94.0952C26.8774 94.046 26.7649 94.0204 26.6507 94.0204C26.5366 94.0204 26.424 94.046 26.3224 94.0952L25.8211 94.3752C25.6406 94.4749 25.6406 94.6363 25.8211 94.7359L26.3224 95.016ZM27.8263 95.8276C27.9279 95.8768 28.0405 95.9024 28.1546 95.9024C28.2688 95.9024 28.3813 95.8768 28.483 95.8276L28.9843 95.5476C29.0244 95.5351 29.0592 95.511 29.084 95.4786C29.1088 95.4462 29.1222 95.4072 29.1222 95.3672C29.1222 95.3272 29.1088 95.2883 29.084 95.2559C29.0592 95.2235 29.0244 95.1993 28.9843 95.1869L28.483 94.9068C28.3813 94.8577 28.2688 94.832 28.1546 94.832C28.0405 94.832 27.9279 94.8577 27.8263 94.9068L27.325 95.1869C27.1445 95.2818 27.1445 95.4432 27.325 95.5428L27.8263 95.8276ZM29.3301 95.7232L28.8288 96.0033C28.6484 96.103 28.6484 96.2643 28.8288 96.364L29.3301 96.644C29.4309 96.6932 29.5426 96.7188 29.6559 96.7188C29.7693 96.7188 29.8811 96.6932 29.9818 96.644L30.4831 96.364C30.6636 96.2643 30.6586 96.1077 30.4831 96.008L29.9818 95.7232C29.8676 95.6451 29.7318 95.6003 29.5911 95.5944C29.4503 95.5885 29.3108 95.6217 29.1898 95.69L29.3301 95.7232ZM30.834 96.5206L30.2576 96.8339C30.2227 96.8467 30.1927 96.8692 30.1715 96.8984C30.1504 96.9276 30.1391 96.9622 30.1391 96.9977C30.1391 97.0331 30.1504 97.0677 30.1715 97.0969C30.1927 97.1261 30.2227 97.1486 30.2576 97.1614L30.834 97.4747C30.9255 97.5192 31.0269 97.5425 31.1298 97.5425C31.2327 97.5425 31.334 97.5192 31.4255 97.4747L32.0021 97.1614C32.0374 97.1498 32.0681 97.1279 32.0898 97.099C32.1115 97.0701 32.1232 97.0355 32.1232 97C32.1232 96.9646 32.1115 96.93 32.0898 96.901C32.0681 96.8721 32.0374 96.8503 32.0021 96.8386L31.4205 96.5206C31.3188 96.4507 31.1978 96.4102 31.0723 96.4043C30.9468 96.3984 30.8222 96.4273 30.7137 96.4874L30.834 96.5206ZM32.3379 97.337L31.7614 97.6503C31.601 97.7405 31.601 97.8829 31.7614 97.9731L32.3379 98.2911C32.4294 98.3356 32.5308 98.3589 32.6337 98.3589C32.7366 98.3589 32.8379 98.3356 32.9294 98.2911L33.5059 97.9778C33.5408 97.965 33.5707 97.9425 33.5918 97.9133C33.613 97.8841 33.6244 97.8495 33.6244 97.8141C33.6244 97.7787 33.613 97.744 33.5918 97.7148C33.5707 97.6856 33.5408 97.6631 33.5059 97.6503L32.9244 97.337C32.8212 97.2641 32.6974 97.222 32.5688 97.216C32.4402 97.2101 32.3127 97.2407 32.2025 97.3038L32.3379 97.337ZM33.8418 98.1487L33.2653 98.462C33.2304 98.4748 33.2004 98.4973 33.1793 98.5265C33.1581 98.5557 33.1469 98.5903 33.1469 98.6257C33.1469 98.6611 33.1581 98.6957 33.1793 98.725C33.2004 98.7542 33.2304 98.7767 33.2653 98.7895L33.8418 99.1027C33.9332 99.1473 34.0347 99.1705 34.1376 99.1705C34.2404 99.1705 34.3418 99.1473 34.4332 99.1027L35.0098 98.7895C35.1752 98.6993 35.1702 98.5569 35.0098 98.4667L34.4282 98.1487C34.3236 98.0727 34.1971 98.0287 34.0654 98.0228C33.9336 98.0169 33.8031 98.0492 33.6913 98.1155L33.8418 98.1487ZM35.3456 98.9651L34.7692 99.2784C34.6088 99.3685 34.6088 99.5109 34.7692 99.6011L35.3456 99.9192C35.438 99.9637 35.5402 99.987 35.6439 99.987C35.7476 99.987 35.8498 99.9637 35.9421 99.9192L36.5137 99.6059C36.6791 99.5157 36.6791 99.3685 36.5137 99.2831L35.9321 98.9651C35.8261 98.8859 35.6966 98.8402 35.5618 98.8342C35.4269 98.8283 35.2935 98.8624 35.1802 98.9319L35.3456 98.9651ZM36.8495 99.7767L36.2781 100.09C36.2408 100.101 36.2081 100.122 36.1848 100.152C36.1616 100.181 36.1491 100.217 36.1491 100.254C36.1491 100.291 36.1616 100.326 36.1848 100.356C36.2081 100.385 36.2408 100.407 36.2781 100.418L36.8545 100.731C36.9474 100.774 37.0494 100.796 37.1528 100.796C37.2562 100.796 37.3582 100.774 37.451 100.731L38.0226 100.413C38.188 100.327 38.188 100.18 38.0226 100.09L37.446 99.772C37.3337 99.6943 37.1989 99.6513 37.0599 99.6487C36.9209 99.6462 36.7844 99.6843 36.669 99.7578L36.8495 99.7767ZM38.9399 101.547L39.5114 101.234C39.6768 101.144 39.6768 100.997 39.5114 100.911L38.9348 100.593C38.8425 100.549 38.7403 100.525 38.6366 100.525C38.5329 100.525 38.4307 100.549 38.3383 100.593L37.7669 100.906C37.6015 100.997 37.6015 101.139 37.7669 101.229L38.3433 101.547C38.4822 101.579 38.6283 101.568 38.7595 101.514L38.9399 101.547ZM40.4437 102.364L41.0203 102.046C41.1807 101.96 41.1807 101.813 41.0203 101.723L40.4437 101.405C40.3509 101.362 40.2489 101.339 40.1455 101.339C40.0421 101.339 39.9401 101.362 39.8472 101.405L39.2758 101.718C39.2386 101.729 39.2059 101.75 39.1827 101.78C39.1594 101.809 39.1468 101.845 39.1468 101.882C39.1468 101.919 39.1594 101.954 39.1827 101.984C39.2059 102.013 39.2386 102.035 39.2758 102.046L39.8573 102.359C39.9876 102.387 40.124 102.377 40.2483 102.33L40.4437 102.364ZM42.5342 102.553L41.9576 102.24C41.8658 102.197 41.7646 102.174 41.662 102.174C41.5593 102.174 41.458 102.197 41.3662 102.24L40.7897 102.558C40.7543 102.57 40.7236 102.592 40.7018 102.621C40.6801 102.65 40.6686 102.684 40.6686 102.72C40.6686 102.755 40.6801 102.79 40.7018 102.819C40.7236 102.847 40.7543 102.869 40.7897 102.881L41.3712 103.199C41.463 103.242 41.5643 103.265 41.667 103.265C41.7696 103.265 41.8708 103.242 41.9627 103.199L42.5392 102.886C42.5904 102.861 42.6289 102.817 42.6463 102.765C42.6637 102.713 42.6585 102.657 42.6319 102.608C42.6053 102.56 42.5595 102.523 42.5045 102.507C42.4495 102.49 42.3898 102.495 42.3386 102.52L42.5342 102.553ZM20.8483 93.4829L22.7131 94.5034C22.8055 94.548 22.9077 94.5712 23.0114 94.5712C23.115 94.5712 23.2172 94.548 23.3096 94.5034L23.881 94.1901C23.9183 94.1796 23.9509 94.158 23.9742 94.1285C23.9974 94.0989 24.01 94.0631 24.01 94.0263C24.01 93.9895 23.9974 93.9537 23.9742 93.9242C23.9509 93.8947 23.9183 93.8731 23.881 93.8626L22.0162 92.8421C21.9239 92.7975 21.8217 92.7743 21.718 92.7743C21.6143 92.7743 21.5121 92.7975 21.4197 92.8421L20.8483 93.1554C20.8279 93.1432 20.8051 93.135 20.7814 93.1311C20.7576 93.1273 20.7333 93.1279 20.7098 93.133C20.6863 93.1381 20.664 93.1475 20.6443 93.1607C20.6246 93.1739 20.6079 93.1906 20.5951 93.2099C20.5823 93.2293 20.5736 93.2508 20.5695 93.2733C20.5655 93.2958 20.5661 93.3188 20.5715 93.3411C20.5768 93.3634 20.5868 93.3844 20.6007 93.403C20.6147 93.4216 20.6323 93.4375 20.6527 93.4496L20.8483 93.4829ZM23.6254 95.0017L24.2069 95.315C24.2984 95.3596 24.3997 95.3828 24.5026 95.3828C24.6055 95.3828 24.7069 95.3596 24.7984 95.315L25.375 95.0017C25.5354 94.9116 25.5354 94.7692 25.375 94.679L24.7984 94.361C24.7069 94.3164 24.6055 94.2932 24.5026 94.2932C24.3997 94.2932 24.2984 94.3164 24.2069 94.361L23.6304 94.6742C23.5892 94.6497 23.5394 94.6417 23.492 94.6519C23.4445 94.6621 23.4032 94.6898 23.3773 94.7288C23.3514 94.7679 23.3429 94.815 23.3537 94.86C23.3645 94.9049 23.3937 94.944 23.4349 94.9685L23.6254 95.0017ZM25.1292 95.8134L25.7108 96.1314C25.8023 96.176 25.9036 96.1992 26.0065 96.1992C26.1094 96.1992 26.2108 96.176 26.3023 96.1314L26.8789 95.8182C26.9143 95.8065 26.9449 95.7847 26.9666 95.7558C26.9883 95.7268 26.9999 95.6922 26.9999 95.6568C26.9999 95.6213 26.9883 95.5867 26.9666 95.5578C26.9449 95.5288 26.9143 95.5071 26.8789 95.4954L26.3023 95.1774C26.2108 95.1328 26.1094 95.1096 26.0065 95.1096C25.9036 95.1096 25.8023 95.1328 25.7108 95.1774L25.1343 95.4906C24.7533 95.5476 24.7583 95.69 24.9388 95.7802L25.1292 95.8134ZM26.6331 96.6298L27.2147 96.9431C27.3065 96.9865 27.4077 97.0091 27.5104 97.0091C27.613 97.0091 27.7143 96.9865 27.8062 96.9431L28.3827 96.6251C28.5432 96.5396 28.5432 96.3925 28.3827 96.3023L27.8062 95.9843C27.7143 95.9408 27.613 95.9182 27.5104 95.9182C27.4077 95.9182 27.3065 95.9408 27.2147 95.9843L26.6381 96.2976C26.5963 96.2686 26.544 96.2566 26.4927 96.2642C26.4415 96.2717 26.3955 96.2982 26.365 96.3379C26.3344 96.3775 26.3217 96.4271 26.3297 96.4756C26.3377 96.5241 26.3657 96.5676 26.4076 96.5966L26.6331 96.6298ZM29.295 97.7595L29.8716 97.4462C29.907 97.4345 29.9376 97.4128 29.9593 97.3838C29.981 97.3549 29.9927 97.3203 29.9927 97.2848C29.9927 97.2493 29.981 97.2147 29.9593 97.1858C29.9376 97.1569 29.907 97.1351 29.8716 97.1234L29.29 96.8054C29.1985 96.7609 29.0972 96.7376 28.9943 96.7376C28.8914 96.7376 28.79 96.7609 28.6985 96.8054L28.1221 97.1187C27.9616 97.2089 27.9616 97.3513 28.1221 97.4415L28.6985 97.7595C28.8229 97.7831 28.9519 97.7715 29.0694 97.7262L29.295 97.7595ZM30.7989 98.5759L31.3754 98.2579C31.5409 98.1724 31.5359 98.0253 31.3754 97.9351L30.7939 97.6171C30.702 97.5736 30.6008 97.551 30.4982 97.551C30.3955 97.551 30.2942 97.5736 30.2024 97.6171L29.6259 97.9304C29.5911 97.9432 29.561 97.9656 29.5399 97.9949C29.5188 98.0241 29.5075 98.0587 29.5075 98.0941C29.5075 98.1295 29.5188 98.1641 29.5399 98.1934C29.561 98.2226 29.5911 98.2451 29.6259 98.2579L30.2024 98.5711C30.3215 98.5927 30.4446 98.5829 30.5583 98.5427L30.7989 98.5759ZM32.3028 99.3875L32.8793 99.0743C33.0447 98.9841 33.0397 98.8417 32.8793 98.7515L32.2977 98.4335C32.2063 98.3889 32.1049 98.3657 32.0021 98.3657C31.8992 98.3657 31.7977 98.3889 31.7062 98.4335L31.1298 98.7467C30.9694 98.8369 30.9694 98.9793 31.1298 99.0695L31.7062 99.3875C31.821 99.4057 31.9387 99.3942 32.0471 99.3543L32.3028 99.3875ZM33.8066 100.204L34.3782 99.8859C34.5436 99.8005 34.5436 99.6533 34.3782 99.5632L33.7966 99.2499C33.7048 99.2064 33.6036 99.1838 33.5009 99.1838C33.3982 99.1838 33.2969 99.2064 33.2051 99.2499L32.6287 99.5679C32.4683 99.6533 32.4683 99.8005 32.6287 99.8907L33.2051 100.204C33.3182 100.22 33.4337 100.208 33.5409 100.171L33.8066 100.204ZM35.3105 101.016L35.882 100.702C36.0475 100.612 36.0475 100.47 35.882 100.38L35.3055 100.062C35.2131 100.017 35.1109 99.9937 35.0072 99.9937C34.9036 99.9937 34.8014 100.017 34.709 100.062L34.1376 100.375C33.9721 100.465 33.9721 100.607 34.1376 100.698L34.714 101.016C34.8206 101.029 34.9289 101.018 35.0298 100.982L35.3105 101.016ZM36.8144 101.832L37.3859 101.519C37.4232 101.508 37.4558 101.487 37.4791 101.457C37.5023 101.428 37.5148 101.392 37.5148 101.355C37.5148 101.318 37.5023 101.282 37.4791 101.253C37.4558 101.223 37.4232 101.202 37.3859 101.191L36.8094 100.878C36.7165 100.835 36.6145 100.812 36.5111 100.812C36.4077 100.812 36.3057 100.835 36.2129 100.878L35.6414 101.196C35.476 101.281 35.476 101.429 35.6414 101.519L36.2179 101.837C36.3199 101.846 36.4228 101.833 36.5187 101.799L36.8144 101.832ZM37.1303 102.307L37.7117 102.625C37.8032 102.669 37.9046 102.692 38.0075 102.692C38.1104 102.692 38.2117 102.669 38.3032 102.625L38.8747 102.311C39.0402 102.221 39.0402 102.079 38.8747 101.989L38.2982 101.671C38.2058 101.626 38.1036 101.603 37.9999 101.603C37.8963 101.603 37.7941 101.626 37.7017 101.671L37.1303 101.984C36.6691 102.06 36.669 102.207 36.8345 102.292L37.1303 102.307ZM41.2559 103.289L39.7871 102.487C39.6953 102.444 39.594 102.421 39.4913 102.421C39.3887 102.421 39.2874 102.444 39.1955 102.487L38.6191 102.805C38.4537 102.89 38.4537 103.038 38.6191 103.128L40.0929 103.93C40.1847 103.973 40.286 103.996 40.3887 103.996C40.4913 103.996 40.5925 103.973 40.6843 103.93L41.2609 103.612C41.1256 103.512 41.1255 103.365 40.9802 103.275L41.2559 103.289ZM19.575 94.2708L22.2218 95.6947C22.3261 95.744 22.4411 95.7697 22.5577 95.7697C22.6742 95.7697 22.7892 95.744 22.8935 95.6947L23.3948 95.4242C23.4343 95.4105 23.4685 95.3856 23.4926 95.3529C23.5167 95.3202 23.5297 95.2813 23.5297 95.2414C23.5297 95.2016 23.5167 95.1627 23.4926 95.13C23.4685 95.0973 23.4343 95.0724 23.3948 95.0587L20.4272 93.5873C20.3229 93.538 20.2079 93.5123 20.0914 93.5123C19.9748 93.5123 19.8597 93.538 19.7554 93.5873L19.2541 93.8626C19.0937 93.9765 19.0937 94.1379 19.2792 94.2423L19.575 94.2708ZM23.2144 96.2596L23.7157 96.5301C23.8188 96.5805 23.9331 96.6068 24.0491 96.6068C24.165 96.6068 24.2792 96.5805 24.3823 96.5301L24.8836 96.2548C25.0641 96.1551 25.0641 95.9938 24.8836 95.8893L24.3823 95.6141C24.2789 95.5648 24.1648 95.5391 24.0491 95.5391C23.9333 95.5391 23.8191 95.5648 23.7157 95.6141L23.2144 95.8893C22.7281 95.9605 22.7331 96.1267 22.9336 96.2311L23.2144 96.2596ZM24.7183 97.0712L25.2196 97.3465C25.323 97.3958 25.4372 97.4214 25.5529 97.4214C25.6687 97.4214 25.7828 97.3958 25.8862 97.3465L26.3875 97.076C26.427 97.0623 26.4613 97.0374 26.4854 97.0047C26.5095 96.972 26.5224 96.9331 26.5224 96.8932C26.5224 96.8534 26.5095 96.8145 26.4854 96.7818C26.4613 96.7491 26.427 96.7242 26.3875 96.7105L25.8862 96.4352C25.7831 96.3848 25.6689 96.3585 25.5529 96.3585C25.437 96.3585 25.3226 96.3848 25.2196 96.4352L24.7183 96.7058C24.217 96.7769 24.2219 96.9431 24.4074 97.0428L24.7183 97.0712ZM26.2221 97.8876L26.7234 98.1629C26.8269 98.2122 26.941 98.2378 27.0568 98.2378C27.1726 98.2378 27.2866 98.2122 27.3901 98.1629L27.8914 97.8876C28.0768 97.788 28.0718 97.6266 27.8914 97.5221L27.3901 97.2469C27.2866 97.1976 27.1726 97.1719 27.0568 97.1719C26.941 97.1719 26.8269 97.1976 26.7234 97.2469L26.2221 97.5221C25.7108 97.5933 25.7108 97.7547 25.8962 97.8592L26.2221 97.8876ZM27.726 98.6993L28.2273 98.9746C28.3313 99.025 28.4463 99.0513 28.5631 99.0513C28.6799 99.0513 28.795 99.025 28.899 98.9746L29.4003 98.704C29.5857 98.6044 29.5857 98.4382 29.4003 98.3386L28.899 98.0632C28.7955 98.014 28.6815 97.9883 28.5657 97.9883C28.4499 97.9883 28.3358 98.014 28.2323 98.0632L27.731 98.3338C27.6838 98.2904 27.6204 98.2665 27.5546 98.2674C27.4888 98.2683 27.426 98.2939 27.3802 98.3386C27.3343 98.3832 27.309 98.4433 27.3099 98.5057C27.3108 98.568 27.3379 98.6274 27.3851 98.6708L27.726 98.6993ZM29.2299 99.5157L29.7312 99.791C29.8355 99.8403 29.9504 99.866 30.067 99.866C30.1836 99.866 30.2985 99.8403 30.4028 99.791L30.9041 99.5157C31.0896 99.416 31.0896 99.2546 30.9041 99.1502L30.4028 98.8797C30.2989 98.8293 30.1838 98.803 30.067 98.803C29.9502 98.803 29.8351 98.8293 29.7312 98.8797L29.2299 99.1549C28.6885 99.2214 28.6885 99.3828 28.874 99.4872L29.2299 99.5157ZM30.7338 100.327L31.2351 100.603C31.339 100.653 31.4541 100.679 31.5709 100.679C31.6877 100.679 31.8028 100.653 31.9067 100.603L32.408 100.332C32.4476 100.318 32.4818 100.293 32.5059 100.261C32.53 100.228 32.5429 100.189 32.5429 100.149C32.5429 100.109 32.53 100.071 32.5059 100.038C32.4818 100.005 32.4476 99.9803 32.408 99.9666L31.9067 99.6913C31.8024 99.642 31.6875 99.6163 31.5709 99.6163C31.4543 99.6163 31.3394 99.642 31.2351 99.6913L30.7338 99.9619C30.7104 99.9388 30.6824 99.9203 30.6515 99.9075C30.6206 99.8946 30.5874 99.8877 30.5536 99.887C30.5199 99.8864 30.4863 99.892 30.4549 99.9036C30.4234 99.9152 30.3946 99.9326 30.3703 99.9547C30.3459 99.9769 30.3264 100.003 30.3129 100.033C30.2993 100.062 30.2919 100.093 30.2912 100.125C30.2905 100.157 30.2966 100.189 30.3088 100.219C30.3211 100.249 30.3395 100.276 30.3628 100.299L30.7338 100.327ZM32.2376 101.144L32.7389 101.419C32.8432 101.468 32.9582 101.494 33.0748 101.494C33.1913 101.494 33.3063 101.468 33.4106 101.419L33.9119 101.148C33.9532 101.136 33.9893 101.111 34.0148 101.078C34.0403 101.045 34.0541 101.004 34.0541 100.963C34.0541 100.922 34.0403 100.882 34.0148 100.849C33.9893 100.816 33.9532 100.791 33.9119 100.778L33.4106 100.508C33.3066 100.457 33.1916 100.431 33.0748 100.431C32.958 100.431 32.8429 100.457 32.7389 100.508L32.2376 100.783C32.1911 100.735 32.1261 100.706 32.057 100.702C31.9879 100.699 31.9203 100.722 31.8691 100.766C31.818 100.81 31.7874 100.872 31.7841 100.937C31.7808 101.003 31.8051 101.067 31.8516 101.115L32.2376 101.144ZM33.7415 101.955L34.2428 102.231C34.3464 102.282 34.4616 102.309 34.5786 102.309C34.6957 102.309 34.8109 102.282 34.9145 102.231L35.4158 101.96C35.4553 101.946 35.4895 101.922 35.5137 101.889C35.5378 101.856 35.5506 101.817 35.5506 101.777C35.5506 101.738 35.5378 101.699 35.5137 101.666C35.4895 101.633 35.4553 101.608 35.4158 101.595L34.9145 101.319C34.8102 101.27 34.6952 101.244 34.5786 101.244C34.4621 101.244 34.3471 101.27 34.2428 101.319L33.7415 101.59C33.155 101.656 33.155 101.827 33.3405 101.927L33.7415 101.955ZM35.2454 102.772L35.7467 103.047C35.851 103.096 35.9659 103.122 36.0825 103.122C36.1991 103.122 36.314 103.096 36.4183 103.047L36.9196 102.777C36.9609 102.764 36.997 102.739 37.0226 102.706C37.0481 102.673 37.0618 102.633 37.0618 102.591C37.0618 102.55 37.0481 102.51 37.0226 102.477C36.997 102.444 36.9609 102.419 36.9196 102.406L36.4183 102.136C36.3144 102.085 36.1993 102.059 36.0825 102.059C35.9657 102.059 35.8506 102.085 35.7467 102.136L35.2454 102.411C35.1989 102.359 35.1323 102.326 35.0604 102.32C34.9884 102.315 34.917 102.336 34.8618 102.38C34.8067 102.424 34.7722 102.487 34.7661 102.555C34.76 102.623 34.7828 102.691 34.8293 102.743L35.2454 102.772ZM36.7493 103.588L37.2506 103.859C37.3533 103.91 37.4677 103.937 37.5839 103.937C37.7002 103.937 37.8145 103.91 37.9172 103.859L38.4185 103.588C38.458 103.574 38.4923 103.55 38.5164 103.517C38.5405 103.484 38.5534 103.445 38.5534 103.405C38.5534 103.366 38.5405 103.327 38.5164 103.294C38.4923 103.261 38.458 103.236 38.4185 103.223L37.9172 102.947C37.8129 102.898 37.698 102.872 37.5814 102.872C37.4648 102.872 37.3499 102.898 37.2456 102.947L36.7443 103.218C36.1327 103.294 36.1377 103.455 36.3231 103.555L36.7493 103.588ZM39.9374 104.063L39.4361 103.792C39.3322 103.742 39.2171 103.716 39.1003 103.716C38.9835 103.716 38.8684 103.742 38.7645 103.792L38.2632 104.068C38.0777 104.167 38.0777 104.329 38.2632 104.433L38.7645 104.708C38.8688 104.758 38.9837 104.783 39.1003 104.783C39.2169 104.783 39.3318 104.758 39.4361 104.708L39.9374 104.433C39.6968 104.291 39.6969 104.129 39.5114 104.03L39.9374 104.063ZM20.6527 95.0445L19.4897 94.4084C19.3863 94.3592 19.2722 94.3335 19.1564 94.3335C19.0407 94.3335 18.9265 94.3592 18.8231 94.4084L18.3218 94.679C18.2805 94.6917 18.2445 94.7164 18.219 94.7497C18.1934 94.7829 18.1797 94.823 18.1797 94.8641C18.1797 94.9052 18.1934 94.9453 18.219 94.9785C18.2445 95.0118 18.2805 95.0365 18.3218 95.0492L19.4848 95.6852C19.5882 95.7345 19.7023 95.7602 19.8181 95.7602C19.9338 95.7602 20.048 95.7345 20.1514 95.6852L20.6527 95.41C20.4272 95.2581 20.4272 95.0967 20.2267 95.0112L20.6527 95.0445ZM22.1566 95.8609L21.6553 95.5856C21.5519 95.5363 21.4377 95.5107 21.3219 95.5107C21.2062 95.5107 21.0921 95.5363 20.9887 95.5856L20.4874 95.8561C20.4479 95.8698 20.4136 95.8947 20.3895 95.9274C20.3654 95.9601 20.3525 95.999 20.3525 96.0389C20.3525 96.0787 20.3654 96.1176 20.3895 96.1503C20.4136 96.183 20.4479 96.2079 20.4874 96.2216L20.9887 96.4969C21.0918 96.5473 21.206 96.5736 21.3219 96.5736C21.4379 96.5736 21.5523 96.5473 21.6553 96.4969L22.1566 96.2263C21.931 96.0745 21.901 95.9083 21.7155 95.8087L22.1566 95.8609ZM23.6605 96.6725L23.1592 96.402C23.0561 96.3516 22.9418 96.3253 22.8258 96.3253C22.7098 96.3253 22.5956 96.3516 22.4926 96.402L21.9913 96.6773C21.8108 96.777 21.8108 96.9383 21.9913 97.0428L22.4926 97.318C22.596 97.3673 22.71 97.393 22.8258 97.393C22.9416 97.393 23.0558 97.3673 23.1592 97.318L23.6605 97.0428C23.3948 96.9099 23.3898 96.7247 23.2044 96.6203L23.6605 96.6725ZM34.0874 102.368L24.653 97.2089C24.5487 97.1596 24.4338 97.1339 24.3172 97.1339C24.2006 97.1339 24.0857 97.1596 23.9814 97.2089L23.4801 97.4794C23.4405 97.4931 23.4063 97.518 23.3822 97.5507C23.3581 97.5834 23.3452 97.6223 23.3452 97.6622C23.3452 97.7021 23.3581 97.7409 23.3822 97.7736C23.4063 97.8063 23.4405 97.8312 23.4801 97.8449L32.4582 102.957C32.5613 103.007 32.6756 103.034 32.7916 103.034C32.9076 103.034 33.0219 103.007 33.1249 102.957L33.6262 102.682C33.6644 102.668 33.6972 102.643 33.7205 102.611C33.7438 102.579 33.7565 102.542 33.7571 102.503C33.7576 102.464 33.746 102.426 33.7235 102.394C33.7011 102.361 33.669 102.336 33.6313 102.321L34.0874 102.368ZM35.5913 103.185L35.09 102.909C34.9873 102.858 34.8728 102.831 34.7566 102.831C34.6404 102.831 34.5259 102.858 34.4232 102.909L33.9219 103.18C33.7364 103.28 33.7415 103.446 33.9219 103.545L34.4232 103.821C34.5266 103.87 34.6408 103.896 34.7566 103.896C34.8724 103.896 34.9865 103.87 35.09 103.821L35.5913 103.55C35.6199 103.521 35.6421 103.487 35.6567 103.449C35.6714 103.412 35.6781 103.372 35.6764 103.332C35.6748 103.292 35.6649 103.253 35.6473 103.217C35.6297 103.18 35.6047 103.148 35.5738 103.121C35.5428 103.094 35.5065 103.072 35.4669 103.059C35.4274 103.045 35.3854 103.038 35.3433 103.04C35.3012 103.042 35.2597 103.051 35.2214 103.068C35.1831 103.084 35.1487 103.108 35.1201 103.137L35.5913 103.185ZM37.0951 103.996L36.5938 103.721C36.4904 103.672 36.3762 103.646 36.2605 103.646C36.1447 103.646 36.0305 103.672 35.9271 103.721L35.4258 103.992C35.3845 104.004 35.3485 104.029 35.323 104.062C35.2975 104.096 35.2837 104.136 35.2837 104.177C35.2837 104.218 35.2975 104.258 35.323 104.291C35.3485 104.324 35.3845 104.349 35.4258 104.362L35.9271 104.632C36.0302 104.683 36.1445 104.709 36.2605 104.709C36.3765 104.709 36.4908 104.683 36.5938 104.632L37.0951 104.357C36.7994 104.215 36.7944 104.03 36.6089 103.949L37.0951 103.996ZM38.599 104.827L38.0977 104.552C37.9934 104.502 37.8785 104.477 37.7619 104.477C37.6453 104.477 37.5303 104.502 37.4259 104.552L36.9247 104.827C36.7392 104.927 36.7392 105.088 36.9247 105.193L37.4259 105.463C37.5299 105.513 37.6451 105.54 37.7619 105.54C37.8787 105.54 37.9938 105.513 38.0977 105.463L38.599 105.188C38.3183 105.045 38.3183 104.884 38.1328 104.78L38.599 104.827Z",
    fill: "url(#paint53_linear_2164_2451)"
  }), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M49.5013 100.992L26.2464 88.271C25.7495 87.9342 25.3432 87.4915 25.0602 86.9787C24.7772 86.4659 24.6255 85.8973 24.6172 85.3187V68.0461C24.6172 66.9117 25.3441 66.3896 26.2464 66.8785L49.5013 79.5992C49.9973 79.9368 50.4029 80.3796 50.6858 80.8923C50.9687 81.4049 51.121 81.9731 51.1305 82.5515V99.8241C51.1255 100.958 50.3936 101.481 49.5013 100.992Z",
    fill: "url(#paint54_linear_2164_2451)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M49.7063 100.104L26.697 87.5212C26.3268 87.2724 26.0265 86.9416 25.8221 86.5578C25.6176 86.174 25.5152 85.7487 25.5239 85.3189V67.9561C25.5242 67.9079 25.5378 67.8605 25.5634 67.8188C25.589 67.7771 25.6257 67.7425 25.6698 67.7185C25.714 67.6945 25.764 67.6818 25.815 67.6819C25.8659 67.6819 25.916 67.6946 25.9601 67.7188L26.0102 67.7472L49.0346 80.3398C49.4245 80.5698 49.7401 80.8969 49.947 81.2853C50.1539 81.6737 50.244 82.1085 50.2076 82.5421V99.8575C50.2078 99.9092 50.1937 99.9602 50.1666 100.005C50.1394 100.05 50.1002 100.087 50.0529 100.113C50.0056 100.139 49.9519 100.153 49.8972 100.153C49.8425 100.153 49.7888 100.14 49.7414 100.114L49.7063 100.104Z",
    fill: "url(#paint55_linear_2164_2451)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M49.0346 80.3493L26.0102 67.7568L25.9601 67.7283C25.916 67.7042 25.8659 67.6915 25.815 67.6914C25.764 67.6914 25.714 67.704 25.6698 67.728C25.6257 67.752 25.589 67.7866 25.5634 67.8283C25.5378 67.87 25.5242 67.9174 25.5239 67.9656V85.3189C25.5152 85.7487 25.6176 86.174 25.8221 86.5578C26.0265 86.9416 26.3268 87.2724 26.697 87.5212L49.7063 100.104H49.7414C49.7888 100.13 49.8425 100.144 49.8972 100.144C49.9519 100.144 50.0056 100.13 50.0529 100.104C50.1002 100.078 50.1394 100.041 50.1666 99.9956C50.1937 99.9507 50.2078 99.8998 50.2076 99.848V82.5517C50.244 82.118 50.1539 81.6832 49.947 81.2948C49.7401 80.9064 49.4245 80.5793 49.0346 80.3493ZM50.0372 99.867C50.0372 99.8997 50.0235 99.9311 49.999 99.9542C49.9746 99.9774 49.9414 99.9904 49.9069 99.9904C49.8856 99.9966 49.8629 99.9966 49.8416 99.9904L26.7822 87.3884C26.44 87.1553 26.163 86.8468 25.9752 86.4895C25.7874 86.1322 25.6945 85.7369 25.7045 85.3379V67.9561C25.7045 67.943 25.7071 67.93 25.7124 67.918C25.7177 67.9059 25.7255 67.8949 25.7353 67.8856C25.7451 67.8764 25.7567 67.869 25.7695 67.864C25.7822 67.859 25.7959 67.8564 25.8097 67.8564C25.8278 67.8522 25.8468 67.8522 25.8649 67.8564L48.9243 80.4774C49.2827 80.6956 49.5724 81.0011 49.7629 81.362C49.9535 81.7228 50.0378 82.1256 50.0071 82.5279L50.0372 99.867Z",
    fill: "url(#paint56_linear_2164_2451)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M49.9586 79.3476L26.7037 66.6317C26.5667 66.5411 26.4093 66.482 26.244 66.4589C26.0787 66.4358 25.9101 66.4495 25.7513 66.4987C25.7162 66.4987 25.25 66.7361 25.25 66.755C25.4133 66.6933 25.5902 66.6705 25.765 66.6887C25.9398 66.7069 26.1073 66.7656 26.2526 66.8595L49.5075 79.5801C50.0035 79.9178 50.4091 80.3607 50.692 80.8733C50.9749 81.3859 51.1272 81.9542 51.1367 82.5325V99.8051C51.1367 100.512 50.851 100.982 50.4199 101.115C50.4703 101.115 50.5195 101.1 50.5602 101.072L51.0965 100.783C51.2756 100.633 51.4145 100.445 51.5016 100.235C51.5888 100.025 51.6217 99.7974 51.5978 99.5725V82.3189C51.5915 81.7363 51.4398 81.1634 51.1549 80.647C50.87 80.1305 50.46 79.6853 49.9586 79.3476Z",
    fill: "url(#paint57_linear_2164_2451)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M49.5761 79.5659L26.3212 66.8452C26.1807 66.7517 26.0183 66.6921 25.848 66.6715C25.6777 66.6508 25.5046 66.6697 25.3438 66.7265C25.6174 66.6966 25.8936 66.757 26.1258 66.8974L49.3807 79.6181C49.8782 79.9547 50.2852 80.3972 50.569 80.91C50.8529 81.4228 51.0056 81.9915 51.0149 82.5704V99.843C51.0149 100.512 50.7592 100.968 50.3632 101.129C50.8645 101.053 51.2103 100.564 51.2103 99.786V82.5134C51.2015 81.9351 51.049 81.3669 50.7651 80.8548C50.4812 80.3428 50.0738 79.9012 49.5761 79.5659Z",
    fill: "url(#paint58_radial_2164_2451)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M51.5116 82.4138C50.9151 82.6464 50.1331 82.148 49.7671 81.2983C49.4012 80.4487 49.5817 79.5706 50.1782 79.338C50.7748 79.1055 51.5518 79.6086 51.9227 80.4582C52.2937 81.3079 52.1232 82.1955 51.5116 82.4138Z",
    fill: "url(#paint59_radial_2164_2451)"
  }), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.09,
    d: "M66.3106 108.776L68.7068 107.352C68.7068 107.352 69.5891 106.835 69.6092 106.83C70.1794 106.543 70.8181 106.399 71.4639 106.412C71.6795 106.417 71.8942 106.439 72.1056 106.479C72.4136 106.534 72.71 106.637 72.9829 106.783L77.5797 109.298L78.6875 109.906L82.1966 111.805C82.4501 111.93 82.6665 112.113 82.8259 112.338C82.9853 112.562 83.0826 112.821 83.1089 113.091C82.9286 113.591 82.5995 114.031 82.1614 114.358C81.5575 114.921 80.9035 115.434 80.2064 115.891L79.0434 116.546C78.7827 116.689 78.5051 116.802 78.2163 116.883C77.8754 116.976 77.5231 117.025 77.1686 117.03C76.6306 117.049 76.0968 116.934 75.6197 116.698L75.374 116.565L70.9376 114.14L70.1004 113.665L66.2605 111.562C66.0203 111.44 65.8121 111.268 65.6509 111.059C65.4896 110.851 65.3794 110.611 65.3281 110.357C65.3308 110.325 65.3308 110.294 65.3281 110.262C65.3276 109.952 65.4195 109.648 65.5933 109.385C65.7672 109.122 66.0158 108.911 66.3106 108.776Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.18,
    d: "M66.3503 108.862L68.6762 107.476C68.7163 107.476 69.5184 107.001 69.5685 107.001C70.1269 106.734 70.7478 106.605 71.3732 106.626C71.5822 106.636 71.79 106.661 71.9948 106.702C72.2886 106.767 72.5718 106.869 72.8369 107.006L77.3134 109.455L78.3913 110.044L81.7849 111.9C82.0295 112.019 82.2411 112.192 82.403 112.403C82.5648 112.614 82.6725 112.857 82.7174 113.115C82.6071 113.579 82.348 114 81.9755 114.32C81.4411 114.885 80.8445 115.394 80.1959 115.839L79.0479 116.494C78.7897 116.634 78.5178 116.75 78.2359 116.841C77.9003 116.936 77.5532 116.99 77.2032 117.002C76.6702 117.025 76.1399 116.917 75.6642 116.689L75.4236 116.565L71.0322 114.159L70.2052 113.708L66.4003 111.624C65.933 111.371 65.5879 110.956 65.4379 110.466C65.4379 110.438 65.4379 110.409 65.4379 110.376C65.4044 110.065 65.4743 109.752 65.6378 109.48C65.8014 109.209 66.0505 108.993 66.3503 108.862Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.27,
    d: "M66.3971 108.928L68.6529 107.58C68.7131 107.547 69.455 107.105 69.5252 107.105C70.0735 106.858 70.6782 106.744 71.2847 106.773C71.487 106.788 71.688 106.817 71.8862 106.858C72.169 106.93 72.4417 107.034 72.6984 107.167L77.0496 109.54L78.0973 110.115L81.3958 111.918C81.8119 112.146 82.3382 112.663 82.3382 113.062C82.2931 113.486 82.107 113.885 81.8068 114.201C81.3465 114.768 80.8088 115.274 80.2077 115.706L79.0848 116.37C78.8294 116.512 78.5609 116.631 78.2827 116.726C77.9572 116.823 77.6206 116.882 77.2801 116.902C76.7613 116.932 76.2431 116.834 75.7763 116.617L75.5356 116.494L71.1895 114.121L70.3674 113.674L66.5525 111.624C66.0982 111.371 65.7456 110.982 65.5499 110.518C65.5499 110.49 65.5499 110.461 65.5249 110.433C65.3845 109.877 65.7003 109.308 66.3971 108.928Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.36,
    d: "M66.4381 108.999L68.6287 107.685C68.7089 107.642 69.3858 107.262 69.481 107.243C70.0178 107.012 70.607 106.911 71.1954 106.949C71.3914 106.967 71.5857 106.999 71.7768 107.044C72.0482 107.121 72.3103 107.224 72.5589 107.352L76.7848 109.664L77.7873 110.219L80.9856 111.971C81.3516 112.17 81.9481 112.697 81.9481 113.048C81.9806 113.239 81.9682 113.434 81.9119 113.619C81.8555 113.804 81.7567 113.976 81.6223 114.121C81.2963 114.729 80.8048 115.243 80.1986 115.611L79.0807 116.262C78.8269 116.398 78.564 116.518 78.2936 116.622C77.9694 116.727 77.6325 116.792 77.2911 116.817C76.7745 116.851 76.2572 116.762 75.7872 116.556L75.5466 116.432L71.2456 114.059L70.4384 113.618L66.7139 111.581C66.373 111.396 65.7113 110.85 65.6812 110.528C65.6812 110.499 65.6561 110.471 65.6461 110.447C65.4506 109.949 65.7363 109.379 66.4381 108.999Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.45,
    d: "M66.477 109.066L68.5974 107.789C68.8679 107.635 69.1474 107.495 69.4346 107.371C69.9605 107.158 70.5344 107.074 71.1039 107.124C71.2918 107.144 71.4777 107.178 71.6603 107.224C71.9222 107.306 72.1756 107.411 72.4172 107.537L76.5178 109.778L77.5203 110.319L80.6285 112.013C80.9393 112.184 81.6009 112.721 81.6009 113.02C81.6009 113.167 81.8366 113.736 81.4907 114.031C81.2702 114.646 80.8284 115.168 80.2424 115.507L79.1346 116.152C78.8852 116.291 78.6274 116.417 78.3626 116.527C78.0384 116.634 77.7017 116.702 77.36 116.731C76.8454 116.778 76.3268 116.696 75.8561 116.494C75.7734 116.459 75.6931 116.42 75.6155 116.375L71.3596 114.05L70.5625 113.613L66.8779 111.596C66.5822 111.434 65.8253 110.869 65.8052 110.594C65.7898 110.568 65.7764 110.541 65.7651 110.513C65.5144 110.02 65.7752 109.45 66.477 109.066Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.55,
    d: "M66.5166 109.132L68.5719 107.893C68.836 107.744 69.1107 107.613 69.394 107.499C69.9077 107.306 70.4639 107.236 71.0131 107.295C71.1948 107.32 71.3742 107.358 71.5496 107.409C71.8005 107.493 72.0436 107.596 72.2764 107.718L76.2517 109.892L77.2042 110.414L80.2119 112.056C80.4726 112.199 81.2145 112.744 81.2145 113.005C81.2145 113.124 81.5954 113.703 81.3097 113.955C81.2624 114.261 81.141 114.553 80.9549 114.807C80.7688 115.062 80.5231 115.272 80.237 115.421L79.1491 116.062C78.9021 116.202 78.6479 116.331 78.3873 116.447C78.0739 116.558 77.7472 116.633 77.4147 116.67C76.9023 116.722 76.3845 116.648 75.9108 116.456C75.8297 116.421 75.751 116.382 75.6752 116.338L71.4644 114.035L70.6723 113.604L67.0279 111.61C66.7823 111.477 65.9401 110.888 65.9251 110.661C65.9067 110.638 65.8899 110.614 65.8749 110.589C65.5791 110.091 65.8148 109.517 66.5166 109.132Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.64,
    d: "M66.5484 109.203L68.5535 107.998C68.8087 107.853 69.0772 107.731 69.3557 107.632C69.8578 107.455 70.3985 107.398 70.9297 107.466C71.0995 107.497 71.2669 107.538 71.431 107.59C71.67 107.678 71.9027 107.781 72.1277 107.898L75.9727 110.006L76.9 110.509L79.8075 112.104C80.0181 112.217 80.8101 112.768 80.8101 112.967C80.8101 113.067 81.3415 113.651 81.1109 113.846C81.2413 114.32 80.8352 114.961 80.2186 115.298L79.1409 115.939C79.0507 115.991 78.4991 116.295 78.3938 116.333C78.0853 116.445 77.764 116.523 77.4364 116.565C76.9349 116.626 76.4252 116.562 75.9576 116.38C75.9075 116.38 75.7722 116.29 75.722 116.266L71.5613 113.997L70.7792 113.57L67.17 111.596C66.9745 111.491 66.0471 110.879 66.032 110.694L65.977 110.623C65.6411 110.162 65.8516 109.588 66.5484 109.203Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.73,
    d: "M66.5985 109.251L68.5133 108.083C68.7639 107.946 69.0274 107.832 69.3004 107.741C69.7918 107.583 70.3167 107.541 70.8293 107.618C70.9989 107.654 71.1662 107.698 71.3306 107.751C71.4159 107.751 71.9222 108.022 71.9924 108.064L75.7169 110.1L76.6143 110.575L79.4265 112.113C79.5819 112.198 80.429 112.759 80.429 112.91C80.429 112.982 81.1108 113.575 80.9303 113.722C81.191 114.163 80.8652 114.804 80.2135 115.146L79.1557 115.782C79.0856 115.82 78.4991 116.157 78.4189 116.186C78.1165 116.305 77.8001 116.389 77.4765 116.437C76.9816 116.504 76.4769 116.446 76.0126 116.271C75.9317 116.239 75.853 116.203 75.777 116.162L71.6614 113.907L70.8844 113.485L67.3203 111.534C67.1749 111.453 66.1573 110.822 66.1472 110.684L66.0821 110.618C65.7062 110.233 65.8866 109.659 66.5985 109.251Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.82,
    d: "M66.6398 109.336L68.4896 108.207C68.7315 108.073 68.9887 107.966 69.2565 107.889C69.7438 107.748 70.2595 107.721 70.7604 107.808C70.9308 107.841 71.0813 107.908 71.2317 107.95C71.2918 107.95 71.8232 108.24 71.8683 108.264L75.4676 110.233L76.3298 110.708L79.0468 112.194C79.4225 112.397 79.7723 112.641 80.0895 112.92C80.0895 112.967 80.9216 113.575 80.8063 113.67C81.1973 114.083 80.9568 114.719 80.265 115.094L79.2223 115.73C79.1771 115.754 78.5505 116.119 78.5004 116.143C78.2023 116.263 77.8913 116.352 77.573 116.409C77.0835 116.48 76.583 116.431 76.1193 116.266C76.04 116.235 75.9629 116.198 75.8886 116.157L71.8182 113.931L71.0512 113.513L67.5421 111.581C67.1168 111.348 66.7127 111.081 66.3341 110.784L66.2638 110.722C65.7675 110.305 65.9279 109.726 66.6398 109.336Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.91,
    d: "M66.6827 109.407L68.4623 108.311C68.697 108.183 68.948 108.084 69.2092 108.017C69.6791 107.898 70.1718 107.885 70.6479 107.979C70.8016 108.02 70.9524 108.071 71.0991 108.131C71.1292 108.131 71.6806 108.434 71.7057 108.449L75.1796 110.347L76.0117 110.822L78.6285 112.246C78.9949 112.445 79.3481 112.666 79.6862 112.906C79.6862 112.929 80.6888 113.542 80.6136 113.589C81.1149 113.974 80.9746 114.605 80.2527 115.013L79.22 115.644C79.22 115.644 78.5383 116.057 78.5133 116.067C78.2231 116.193 77.9186 116.287 77.6059 116.347C77.1223 116.427 76.6251 116.387 76.1621 116.233C76.0807 116.202 76.002 116.166 75.9265 116.124L71.9162 113.921L71.1642 113.508L67.6552 111.61C67.6051 111.61 66.412 110.907 66.412 110.86L66.3268 110.803C65.8305 110.38 65.9659 109.797 66.6827 109.407Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.9961 116.038L71.2689 113.456L66.5417 110.87C65.89 110.514 65.9703 109.887 66.7273 109.474L68.4416 108.416C68.8289 108.211 69.2612 108.095 69.7043 108.077C70.1474 108.059 70.5888 108.139 70.9933 108.311L75.7204 110.898L80.4476 113.485C81.1043 113.841 81.0191 114.467 80.2621 114.88L78.5527 115.939C78.1645 116.144 77.731 116.26 77.287 116.277C76.8429 116.294 76.4008 116.213 75.9961 116.038Z",
    fill: "black"
  }))), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M77.2527 115.896L68.4249 111.069C67.4223 110.523 66.6252 109.066 66.6252 107.808V84.189C66.6252 83.5482 66.0688 83.4106 66.4047 83.178C66.4047 83.178 67.1917 82.8363 67.2068 82.8315C67.4 82.7472 67.6122 82.7092 67.8246 82.7208C68.037 82.7324 68.2431 82.7932 68.4249 82.8979L77.2527 87.7252C78.2553 88.2663 79.0573 89.7282 79.0573 90.986V114.581C79.0855 114.837 79.0463 115.095 78.9431 115.333C78.8398 115.571 78.6758 115.78 78.4658 115.943L77.4632 116.385C77.1624 116.484 77.6888 116.109 77.2527 115.896Z",
    fill: "url(#paint60_linear_2164_2451)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.6,
    d: "M76.5727 114.833L67.7449 110.005C66.7423 109.459 65.9453 108.002 65.9453 106.744V84.4881C65.9453 83.2302 66.7523 82.6511 67.7449 83.197L76.5727 88.0195C77.5753 88.5653 78.3774 90.0272 78.3774 91.2803V113.523C78.3724 114.795 77.5753 115.374 76.5727 114.833Z",
    fill: "url(#paint61_radial_2164_2451)"
  }), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M76.4136 116.247L67.586 111.42C66.5834 110.879 65.7812 109.417 65.7812 108.159V84.5688C65.7812 83.3157 66.5884 82.7367 67.586 83.2825L76.4136 88.105C77.4162 88.6508 78.2183 90.1128 78.2183 91.3658V114.947C78.2183 116.214 77.4112 116.793 76.4136 116.247Z",
    fill: "white"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M66.0469 108.301V84.6876C66.0469 83.5864 66.7587 83.0785 67.6309 83.5579L76.3885 88.3661C76.8681 88.6912 77.2608 89.1181 77.535 89.6126C77.8092 90.1071 77.9574 90.6556 77.9676 91.214V114.837C77.9676 115.939 77.2607 116.447 76.3885 115.967L67.611 111.149C67.1349 110.822 66.7458 110.394 66.4744 109.9C66.2029 109.406 66.0566 108.859 66.0469 108.301Z",
    fill: "url(#paint62_linear_2164_2451)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M66.3828 107.105V84.9343C66.3828 84.0135 66.9744 83.5911 67.7013 83.985L76.2984 88.6793C76.7 88.9541 77.0284 89.314 77.2573 89.7301C77.4862 90.1462 77.6093 90.6072 77.6168 91.0763V113.247C77.6168 114.168 77.0253 114.591 76.2984 114.197L67.7013 109.502C67.2994 109.228 66.9708 108.868 66.7419 108.452C66.513 108.036 66.39 107.575 66.3828 107.105Z",
    fill: "url(#paint63_linear_2164_2451)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M67.8057 84.2318C67.1189 83.8568 66.5625 84.1606 66.5625 84.9058V107.352C66.5858 107.76 66.7106 108.157 66.9266 108.511C67.1426 108.865 67.4438 109.166 67.8057 109.388L76.2023 113.978C76.8891 114.353 77.4455 114.049 77.4455 113.304V90.858C77.4222 90.4499 77.2975 90.0527 77.0814 89.6989C76.8654 89.345 76.5642 89.0445 76.2023 88.8217L67.8057 84.2318Z",
    fill: "#BCBEC0"
  }))), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M78.4531 96.511V95.0111C78.4572 94.9172 78.4842 94.8255 78.5321 94.7431C78.5799 94.6608 78.6473 94.59 78.7289 94.5365C78.8792 94.4511 79.0046 94.5365 79.0046 94.7311V96.2358C79.0021 96.3333 78.9759 96.429 78.9281 96.5154C78.8803 96.6018 78.8121 96.6766 78.7289 96.7341C78.5785 96.7911 78.4531 96.7056 78.4531 96.511Z",
    fill: "url(#paint64_linear_2164_2451)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M78.6212 96.6866C78.541 96.6866 78.5159 96.5916 78.5159 96.511V95.0111C78.5129 94.919 78.5336 94.8276 78.5764 94.7449C78.6192 94.6621 78.6828 94.5906 78.7615 94.5364C78.7879 94.5302 78.8154 94.5302 78.8417 94.5364C78.9169 94.5364 78.947 94.6313 78.947 94.7073V96.2119C78.9479 96.3037 78.9262 96.3944 78.8836 96.4768C78.8409 96.5592 78.7785 96.6311 78.7013 96.6866C78.6749 96.6921 78.6476 96.6921 78.6212 96.6866Z",
    fill: "url(#paint65_linear_2164_2451)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M78.5805 96.5489V95.049C78.5783 94.9571 78.5994 94.866 78.6421 94.7834C78.6849 94.7008 78.748 94.6291 78.8261 94.5744C78.8494 94.5711 78.8729 94.5711 78.8962 94.5744C78.8891 94.5627 78.8789 94.5531 78.8666 94.5464C78.8543 94.5397 78.8403 94.5363 78.8261 94.5364C78.7998 94.5302 78.7723 94.5302 78.7459 94.5364C78.6672 94.5906 78.6036 94.6621 78.5608 94.7449C78.5179 94.8276 78.4972 94.919 78.5003 95.0111V96.511C78.5003 96.5916 78.5253 96.6866 78.6055 96.6866C78.5831 96.644 78.5743 96.5961 78.5805 96.5489Z",
    fill: "url(#paint66_radial_2164_2451)"
  }), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M77.3366 113.28C77.3477 113.477 77.2875 113.671 77.1661 113.831C77.1174 113.89 77.0548 113.936 76.9834 113.968C76.912 113.999 76.8338 114.014 76.7551 114.011C76.5776 114.003 76.4051 113.953 76.2538 113.864L67.8572 109.274C67.5113 109.061 67.2231 108.774 67.0159 108.436C66.8087 108.098 66.6882 107.719 66.6641 107.328V84.9058C66.6641 84.4311 66.8846 84.1748 67.2455 84.1748C67.4231 84.1828 67.5956 84.2334 67.7468 84.3219L76.1435 88.9119C76.4893 89.1252 76.7775 89.4124 76.9847 89.7504C77.192 90.0884 77.3125 90.4678 77.3366 90.8579V113.28Z",
    fill: "url(#paint67_linear_2164_2451)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M65.8516 112.573L78.0329 119.005H78.078C77.8419 118.067 77.2495 117.244 76.4137 116.693L67.586 111.871C66.7589 111.391 66.0471 111.719 65.8516 112.573Z",
    fill: "url(#paint68_linear_2164_2451)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M78.2675 116.537C78.1823 116.575 77.6359 116.769 77.5807 116.793C77.4256 116.868 77.2538 116.908 77.0794 116.908C76.9051 116.908 76.7332 116.868 76.5781 116.793C77.3255 117.351 77.8547 118.13 78.082 119.005H78.0368L79.4104 118.53C79.2224 117.782 78.8281 117.094 78.2675 116.537Z",
    fill: "url(#paint69_linear_2164_2451)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M74.3152 35.5041C73.3703 34.956 72.3054 34.62 71.2022 34.5216C71.2022 34.4599 71.2022 34.4029 71.2022 34.3412C71.2022 25.413 64.5401 14.5387 56.3239 10.0485C49.7219 6.43641 44.1274 8.06445 42.1874 13.4755C41.6925 13.112 41.1735 12.7791 40.6334 12.4787C35.2195 9.52164 30.8281 11.8902 30.8281 17.7759C30.8281 23.6615 35.2195 30.8335 40.6334 33.7906L74.3052 52.1976C78.5461 54.5186 81.99 52.6723 81.99 48.0539C81.99 43.4355 78.5762 37.8251 74.3152 35.5041Z",
    fill: "url(#paint70_linear_2164_2451)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M97.0004 39.8186C97.0004 35.2097 93.5615 29.5899 89.3155 27.2736C88.3706 26.7255 87.3058 26.3894 86.2025 26.291C86.2025 26.2293 86.2025 26.1724 86.2025 26.1059C86.2025 17.1825 79.5404 6.30345 71.3292 1.81325C66.7123 -0.707157 62.6969 -0.370162 59.8696 1.41928L55.1274 3.98238C52.4455 2.66759 50.0493 2.67709 48.36 3.77828L34.1484 11.6006C35.8779 10.8886 38.1587 11.1259 40.6351 12.4787C41.1752 12.779 41.6942 13.112 42.1891 13.4754C44.1291 8.06439 49.7085 6.43634 56.3256 10.0484C64.5418 14.5387 71.2039 25.4129 71.2039 34.3411C71.2039 34.4028 71.2039 34.4598 71.2039 34.5215C72.3071 34.6199 73.372 34.956 74.3169 35.504C78.5578 37.8251 82.0018 43.4402 82.0018 48.0538C82.0018 50.0047 81.3801 51.4571 80.3525 52.3257L94.509 44.6363C96.0379 43.9244 97.0004 42.2583 97.0004 39.8186Z",
    fill: "url(#paint71_linear_2164_2451)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M63.1349 12.518C69.227 10.1476 73.2467 6.10905 72.1134 3.49767C70.98 0.886294 65.1227 0.690947 59.0307 3.06141C52.9386 5.43187 48.9188 9.47046 50.0521 12.0818C51.1855 14.6932 57.0429 14.8885 63.1349 12.518Z",
    fill: "url(#paint72_radial_2164_2451)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M88.7387 32.7891C89.6059 34.27 86.4728 37.4834 81.7206 39.9706C76.9683 42.4577 78.372 40.9531 77.5047 39.4959C76.6375 38.0387 73.8503 37.1227 78.5825 34.6402C83.3147 32.1578 87.8714 31.3129 88.7387 32.7891Z",
    fill: "url(#paint73_radial_2164_2451)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M40.4002 12.8535C40.9387 13.1561 41.4575 13.489 41.9541 13.8503C42.0633 13.5439 42.1888 13.2429 42.3301 12.9485C41.939 12.6779 41.5431 12.4216 41.1421 12.1985C37.7232 10.3331 34.7155 10.5894 32.9609 12.5118C34.7556 11.2207 37.4225 11.2255 40.4002 12.8535Z",
    fill: "url(#paint74_radial_2164_2451)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M74.8134 35.205C73.8663 34.6575 72.8 34.3215 71.6953 34.2225C71.6953 34.1608 71.6953 34.1038 71.6953 34.0421C71.6953 25.1139 65.0382 14.2396 56.822 9.74941C51.774 6.98694 47.3276 7.29547 44.6406 10.001C47.3626 7.91727 51.4733 7.88403 56.0801 10.4044C64.2963 14.8946 70.9534 25.7689 70.9534 34.6971C70.9534 34.7588 70.9534 34.8158 70.9534 34.8775C72.0565 34.9765 73.1212 35.3126 74.0664 35.86C78.3074 38.1811 81.7463 43.7962 81.7463 48.4098C81.8163 49.7694 81.3896 51.1103 80.5381 52.207C81.7462 51.3954 82.4882 49.8623 82.4882 47.7311C82.4932 43.1602 79.0794 37.545 74.8134 35.205Z",
    fill: "url(#paint75_radial_2164_2451)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M46.7192 36.7382C46.7192 33.8191 44.5386 30.2545 41.8467 28.7878C41.25 28.4375 40.5757 28.223 39.8766 28.1613C39.8766 28.1233 39.8766 28.0853 39.8766 28.0474C39.8766 22.9211 36.4077 16.7791 31.8861 13.5515C31.1432 14.8454 30.7797 16.3041 30.8333 17.7759C30.8333 23.6616 35.2247 30.8336 40.6386 33.7907L46.6992 37.1132C46.7092 36.9851 46.7192 36.8664 46.7192 36.7382Z",
    fill: "url(#paint76_linear_2164_2451)"
  }), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5677 32.547C26.9683 32.1992 26.2926 31.9865 25.5926 31.9252C25.5926 31.8825 25.5926 31.8493 25.5926 31.8066C25.5926 26.1487 21.3717 19.252 16.1633 16.4089C11.9775 14.1163 8.42842 15.1463 7.20026 18.578C6.88056 18.3491 6.54568 18.1398 6.19767 17.9515C2.76382 16.0529 -0.0234375 17.5765 -0.0234375 21.3073C-0.0234375 25.038 2.76382 29.5852 6.19767 31.4601L27.5426 43.1318C30.2345 44.6032 32.4151 43.426 32.4151 40.5022C32.4151 37.5783 30.2596 34.0185 27.5677 32.547Z",
    fill: "url(#paint77_linear_2164_2451)"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9487 35.281C41.9487 32.3572 39.7681 28.7973 37.0761 27.3259C36.4768 26.978 35.8011 26.7653 35.1011 26.7041C35.1036 26.6661 35.1036 26.6281 35.1011 26.5901C35.1011 20.9275 30.8752 14.0356 25.6667 11.1877C22.7442 9.58813 20.1976 9.80171 18.408 10.9361L15.4003 12.5642C13.6959 11.7288 12.1769 11.7336 11.1092 12.4313L2.08594 17.3914C3.18377 16.9167 4.62258 17.0876 6.20165 17.9515C6.54965 18.1398 6.88454 18.3491 7.20423 18.578C8.4324 15.1463 11.9815 14.1163 16.1673 16.4089C21.3757 19.2568 25.5966 26.1487 25.5966 31.8066C25.5966 31.8493 25.5966 31.8825 25.5966 31.9253C26.2966 31.9865 26.9723 32.1992 27.5717 32.5471C30.2636 34.0185 32.4442 37.5783 32.4442 40.5022C32.4442 41.7363 32.0532 42.6619 31.3965 43.203L40.3747 38.3283C41.3372 37.8869 41.9487 36.8284 41.9487 35.281Z",
    fill: "url(#paint78_linear_2164_2451)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M20.4778 17.9742C24.3394 16.4716 26.8872 13.911 26.1685 12.2549C25.4497 10.5989 21.7366 10.4745 17.875 11.9771C14.0133 13.4797 11.4655 16.0402 12.1842 17.6963C12.903 19.3523 16.6161 19.4767 20.4778 17.9742Z",
    fill: "url(#paint79_radial_2164_2451)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M36.713 30.824C37.2645 31.7733 35.2793 33.8 32.2766 35.3759C29.2738 36.9517 30.1562 35.9977 29.6048 35.0626C29.0533 34.1275 27.2887 33.558 30.2864 31.9821C33.2842 30.4063 36.1666 29.8889 36.713 30.824Z",
    fill: "url(#paint80_radial_2164_2451)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M6.06156 18.1888C6.40948 18.3772 6.74436 18.5865 7.06414 18.8153C7.13218 18.621 7.21252 18.4308 7.30475 18.2457C7.05411 18.0749 6.80345 17.9135 6.5478 17.7711C4.38221 16.5845 2.47224 16.7506 1.35938 17.9704C2.48728 17.1683 4.1767 17.1683 6.06156 18.1888Z",
    fill: "url(#paint81_radial_2164_2451)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M27.8872 32.3571C27.2875 32.0093 26.612 31.795 25.912 31.7306C25.912 31.6926 25.912 31.6546 25.912 31.6166C25.912 25.9588 21.6912 19.0621 16.4828 16.2142C13.2795 14.4675 10.4672 14.6573 8.75781 16.3756C10.4873 15.056 13.089 15.0323 16.0115 16.6319C21.2199 19.4798 25.4408 26.3717 25.4408 32.0296C25.4408 32.0723 25.4408 32.1055 25.4408 32.1483C26.1408 32.2095 26.8165 32.4222 27.4159 32.77C30.1078 34.2415 32.2884 37.8014 32.2884 40.7252C32.3333 41.593 32.0627 42.4491 31.5216 43.1507C32.2885 42.6333 32.7547 41.6603 32.7547 40.3028C32.7547 37.4026 30.5741 33.838 27.8872 32.3571Z",
    fill: "url(#paint82_radial_2164_2451)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M74.0703 79.7795L73.3685 79.2147L73.5389 80.0691L73.1279 80.107H72.9474C72.7473 80.1048 72.5485 80.0777 72.3559 80.0263L72.1754 79.9789L71.8094 79.1245L71.624 79.0343L71.238 79.509L70.9372 79.2574C70.69 79.0499 70.4619 78.8228 70.2554 78.5786L70.1401 78.4457L70.3056 77.7955C70.2048 77.6518 70.1128 77.5028 70.0298 77.3493L69.3532 77.1594L69.2879 76.9981L69.2578 76.9221V86.2775L74.2707 89.1017V79.5422L74.0703 79.7795Z",
    fill: "url(#paint83_linear_2164_2451)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.5
  }, _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M73.7062 77.7052C73.7134 77.5961 73.7134 77.4868 73.7062 77.3777L74.2827 77.3065C74.2236 77.0225 74.1363 76.7444 74.022 76.4759L73.3604 76.2908C73.2441 76.0553 73.1065 75.8298 72.9493 75.6168L73.1097 74.9855C72.9184 74.757 72.7053 74.5456 72.4731 74.3542L72.1172 74.7909C72.0258 74.7216 71.9286 74.6597 71.8264 74.6057C71.7346 74.5519 71.6372 74.5074 71.5356 74.4728L71.1847 73.6469C70.9777 73.5927 70.7624 73.5718 70.5481 73.5852L70.7085 74.3921C70.5524 74.4292 70.4101 74.5064 70.2974 74.6152L69.6357 74.0789C69.5123 74.2431 69.4238 74.4285 69.375 74.6247L69.9516 75.3272C69.9351 75.4277 69.9267 75.5293 69.9265 75.631C69.9275 75.7405 69.9359 75.8499 69.9516 75.9585L69.375 76.0297C69.4341 76.3137 69.5213 76.5919 69.6357 76.8603L70.2974 77.0502C70.4118 77.2851 70.5495 77.5092 70.7085 77.7195L70.5481 78.3508C70.7394 78.5793 70.9525 78.7906 71.1847 78.982L71.5356 78.5454C71.6289 78.6134 71.726 78.6768 71.8264 78.7352C71.9198 78.7848 72.017 78.8276 72.1172 78.8634L72.4731 79.6892C72.6792 79.7482 72.8953 79.7691 73.1097 79.751L72.9493 78.9441C73.1038 78.9058 73.2454 78.8306 73.3604 78.7257L74.022 79.2573C74.1454 79.0931 74.2339 78.9077 74.2827 78.7115L73.7062 78.009C73.7142 77.9079 73.7142 77.8063 73.7062 77.7052ZM71.8063 77.4964C71.5848 77.3606 71.4004 77.1772 71.2679 76.9611C71.1355 76.745 71.0589 76.5022 71.0443 76.2528C71.0443 75.7781 71.3852 75.6072 71.8063 75.8398C72.0297 75.9752 72.2158 76.1591 72.3492 76.3762C72.4826 76.5933 72.5594 76.8374 72.5733 77.0882C72.5633 77.5438 72.2324 77.7289 71.8063 77.4964Z",
    fill: "#7C1DC9"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.5
  }, _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5909 44.8832C19.5907 44.7609 19.5806 44.6387 19.5608 44.5177L20.2025 44.4418C20.1333 44.1292 20.036 43.8227 19.9117 43.5257L19.1798 43.3169C19.0532 43.0562 18.9022 42.8069 18.7287 42.5717L18.9041 41.8739C18.6923 41.6223 18.4575 41.3888 18.2023 41.1762L17.8113 41.6509C17.706 41.5797 17.5958 41.5085 17.4855 41.4468C17.3827 41.3901 17.2753 41.3409 17.1646 41.2996L16.7736 40.3883C16.5459 40.3256 16.3081 40.3031 16.0718 40.3218L16.2472 41.2142C16.0752 41.2552 15.9178 41.3387 15.7911 41.4562L15.0642 40.8677C14.927 41.0489 14.8282 41.2536 14.7734 41.4705L15.4151 42.2489C15.3945 42.3586 15.3844 42.4698 15.385 42.5812C15.3852 42.7035 15.3953 42.8257 15.4151 42.9466L14.7734 43.0226C14.8402 43.3373 14.9376 43.6456 15.0642 43.9434L15.7911 44.1522C15.9206 44.4109 16.0731 44.6586 16.2472 44.8927L16.0718 45.5905C16.2823 45.8432 16.5172 46.0768 16.7736 46.2882L17.1646 45.8135C17.2668 45.888 17.3741 45.9562 17.4855 46.0177C17.5895 46.0754 17.6985 46.1246 17.8113 46.1648L18.2023 47.0761C18.4299 47.139 18.6678 47.1615 18.9041 47.1426L18.7287 46.255C18.8994 46.2118 19.055 46.1266 19.1798 46.0082L19.9318 46.5967C20.0661 46.4157 20.1647 46.213 20.2225 45.9987L19.5809 45.2202C19.5946 45.1084 19.5979 44.9956 19.5909 44.8832ZM17.4855 44.6507C17.2401 44.5007 17.0357 44.2977 16.8892 44.0584C16.7428 43.8191 16.6585 43.5503 16.6432 43.2742C16.6432 42.7663 17.0193 42.5622 17.4855 42.7995C17.7308 42.95 17.9351 43.153 18.0823 43.3921C18.2294 43.6312 18.3153 43.8998 18.3327 44.176C18.3327 44.6981 17.9517 44.907 17.4855 44.6507Z",
    fill: "#9F19AB"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M33.9645 82.0295C33.788 82.0278 33.615 81.982 33.4632 81.8966L29.7035 79.8224C29.5542 79.7393 29.4218 79.6316 29.3125 79.5044V86.4675L34.3254 89.3154V81.9441C34.2147 82.0011 34.0905 82.0306 33.9645 82.0295Z",
    fill: "url(#paint84_linear_2164_2451)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.5
  }, _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6964 76.9745L33.6463 76.946V75.6549C33.6194 75.2037 33.4804 74.7649 33.2409 74.3741C33.0014 73.9832 32.6681 73.6512 32.2678 73.4051L31.3203 72.8877C30.5583 72.47 29.9417 72.8023 29.9417 73.6282V74.9192L29.8917 74.8955C29.5408 74.7009 29.25 74.8575 29.25 75.242V78.4412C29.2634 78.6512 29.3283 78.8554 29.4397 79.0375C29.5511 79.2196 29.7059 79.3746 29.8917 79.4901L33.6964 81.5691C34.0473 81.759 34.3381 81.6071 34.3381 81.2226V78.0187C34.3254 77.8091 34.2607 77.6053 34.1492 77.4239C34.0377 77.2424 33.8826 77.0884 33.6964 76.9745ZM32.0321 78.7402V79.4949L31.5559 79.2386V78.4839C31.3637 78.284 31.2504 78.0275 31.2351 77.7577C31.2351 77.4207 31.4857 77.283 31.7915 77.4586C31.9549 77.5573 32.0911 77.6914 32.1887 77.8499C32.2864 78.0084 32.3427 78.1867 32.353 78.37C32.353 78.631 32.2226 78.7687 32.0321 78.7592V78.7402ZM32.8492 76.5093L30.7388 75.3559V74.3259C30.7388 73.8513 31.0896 73.6662 31.5258 73.9035L32.0622 74.1978C32.2911 74.3372 32.4818 74.526 32.6187 74.7488C32.7555 74.9716 32.8346 75.222 32.8492 75.4793V76.5093Z",
    fill: "#9F19AB"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M74.064 100.731C73.9509 100.73 73.8402 100.7 73.7432 100.645L69.3268 98.2341L69.2266 98.1582V108.088L74.2395 110.907V100.707C74.183 100.725 74.1235 100.733 74.064 100.731Z",
    fill: "url(#paint85_linear_2164_2451)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.5
  }, _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M73.4496 97.7784C73.101 97.4931 72.8031 97.1565 72.5673 96.7816C72.422 96.5491 72.427 96.307 72.5673 96.2215C72.7635 96.1099 72.919 95.9443 73.0134 95.7469C73.1688 95.7896 73.3594 95.7469 73.3594 95.5333C73.36 95.3346 73.2811 95.143 73.1388 94.9969C73.1513 94.5168 73.026 94.0425 72.7761 93.6245C72.5263 93.2066 72.1614 92.8607 71.7202 92.6237C70.6575 92.0399 70.3416 92.5952 70.3065 93.4258C70.1762 93.4021 70.081 93.5208 70.081 93.7249C70.1164 93.9545 70.2394 94.1639 70.4268 94.3135C70.5381 94.6453 70.6894 94.9638 70.8779 95.2628C71.0183 95.4953 71.0233 95.7374 70.8779 95.8229C70.6021 95.9441 70.287 95.9577 70.0007 95.8608C69.5545 95.7327 69.2188 95.9842 69.2188 96.5064V97.4082C69.2238 97.504 69.2534 97.5973 69.3049 97.68C69.3564 97.7627 69.4283 97.8323 69.5144 97.8828L73.9308 100.299C74.0913 100.389 74.2216 100.299 74.2216 100.142V99.2831C74.2057 98.9961 74.129 98.7152 73.9964 98.4567C73.8639 98.1983 73.6779 97.9677 73.4496 97.7784Z",
    fill: "#9F19AB"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M47.0651 57.6179H46.9598V59.8583L44.9546 56.5784L42.3379 55.1545C42.2838 55.1251 42.2333 55.0901 42.1875 55.05V65.0177L47.2004 67.8372V57.6037C47.1561 57.6135 47.1106 57.6182 47.0651 57.6179Z",
    fill: "url(#paint86_linear_2164_2451)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.5
  }, _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M46.848 53.3748L42.5169 51.0015C42.2512 50.8544 42.0156 50.973 42.0156 51.2626V54.0393C42.0262 54.1984 42.0773 54.3528 42.1646 54.4892C42.2519 54.6256 42.3728 54.7399 42.5169 54.8224L45.2238 56.3034L46.5773 58.5152V57.0391L46.848 57.1862C47.1137 57.3333 47.3493 57.2147 47.3493 56.9252V54.1484C47.3368 53.991 47.2849 53.8387 47.1977 53.7041C47.1105 53.5696 46.9906 53.4567 46.848 53.3748ZM43.7952 53.8921C43.6549 53.9681 43.4293 53.8446 43.2939 53.6168C43.1586 53.389 43.1486 53.1422 43.2939 53.0615C43.4393 52.9808 43.6599 53.1089 43.7952 53.3368C43.9306 53.5646 43.9356 53.8162 43.7952 53.8921ZM44.9682 54.5329C44.8278 54.6088 44.6022 54.4854 44.4669 54.2576C44.3315 54.0298 44.3265 53.7829 44.4669 53.7022C44.6073 53.6216 44.8378 53.7497 44.9682 53.9823C45.0985 54.2149 45.1086 54.4569 44.9883 54.5329H44.9682ZM46.1412 55.1737C46.0009 55.2496 45.7703 55.1262 45.64 54.8984C45.5096 54.6705 45.4996 54.4237 45.64 54.343C45.7803 54.2624 46.0109 54.3905 46.1412 54.6231C46.2716 54.8556 46.2816 55.0977 46.1412 55.1737Z",
    fill: "#9F19AB"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.5
  }, _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M65.1972 65.3455L61.1367 63.1242C60.8259 62.9533 60.5703 63.0909 60.5703 63.4327V63.5988V65.5828V65.7537C60.582 65.9385 60.6393 66.1181 60.7377 66.278C60.8361 66.438 60.9727 66.5738 61.1367 66.6745L65.1972 68.8959C65.508 69.0668 65.7636 68.9292 65.7636 68.5922V66.2948C65.7562 66.1052 65.701 65.9201 65.6024 65.7549C65.5039 65.5898 65.3649 65.4494 65.1972 65.3455ZM65.5732 68.165L60.7607 65.5306V63.8314L65.5732 66.4609V68.165ZM64.2447 66.4752L62.0892 65.2933V65.5828L64.2447 66.76V66.4752Z",
    fill: "#9F19AB"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.5
  }, _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1813 55.9664C34.1064 55.8644 34.011 55.7773 33.9006 55.7101L29.7199 53.427C29.6792 53.4009 29.6331 53.3832 29.5848 53.3751C29.5364 53.3669 29.4868 53.3684 29.4391 53.3795L31.8102 56.8825L34.1813 55.9664ZM34.1914 55.9806L32.5572 56.8587L32.6123 56.8302L34.1914 59.4076L32.492 56.8967L31.8203 57.2574L31.1485 56.1562L29.4492 56.816L31.0282 55.9664L29.4492 53.389C29.3882 53.4127 29.3373 53.455 29.3046 53.5092C29.2719 53.5633 29.2592 53.6263 29.2686 53.6881V56.3698C29.2788 56.522 29.3263 56.6698 29.4072 56.8016C29.4881 56.9334 29.6003 57.0456 29.7349 57.1293L33.9156 59.4124C34.1763 59.5548 34.3819 59.4408 34.3819 59.1608V56.4695C34.3678 56.2929 34.3018 56.1236 34.1914 55.9806Z",
    fill: "#9F19AB"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.5
  }, _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M55.2953 69.3372L53.8816 70.5855V70.6187L56.1324 71.5253V72.6265L53.8816 71.1029V71.1361L55.3103 73.8606L54.3729 73.9318L53.4806 71.1788H53.4506L52.478 72.935L51.6308 71.8861L53.0495 70.6852V70.652L50.8438 69.7549V68.6537L53.0345 70.1583V70.1251L51.6308 67.3816L52.5382 67.3152L53.4655 70.0682H53.4956L54.403 68.2977L55.2953 69.3372Z",
    fill: "#9F19AB"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.5
  }, _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1544 42.9797L14.7734 43.0272C14.7811 43.0657 14.7912 43.1037 14.8035 43.1411L15.1594 43.0984C15.1552 43.059 15.1535 43.0194 15.1544 42.9797Z",
    fill: "#9F19AB"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.5
  }, _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9918 41.3755V41.3328C15.9418 41.3617 15.8949 41.3951 15.8516 41.4325C15.8972 41.411 15.9439 41.3919 15.9918 41.3755Z",
    fill: "#9F19AB"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.5
  }, _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8672 46.1982L18.9383 46.1694L18.8672 46.1982Z",
    fill: "#9F19AB"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.5
  }, _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M18.645 42.0211L18.4697 42.7236C18.6466 42.9559 18.7993 43.2039 18.9258 43.4641L19.6577 43.6729C19.765 43.934 19.8522 44.2021 19.9183 44.4751L20.1991 44.4419C20.1299 44.1292 20.0326 43.8228 19.9083 43.5258L19.1764 43.317C19.0498 43.0563 18.8989 42.8069 18.7253 42.5717L18.9007 41.874C18.6889 41.6223 18.4541 41.3889 18.1989 41.1763L18.0234 41.3946C18.2483 41.5871 18.4562 41.7966 18.645 42.0211Z",
    fill: "#9F19AB"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.5
  }, _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2329 44.8025C17.5387 44.9687 17.8043 44.9354 17.9497 44.7551C17.7861 44.7735 17.621 44.7365 17.4835 44.6507C17.2381 44.5007 17.0337 44.2978 16.8873 44.0584C16.7409 43.8191 16.6565 43.5503 16.6413 43.2742C16.6354 43.1289 16.6794 42.9857 16.7666 42.866C16.541 42.9039 16.3906 43.1033 16.3906 43.4213C16.4067 43.698 16.4913 43.9671 16.6376 44.2071C16.7839 44.447 16.9879 44.651 17.2329 44.8025Z",
    fill: "#9F19AB"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.5
  }, _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4688 46.402L18.614 47.1425C18.7091 47.1496 18.8047 47.1496 18.8998 47.1425L18.7294 46.2976C18.6487 46.3448 18.5608 46.3801 18.4688 46.402Z",
    fill: "#9F19AB"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.5
  }, _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5888 44.8831C19.5936 44.8008 19.5936 44.7184 19.5888 44.6362L19.3281 44.6695C19.3354 44.7912 19.3354 44.9132 19.3281 45.035C19.3361 45.1456 19.3361 45.2566 19.3281 45.3672L19.9698 46.1456C19.9313 46.2708 19.8827 46.393 19.8244 46.5111L19.9297 46.5965C20.064 46.4155 20.1626 46.2129 20.2204 45.9985L19.5788 45.22C19.5925 45.1082 19.5958 44.9955 19.5888 44.8831Z",
    fill: "#9F19AB"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.5
  }, _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5357 41.6128C15.6052 41.5481 15.6846 41.4937 15.7713 41.4514L15.0595 40.8723C15.0041 40.9474 14.9554 41.0268 14.9141 41.1096L15.5357 41.6128Z",
    fill: "#9F19AB"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.5
  }, _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9186 45.9607L16.7031 46.2265L16.7783 46.293L17.0038 46.0177L16.9186 45.9607Z",
    fill: "#9F19AB"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.5
  }, _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5214 40.5448L16.9124 41.4561C17.0236 41.4964 17.131 41.5456 17.2333 41.6033C17.3456 41.6636 17.4527 41.7318 17.5541 41.8074L17.7196 41.6033C17.6442 41.5484 17.5656 41.4976 17.484 41.4514C17.3811 41.3947 17.2738 41.3455 17.1631 41.3042L16.7721 40.3929C16.5444 40.3303 16.3066 40.3077 16.0703 40.3265L16.1004 40.4784C16.2427 40.4874 16.3837 40.5096 16.5214 40.5448Z",
    fill: "#9F19AB"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.5
  }, _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M44.2068 53.8492C44.0665 53.9252 44.0665 54.1767 44.2068 54.4046C44.3472 54.6324 44.5778 54.7605 44.7081 54.6846C44.7327 54.668 44.7533 54.6467 44.7688 54.6223C44.7843 54.5978 44.7945 54.5705 44.7984 54.5422C44.6537 54.4886 44.5318 54.391 44.452 54.2647C44.3721 54.1384 44.3388 53.9906 44.3572 53.8445C44.3081 53.8293 44.2548 53.831 44.2068 53.8492Z",
    fill: "#9F19AB"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.5
  }, _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M43.035 53.2086C42.8946 53.2846 42.8946 53.5314 43.035 53.764C43.1753 53.9965 43.4059 54.12 43.5363 54.044C43.5608 54.0274 43.5814 54.0062 43.597 53.9817C43.6125 53.9572 43.6225 53.9299 43.6264 53.9016C43.4762 53.8507 43.3524 53.7471 43.2806 53.6121C43.1951 53.4925 43.1627 53.3459 43.1903 53.2039C43.1394 53.1884 43.0846 53.1901 43.035 53.2086Z",
    fill: "#9F19AB"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.5
  }, _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M45.3865 54.4901C45.2462 54.5661 45.2462 54.8176 45.3865 55.0454C45.5269 55.2733 45.7575 55.4014 45.8878 55.3255C45.9123 55.3089 45.933 55.2876 45.9485 55.2632C45.964 55.2387 45.9741 55.2114 45.978 55.1831C45.8282 55.132 45.7034 55.0306 45.6271 54.8983C45.5459 54.7753 45.514 54.6288 45.5369 54.4854C45.4878 54.4702 45.4345 54.4719 45.3865 54.4901Z",
    fill: "#9F19AB"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.5
  }, _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M46.3281 57.1956V58.1069L46.5788 58.5198V57.3332L46.3281 57.1956Z",
    fill: "#9F19AB"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.5
  }, _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M46.8555 53.3747L42.5243 51.0014C42.3238 50.8923 42.1483 50.9349 42.0781 51.0916C42.1478 51.0961 42.2151 51.1173 42.2737 51.1533L46.6048 53.5265C46.7482 53.611 46.8684 53.7264 46.9556 53.8634C47.0427 54.0004 47.0943 54.155 47.1061 54.3145V57.0912C47.1056 57.1497 47.0937 57.2076 47.071 57.2621C47.2414 57.2621 47.3567 57.1529 47.3567 56.9393V54.1626C47.3466 54.0027 47.2957 53.8475 47.2084 53.7103C47.1211 53.5731 47 53.4579 46.8555 53.3747Z",
    fill: "#9F19AB"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.5
  }, _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6561 55.862C33.7531 55.9178 33.8369 55.9921 33.9019 56.0803L34.1875 55.9664C34.1126 55.8644 34.0172 55.7773 33.9068 55.7101L29.7261 53.427C29.6854 53.4009 29.6393 53.3832 29.591 53.3751C29.5426 53.3669 29.493 53.3684 29.4453 53.3795L29.6458 53.6691L33.6561 55.862Z",
    fill: "#9F19AB"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.5
  }, _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0144 56.2131L29.4453 56.8207L29.4754 56.8587L30.9141 56.3033L31.5858 57.4045L32.2576 57.039L33.8065 59.3269H33.8417L32.3829 56.9536L32.3277 56.9821L32.5183 56.8824L31.8465 57.2431L31.6861 56.9773L31.5959 57.0153L31.0144 56.2131Z",
    fill: "#9F19AB"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.5
  }, _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1967 55.9805L33.936 56.1181L32.5625 56.8586L32.6177 56.8301L33.936 56.1181C34.0422 56.2571 34.1048 56.4216 34.1166 56.5928V59.2555L34.1917 59.379L34.1266 59.2746C34.1243 59.3283 34.1124 59.3812 34.0915 59.4312C34.2619 59.4312 34.3772 59.3268 34.3772 59.1179V56.4693C34.3661 56.2937 34.3036 56.1244 34.1967 55.9805Z",
    fill: "#9F19AB"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.5
  }, _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M29.454 53.574L29.5793 53.6452L29.4188 53.3794C29.3848 53.3912 29.3542 53.4102 29.329 53.4349C29.3038 53.4595 29.2848 53.4892 29.2734 53.5218C29.3368 53.5273 29.3982 53.545 29.454 53.574Z",
    fill: "#9F19AB"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.5
  }, _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2656 53.6309L30.7695 56.0706L30.8948 56.0041L29.2656 53.6309Z",
    fill: "#9F19AB"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.5
  }, _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M52.7759 70.2866V70.2533L52.5453 69.8072L50.8359 68.6348V68.9575L52.7759 70.2866Z",
    fill: "#9F19AB"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.5
  }, _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M52.2895 67.4433L53.2119 70.201L53.242 70.2152L53.4124 69.8877L52.5402 67.2961L51.6328 67.3673L51.693 67.4908L52.2895 67.4433Z",
    fill: "#9F19AB"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.5
  }, _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M53.2222 71.326L53.1921 71.3118L52.375 72.7879L52.4753 72.9161L53.2723 71.4779L53.2222 71.326Z",
    fill: "#9F19AB"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.5
  }, _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M53.625 71.2549V71.2881L54.9935 73.8845L55.3093 73.8607L54.1113 71.5824L53.625 71.2549Z",
    fill: "#9F19AB"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.5
  }, _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M53.8807 70.6189V70.5857L55.2943 69.3373L54.402 68.2979L54.2566 68.5732L55.0437 69.4845L53.625 70.7376V70.7708L55.8758 71.6774V72.4558L56.1315 72.6267V71.5255L53.8807 70.6189Z",
    fill: "#9F19AB"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M54.8676 72.2279L55.9002 74.193L54.1006 74.3259L53.3737 72.0855L52.5416 73.5901L51.1179 71.8339L52.296 70.8324C52.2408 70.7802 52.1907 70.7233 52.1406 70.6663L50.9375 70.1917V80.0217L55.9504 82.8411V72.9446L54.8676 72.2279Z",
    fill: "url(#paint87_linear_2164_2451)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M65.4587 69.304C65.3012 69.3002 65.1473 69.2577 65.0124 69.1806L60.9571 66.9639C60.846 66.9017 60.7448 66.825 60.6562 66.7361V74.753L65.6692 77.5771V69.2707C65.601 69.2914 65.5302 69.3026 65.4587 69.304Z",
    fill: "url(#paint88_linear_2164_2451)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M46.2207 74.7246H46.1856H46.0954C46.0289 74.7229 45.9637 74.7066 45.9049 74.6771C45.8767 74.7767 45.8083 74.862 45.7144 74.9144L45.6242 74.9666H45.4037L45.2833 74.9097L45.0377 74.772C44.8938 74.6911 44.7894 74.5598 44.7469 74.4065L43.7092 71.1599C43.6912 71.1906 43.6675 71.218 43.6391 71.2406C43.5722 71.2961 43.4909 71.3338 43.4035 71.3498L43.0776 71.4067L43.624 72.1045C43.6657 72.1551 43.7026 72.2091 43.7343 72.2659C43.7748 72.3441 43.7954 72.4303 43.7945 72.5174V72.8354C43.7966 72.9126 43.7748 72.9886 43.7321 73.0543C43.6894 73.12 43.6274 73.1726 43.5538 73.2057L43.4786 73.2389H43.2732L43.1529 73.1819C43.073 73.1343 43.0046 73.0712 42.9523 72.9968L42.1953 72.019V86.344L47.2082 89.1635V74.5347L46.2207 74.7246Z",
    fill: "url(#paint89_linear_2164_2451)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.5
  }, _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M47.4953 73.7989C47.4729 73.7514 47.4443 73.7068 47.4101 73.6661L46.1368 72.0333C46.1198 72.0005 46.0937 71.9726 46.0615 71.9525C46.0615 71.9525 46.0215 71.9525 46.0115 71.9525C46.0014 71.9525 45.9864 71.9763 45.9864 72.0048V72.318C45.987 72.3511 45.9956 72.3835 46.0115 72.413C46.0329 72.4489 46.0562 72.4838 46.0816 72.5174L46.994 73.6518L46.0866 73.8132L46.0165 73.8417C45.9986 73.8614 45.9896 73.8869 45.9914 73.9129V74.2261C45.9919 74.2532 46.0007 74.2795 46.0165 74.3021C46.0292 74.3212 46.0463 74.3374 46.0665 74.3495C46.0781 74.3554 46.0911 74.3584 46.1042 74.3584C46.1173 74.3584 46.1302 74.3554 46.1418 74.3495L47.4151 74.098C47.445 74.0956 47.4732 74.0839 47.4953 74.0648C47.5061 74.0532 47.5144 74.0397 47.5196 74.025C47.5248 74.0103 47.5268 73.9947 47.5254 73.9793V73.8844C47.5199 73.8546 47.5097 73.8259 47.4953 73.7989ZM44.277 70.5001C44.2647 70.4719 44.2496 70.4449 44.2318 70.4194C44.212 70.3912 44.1865 70.367 44.1567 70.3482L43.9161 70.2153C43.891 70.2153 43.8759 70.2153 43.8609 70.2153C43.8526 70.2204 43.846 70.2275 43.8416 70.2358C43.8371 70.2442 43.8351 70.2535 43.8358 70.2628C43.8334 70.2801 43.8334 70.2977 43.8358 70.315L45.1141 74.3448L45.1543 74.4255C45.1763 74.4523 45.2035 74.4749 45.2344 74.492L45.475 74.6248C45.4834 74.6294 45.4929 74.6318 45.5026 74.6318C45.5123 74.6318 45.5219 74.6294 45.5302 74.6248C45.5342 74.6175 45.5362 74.6094 45.5362 74.6011C45.5362 74.5929 45.5342 74.5847 45.5302 74.5774C45.5327 74.5601 45.5327 74.5425 45.5302 74.5252L44.277 70.5001ZM43.3395 70.4622C43.3154 70.4529 43.2885 70.4529 43.2644 70.4622L41.9911 70.709C41.9589 70.7151 41.9294 70.73 41.9059 70.7517C41.8959 70.7778 41.8959 70.8063 41.9059 70.8324V70.9321C41.9063 70.9717 41.9165 71.0108 41.9359 71.046C41.9586 71.0893 41.9855 71.1306 42.0162 71.1694L43.2895 72.8117C43.3092 72.84 43.3347 72.8642 43.3646 72.8829C43.3722 72.887 43.3809 72.8892 43.3897 72.8892C43.3985 72.8892 43.4072 72.887 43.4148 72.8829C43.4231 72.8778 43.4297 72.8707 43.4341 72.8624C43.4385 72.854 43.4404 72.8447 43.4398 72.8354V72.5174C43.4393 72.4858 43.4307 72.4549 43.4148 72.4272C43.3947 72.389 43.3712 72.3525 43.3445 72.318L42.4372 71.1646L43.3445 70.9985C43.3704 70.9958 43.3949 70.9859 43.4148 70.97C43.4241 70.9605 43.4312 70.9493 43.4355 70.937C43.4398 70.9247 43.4412 70.9117 43.4398 70.8988V70.5855C43.4392 70.5585 43.4306 70.5322 43.4148 70.5096C43.3889 70.485 43.3556 70.4684 43.3195 70.4622H43.3395Z",
    fill: "#9F19AB"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M74.1843 61.4818C74.0567 61.4798 73.9321 61.4454 73.8234 61.3822L72.5501 60.6892C72.3799 60.587 72.2385 60.4472 72.1381 60.2818C72.0377 60.1165 71.9813 59.9305 71.9736 59.7399V59.6117L71.2367 59.2082L71.1514 58.9092L69.2266 57.8555V68.3405L74.2395 71.16V61.4771L74.1843 61.4818Z",
    fill: "url(#paint90_linear_2164_2451)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.5
  }, _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M74.0132 57.7794L72.74 57.0817C72.5244 56.9678 72.354 57.0817 72.354 57.2906V57.9598L69.1406 56.1941V57.3997L71.4717 58.686L71.5619 58.9803L72.354 59.4122V59.7493C72.3606 59.8753 72.399 59.998 72.4662 60.1071C72.5334 60.2161 72.6274 60.3083 72.74 60.3758L74.0132 61.0735C74.2237 61.1874 74.3992 61.0735 74.3992 60.8647V58.4107C74.3909 58.2844 74.3519 58.1616 74.2849 58.052C74.2179 57.9424 74.1248 57.8491 74.0132 57.7794ZM73.9631 60.0008C73.9631 60.2097 73.8077 60.2951 73.6122 60.1907L73.542 60.148C73.4406 60.0867 73.3559 60.0036 73.2949 59.9054C73.2339 59.8073 73.1984 59.6968 73.1911 59.5831V58.3775C73.1911 58.1687 73.3465 58.0832 73.542 58.1876L73.6122 58.2256C73.7138 58.2879 73.7984 58.3719 73.8593 58.4708C73.9203 58.5698 73.9558 58.6809 73.9631 58.7952V60.0008Z",
    fill: "#9F19AB"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.5
  }, _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M50.9141 47.1567L52.2324 47.8781V46.1219L50.9141 45.4052V47.1567ZM52.814 48.106L54.1323 48.8274V44.7122L52.814 43.9955V48.106ZM54.7238 42.5715V49.1597L56.0373 49.8764V43.312L54.7238 42.5715Z",
    fill: "#9F19AB"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.5
  }, _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M70.4378 74.5302V74.5015L70.3516 74.5638C70.3792 74.5501 70.408 74.5389 70.4378 74.5302Z",
    fill: "#7C1DC9"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.5
  }, _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M69.6751 75.9917L69.3594 76.0297C69.3659 76.0649 69.3741 76.0997 69.3843 76.1341L69.6852 76.0961C69.6802 76.0629 69.6801 76.0249 69.6751 75.9917Z",
    fill: "#7C1DC9"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.5
  }, _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M72.8327 75.1232L72.6773 75.7545C72.8345 75.9659 72.9721 76.1898 73.0884 76.4238L73.7501 76.6136C73.8483 76.8508 73.9254 77.0953 73.9807 77.3446L74.2613 77.3066C74.2023 77.0226 74.1151 76.7444 74.0008 76.476L73.339 76.2908C73.2227 76.0554 73.0852 75.8299 72.9279 75.6168L73.0884 74.9855C72.8971 74.757 72.684 74.5457 72.4517 74.3542L72.2812 74.5631C72.4802 74.7359 72.6647 74.9231 72.8327 75.1232Z",
    fill: "#7C1DC9"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.5
  }, _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M73.0156 78.9112L73.1071 78.8776C73.1071 78.8776 73.0613 78.8728 73.0156 78.9112Z",
    fill: "#7C1DC9"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.5
  }, _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M71.5588 77.634C71.8346 77.7859 72.0602 77.7574 72.2106 77.5913C72.0695 77.6017 71.9288 77.5684 71.8095 77.4964C71.588 77.3606 71.4035 77.1772 71.2711 76.9611C71.1387 76.745 71.062 76.5023 71.0475 76.2528C71.0421 76.1207 71.0826 75.9907 71.1628 75.8826C70.9422 75.911 70.7969 76.0914 70.7969 76.3904C70.8114 76.6399 70.8881 76.8826 71.0205 77.0987C71.1529 77.3148 71.3373 77.4983 71.5588 77.634Z",
    fill: "#7C1DC9"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.5
  }, _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M72.6797 79.0818L72.81 79.7511C72.9035 79.7582 72.9974 79.7582 73.0908 79.7511L72.9354 78.9727C72.856 79.0202 72.7699 79.0569 72.6797 79.0818Z",
    fill: "#7C1DC9"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.5
  }, _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M73.7138 77.7053C73.7186 77.631 73.7186 77.5565 73.7138 77.4822L73.4531 77.5154C73.4688 77.624 73.4772 77.7334 73.4782 77.8429C73.4779 77.9446 73.4695 78.0462 73.4531 78.1467L74.0346 78.8492C74.0042 78.9589 73.9622 79.0654 73.9093 79.1672L74.0245 79.2574C74.1479 79.0931 74.2365 78.9077 74.2852 78.7115L73.7088 78.009C73.7185 77.908 73.7202 77.8065 73.7138 77.7053Z",
    fill: "#7C1DC9"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.5
  }, _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M70.9122 73.7846L71.2681 74.6105C71.3693 74.646 71.4667 74.6905 71.5589 74.7434C71.6611 74.7974 71.7584 74.8593 71.8497 74.9285L72.01 74.7292C71.9463 74.6837 71.8794 74.6424 71.8096 74.6057C71.7178 74.5519 71.6203 74.5074 71.5188 74.4728L71.1679 73.6469C70.9608 73.5927 70.7456 73.5718 70.5312 73.5852L70.5614 73.7276C70.68 73.7358 70.7975 73.7549 70.9122 73.7846Z",
    fill: "#7C1DC9"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.5
  }, _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M71.2663 78.6831L71.0859 78.911L71.1661 78.9821L71.3617 78.7448L71.2663 78.6831Z",
    fill: "#7C1DC9"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.5
  }, _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M70.0279 74.7529C70.0949 74.6887 70.1728 74.6357 70.2585 74.5962L69.6169 74.0789C69.5643 74.1514 69.5174 74.2276 69.4766 74.3067L70.0279 74.7529Z",
    fill: "#7C1DC9"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.5
  }, _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7814 79.6514V79.3761L31.5558 79.2574V78.5027C31.3637 78.3029 31.2504 78.0464 31.235 77.7765C31.2338 77.6954 31.2544 77.6153 31.2951 77.5439C31.1096 77.5439 30.9844 77.6768 30.9844 77.9142C30.9988 78.1828 31.1123 78.4381 31.3051 78.6356V79.3951L31.7814 79.6514Z",
    fill: "#9F19AB"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.5
  }, _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8553 73.9602C30.6348 73.9934 30.4844 74.1738 30.4844 74.4823V75.5123L32.5898 76.6657V76.3904L30.735 75.3747V74.3447C30.728 74.2073 30.7704 74.0718 30.8553 73.9602Z",
    fill: "#9F19AB"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.5
  }, _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6418 75.0759H29.6868V74.8433C29.6215 74.827 29.5525 74.8306 29.4895 74.8536C29.4265 74.8766 29.3727 74.9179 29.3359 74.9715C29.4467 74.9761 29.5534 75.0125 29.6418 75.0759Z",
    fill: "#9F19AB"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.5
  }, _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6955 76.9744L33.6454 76.9459V75.6549C33.6184 75.2037 33.4795 74.7649 33.2399 74.374C33.0004 73.9831 32.6671 73.6511 32.2669 73.405L31.3193 72.8877C31.1633 72.7722 30.9709 72.7095 30.7729 72.7095C30.5749 72.7095 30.3826 72.7722 30.2266 72.8877C30.3688 72.8538 30.5169 72.8489 30.6613 72.8735C30.8056 72.898 30.9428 72.9514 31.0637 73.0301L32.0162 73.5474C32.4165 73.7936 32.7498 74.1255 32.9893 74.5164C33.2288 74.9073 33.3678 75.3461 33.3948 75.7973V77.0883L33.4398 77.1168C33.6266 77.2302 33.7822 77.384 33.8937 77.5656C34.0053 77.7472 34.0697 77.9513 34.0815 78.161V81.3649C34.0851 81.4653 34.0572 81.5644 34.0013 81.6497C34.2018 81.6497 34.3371 81.4884 34.3371 81.2273V78.0234C34.3253 77.813 34.2609 77.6082 34.1494 77.4259C34.0379 77.2436 33.8823 77.0888 33.6955 76.9744Z",
    fill: "#9F19AB"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.5
  }, _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M69.7471 96.0316C69.8892 96.0815 70.0404 96.1042 70.1918 96.0985C70.3433 96.0928 70.4919 96.0588 70.6294 95.9984C70.6585 95.9818 70.6814 95.9568 70.6946 95.9272C70.4657 95.9786 70.2261 95.9688 70.0028 95.8987C69.9019 95.8614 69.7919 95.8527 69.6859 95.8738C69.5799 95.8949 69.4827 95.9448 69.4062 96.0174C69.5193 95.994 69.6367 95.9989 69.7471 96.0316Z",
    fill: "#9F19AB"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.5
  }, _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M71.4682 92.7755C71.9088 93.0127 72.2731 93.3587 72.5221 93.7768C72.7711 94.1948 72.8953 94.669 72.8818 95.1487C73.0271 95.2952 73.1079 95.4888 73.1075 95.6898C73.1045 95.7195 73.096 95.7484 73.0824 95.7753C73.1166 95.7818 73.152 95.7808 73.1858 95.7725C73.2196 95.7641 73.2509 95.7486 73.2774 95.7272C73.304 95.7057 73.325 95.6788 73.339 95.6485C73.353 95.6181 73.3595 95.5852 73.3581 95.5522C73.3586 95.3535 73.2798 95.1619 73.1374 95.0158C73.1499 94.5357 73.0246 94.0614 72.7748 93.6434C72.525 93.2254 72.16 92.8795 71.7189 92.6426C71.1524 92.3293 70.7965 92.3435 70.5859 92.5524C70.899 92.5213 71.2132 92.6008 71.4682 92.7755Z",
    fill: "#9F19AB"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.5
  }, _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M73.4482 97.7784C73.0996 97.493 72.8017 97.1565 72.5659 96.7816C72.4206 96.549 72.4256 96.3069 72.5659 96.2215C72.7148 96.1387 72.8403 96.0231 72.9319 95.8845C72.8761 95.8988 72.8172 95.8988 72.7614 95.8845C72.6668 96.0833 72.5091 96.2492 72.3103 96.3592C72.1699 96.4399 72.1649 96.6867 72.3103 96.9193C72.5446 97.2951 72.8426 97.6319 73.1926 97.916C73.4212 98.1043 73.6078 98.334 73.7412 98.5916C73.8747 98.8492 73.9523 99.1295 73.9696 99.4159V100.318C73.9718 100.327 73.9718 100.337 73.9696 100.346C74.115 100.408 74.2303 100.346 74.2303 100.18V99.283C74.213 98.9954 74.1349 98.714 74.0006 98.4555C73.8662 98.1971 73.6784 97.9668 73.4482 97.7784Z",
    fill: "#9F19AB"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.5
  }, _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M64.2493 66.7741V66.4751L62.0938 65.2932V65.5733L63.9987 66.6127V66.6365L64.2493 66.7741Z",
    fill: "#9F19AB"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.5
  }, _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M60.5703 64.0022V65.4309V65.5591V65.7062L65.3226 68.3025V68.0273L60.7608 65.5306V64.1066L60.5703 64.0022Z",
    fill: "#9F19AB"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.5
  }, _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M65.2024 65.3455L61.1419 63.1241C60.9213 63.0055 60.7309 63.0387 60.6406 63.1906C60.7292 63.194 60.8154 63.2184 60.8913 63.2618L64.9518 65.4831C65.1158 65.5839 65.2524 65.7197 65.3508 65.8797C65.4492 66.0396 65.5065 66.2192 65.5182 66.404L65.5784 66.4372V68.1412L65.5182 68.108V68.6823C65.5192 68.7649 65.4986 68.8465 65.4581 68.9196C65.6386 68.9196 65.7688 68.782 65.7688 68.5447V66.2474C65.7538 66.066 65.6949 65.8903 65.5966 65.7339C65.4984 65.5775 65.3636 65.4446 65.2024 65.3455Z",
    fill: "#9F19AB"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.5
  }, _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M46.6558 73.7278L46.0642 73.8322L45.9941 73.8607C45.9762 73.8804 45.9672 73.906 45.969 73.9319L46.7209 73.799L46.6558 73.7278Z",
    fill: "#9F19AB"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.5
  }, _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M43.3063 72.3227L42.4592 71.25L42.1484 71.307L43.0557 72.4604C43.081 72.494 43.1045 72.5288 43.1259 72.5648C43.1335 72.596 43.1335 72.6285 43.1259 72.6597L43.2312 72.7926C43.2509 72.8209 43.2765 72.8451 43.3063 72.8638C43.3139 72.868 43.3226 72.8702 43.3314 72.8702C43.3402 72.8702 43.3489 72.868 43.3565 72.8638C43.3648 72.8588 43.3714 72.8517 43.3758 72.8433C43.3803 72.835 43.3823 72.8257 43.3816 72.8163V72.4983C43.3811 72.4668 43.3725 72.4358 43.3565 72.4082C43.3418 72.3787 43.325 72.3501 43.3063 72.3227Z",
    fill: "#9F19AB"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.5
  }, _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M44.2633 70.5001C44.251 70.4719 44.2359 70.4449 44.2181 70.4194C44.1983 70.3912 44.1728 70.367 44.143 70.3482L43.9024 70.2153C43.8773 70.2153 43.8622 70.2153 43.8472 70.2153C43.8389 70.2204 43.8322 70.2275 43.8278 70.2358C43.8234 70.2442 43.8214 70.2535 43.8221 70.2628C43.8197 70.2801 43.8197 70.2977 43.8221 70.315L43.8773 70.4906C43.9071 70.5094 43.9326 70.5336 43.9524 70.5618C43.9713 70.5866 43.9865 70.6138 43.9976 70.6425L45.2157 74.492L45.4563 74.6248C45.4647 74.6294 45.4743 74.6318 45.484 74.6318C45.4936 74.6318 45.5031 74.6294 45.5115 74.6248C45.5155 74.6175 45.5175 74.6094 45.5175 74.6011C45.5175 74.5929 45.5155 74.5847 45.5115 74.5774C45.514 74.5601 45.514 74.5425 45.5115 74.5252L44.2633 70.5001Z",
    fill: "#9F19AB"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.5
  }, _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M43.3196 70.4622C43.2955 70.453 43.2686 70.453 43.2445 70.4622L41.9712 70.709C41.939 70.7152 41.9095 70.7301 41.886 70.7518C41.8818 70.7737 41.8818 70.7963 41.886 70.8182L43.0089 70.5999C43.0208 70.5951 43.0335 70.5926 43.0464 70.5926C43.0594 70.5926 43.0721 70.5951 43.084 70.5999C43.106 70.6135 43.1248 70.6313 43.1392 70.6521C43.1467 70.6769 43.1467 70.7032 43.1392 70.7281V71.0318L43.2995 71.0033C43.3254 71.0007 43.3499 70.9908 43.3698 70.9749C43.3876 70.9551 43.3966 70.9296 43.3949 70.9037V70.5904C43.3943 70.5633 43.3856 70.537 43.3698 70.5145C43.3571 70.4939 43.34 70.4762 43.3196 70.4622Z",
    fill: "#9F19AB"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.5
  }, _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M47.5011 73.799C47.4787 73.7515 47.4501 73.7069 47.4159 73.6662L46.1426 72.0333C46.1256 72.0006 46.0996 71.9727 46.0673 71.9526C46.0673 71.9526 46.0273 71.9526 46.0173 71.9526C46.0073 71.9526 45.9922 71.9764 45.9922 72.0049V72.3039L47.1653 73.8085C47.1976 73.8504 47.2261 73.8949 47.2504 73.9414C47.2576 73.9775 47.2576 74.0145 47.2504 74.0506V74.1598L47.3958 74.1313C47.4257 74.1289 47.4539 74.1173 47.476 74.0981C47.4869 74.0865 47.4952 74.073 47.5003 74.0583C47.5055 74.0436 47.5075 74.0281 47.5061 74.0126V73.913C47.512 73.875 47.5103 73.8364 47.5011 73.799Z",
    fill: "#9F19AB"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.5
  }, _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M73.2132 58.2543C73.0578 58.2068 72.9375 58.2828 72.9375 58.4632V59.6688C72.9442 59.7827 72.979 59.8935 73.0391 59.9924C73.0991 60.0914 73.1828 60.1756 73.2834 60.2384L73.3586 60.2811C73.504 60.3618 73.6293 60.3285 73.6794 60.2146C73.6555 60.2081 73.6321 60.2002 73.6093 60.1909L73.539 60.1482C73.4376 60.0869 73.3529 60.0038 73.2919 59.9057C73.2309 59.8075 73.1954 59.697 73.1881 59.5833V58.3777C73.1877 58.3354 73.1963 58.2935 73.2132 58.2543Z",
    fill: "#9F19AB"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.5
  }, _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M74.0148 57.7795L72.7416 57.0818C72.5812 56.9964 72.4508 57.0296 72.3906 57.1388C72.4236 57.1464 72.4557 57.1575 72.486 57.172L73.7642 57.8697C73.8745 57.9392 73.9663 58.0319 74.0324 58.1406C74.0985 58.2493 74.1371 58.371 74.1451 58.4963V60.9549C74.1468 61.007 74.1367 61.0589 74.1152 61.1068C74.2756 61.1448 74.4008 61.0594 74.4008 60.8648V58.4108C74.3926 58.2845 74.3535 58.1616 74.2865 58.0521C74.2195 57.9425 74.1264 57.8492 74.0148 57.7795Z",
    fill: "#9F19AB"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.5
  }, _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M72.0983 58.05V57.8221L69.1406 56.1941V56.4219L72.0983 58.05Z",
    fill: "#9F19AB"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.5
  }, _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M52.8125 44.2185L53.8752 44.7976V48.7087L54.1259 48.8464V44.7311L52.8125 44.0144V44.2185Z",
    fill: "#9F19AB"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.5
  }, _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M50.9141 45.5905L51.9768 46.1743V47.7406L52.2325 47.8783V46.1078L50.9141 45.3911V45.5905Z",
    fill: "#9F19AB"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.5
  }, _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M54.7188 42.5906V42.7947L55.7865 43.3785V49.7388L56.0371 49.8765V43.312L54.7188 42.5906Z",
    fill: "#9F19AB"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M46.133 87.3615C47.6587 86.5558 48.2058 84.7315 47.3548 83.2869C46.5039 81.8422 44.5772 81.3243 43.0515 82.13C41.5258 82.9357 40.9789 84.76 41.8298 86.2046C42.6808 87.6492 44.6073 88.1672 46.133 87.3615Z",
    fill: "url(#paint91_radial_2164_2451)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.83,
    d: "M43.1596 89.0876C43.6335 89.3486 44.1785 89.4707 44.7258 89.4384C45.273 89.4061 45.7979 89.2209 46.2339 88.9062C46.67 88.5915 46.9977 88.1614 47.1756 87.6703C47.3535 87.1793 47.3735 86.6493 47.2333 86.1474C47.0931 85.6455 46.7988 85.1943 46.3878 84.8507C45.9767 84.5072 45.4673 84.2868 44.9239 84.2174C44.3805 84.148 43.8276 84.2328 43.3351 84.4609C42.8426 84.6891 42.4326 85.0504 42.157 85.4992C41.7875 86.101 41.6854 86.817 41.8734 87.49C42.0615 88.1629 42.5241 88.7376 43.1596 89.0876Z",
    fill: "url(#paint92_radial_2164_2451)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.65,
    d: "M43.3639 90.8247C43.7689 91.051 44.2356 91.1584 44.7051 91.1333C45.1746 91.1083 45.6257 90.9519 46.0013 90.684C46.3769 90.4161 46.66 90.0486 46.8149 89.6283C46.9698 89.2079 46.9895 88.7534 46.8715 88.3224C46.7535 87.8914 46.5031 87.5033 46.152 87.2071C45.8009 86.911 45.3648 86.7201 44.8991 86.6587C44.4334 86.5973 43.9588 86.6681 43.5356 86.8622C43.1124 87.0563 42.7596 87.3649 42.5218 87.749C42.2035 88.2628 42.1135 88.8751 42.2714 89.4517C42.4292 90.0283 42.8221 90.522 43.3639 90.8247Z",
    fill: "url(#paint93_radial_2164_2451)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.48,
    d: "M43.5616 92.3438C43.8983 92.5308 44.2861 92.6192 44.6759 92.5977C45.0657 92.5762 45.44 92.4458 45.7516 92.2229C46.0631 92.0001 46.2979 91.6948 46.4263 91.3457C46.5547 90.9966 46.5709 90.6193 46.4729 90.2614C46.3749 89.9035 46.1671 89.5812 45.8758 89.3351C45.5844 89.089 45.2225 88.9302 44.8359 88.8788C44.4492 88.8273 44.0551 88.8856 43.7034 89.0461C43.3517 89.2066 43.0582 89.4622 42.8598 89.7806C42.7279 89.9925 42.6413 90.2269 42.6051 90.4705C42.569 90.714 42.584 90.962 42.6492 91.2001C42.7144 91.4382 42.8284 91.6617 42.985 91.858C43.1416 92.0542 43.3375 92.2193 43.5616 92.3438Z",
    fill: "url(#paint94_radial_2164_2451)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.3,
    d: "M43.7635 93.7392C44.0335 93.89 44.3447 93.9616 44.6577 93.9449C44.9707 93.9282 45.2713 93.824 45.5217 93.6453C45.7721 93.4667 45.9608 93.2218 46.0641 92.9415C46.1674 92.6613 46.1806 92.3583 46.1019 92.071C46.0233 91.7836 45.8563 91.5249 45.6222 91.3274C45.3881 91.13 45.0974 91.0028 44.7869 90.9618C44.4764 90.9209 44.1601 90.9681 43.8779 91.0975C43.5958 91.2269 43.3606 91.4326 43.202 91.6887C42.9899 92.0312 42.9298 92.4394 43.0351 92.8238C43.1403 93.2082 43.4023 93.5374 43.7635 93.7392Z",
    fill: "url(#paint95_radial_2164_2451)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2164_2451",
    x1: 6.71875,
    y1: 85.0007,
    x2: 27.9836,
    y2: 85.0007,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#B086CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#B289CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#B791D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#C1A1D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#C8ABDA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#DAC6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#EFE5F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#E3D1EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#D1B4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#B395D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#9C7DCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#8E6EC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8969C3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2164_2451",
    x1: 22.1216,
    y1: 71.758,
    x2: 15.4748,
    y2: 89.8828,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F79C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#A580CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#B492D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#CDB0E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#D1B4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#DBC4E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBDEF3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2164_2451",
    x1: 6.71374,
    y1: 90.35,
    x2: 27.9786,
    y2: 90.35,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#B086CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#B289CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#B791D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#C1A1D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#C8ABDA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#DAC6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#EFE5F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#E3D1EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#D1B4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#B395D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#9C7DCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#8E6EC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8969C3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_2164_2451",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(17.3437 86.3392) scale(7.84023 7.42356)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2164_2451",
    x1: 7.514,
    y1: 82.2099,
    x2: 27.1897,
    y2: 82.2099,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25054D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#45108A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#25054D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2164_2451",
    x1: 7.514,
    y1: 81.7827,
    x2: 27.1897,
    y2: 81.7827,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7C1DC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#6E41D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#4C9BE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#2AF6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#37D3F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#5093E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#6360DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#703BD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#7925CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#7C1DC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2164_2451",
    x1: 6.71875,
    y1: 80.691,
    x2: 27.9836,
    y2: 80.691,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#B086CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#B289CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#B791D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#C1A1D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#C8ABDA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#DAC6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#EFE5F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#E3D1EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#D1B4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#B395D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#9C7DCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#8E6EC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8969C3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2164_2451",
    x1: 22.1261,
    y1: 67.4435,
    x2: 15.4792,
    y2: 85.5682,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F79C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#A580CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#B492D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#CDB0E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#D1B4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#DBC4E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBDEF3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_2164_2451",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(17.3481 82.0295) scale(7.84023 7.42356)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_2164_2451",
    x1: 7.514,
    y1: 77.9,
    x2: 27.1897,
    y2: 77.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25054D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#45108A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#25054D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_2164_2451",
    x1: 7.514,
    y1: 77.4679,
    x2: 27.1897,
    y2: 77.4679,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7C1DC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#6E41D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#4C9BE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#2AF6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#37D3F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#5093E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#6360DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#703BD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#7925CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#7C1DC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_2164_2451",
    x1: 6.71875,
    y1: 76.3763,
    x2: 27.9836,
    y2: 76.3763,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#B086CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#B289CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#B791D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#C1A1D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#C8ABDA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#DAC6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#EFE5F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#E3D1EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#D1B4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#B395D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#9C7DCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#8E6EC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8969C3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_2164_2451",
    x1: 22.1216,
    y1: 63.1336,
    x2: 15.4748,
    y2: 81.2584,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F79C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#A580CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#B492D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#CDB0E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#D1B4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#DBC4E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBDEF3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial_2164_2451",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(17.3435 77.7148) scale(7.84023 7.42356)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_2164_2451",
    x1: 7.514,
    y1: 73.5854,
    x2: 27.1897,
    y2: 73.5854,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25054D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#45108A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#25054D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_2164_2451",
    x1: 7.514,
    y1: 73.1535,
    x2: 27.1897,
    y2: 73.1535,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7C1DC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#6E41D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#4C9BE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#2AF6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#37D3F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#5093E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#6360DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#703BD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#7925CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#7C1DC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_2164_2451",
    x1: 6.71875,
    y1: 72.0617,
    x2: 27.9836,
    y2: 72.0617,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#B086CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#B289CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#B791D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#C1A1D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#C8ABDA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#DAC6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#EFE5F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#E3D1EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#D1B4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#B395D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#9C7DCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#8E6EC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8969C3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_2164_2451",
    x1: 22.1216,
    y1: 58.8191,
    x2: 15.4748,
    y2: 76.9438,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F79C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#A580CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#B492D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#CDB0E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#D1B4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#DBC4E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBDEF3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint18_radial_2164_2451",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(17.3437 73.4002) scale(7.84022 7.42356)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_2164_2451",
    x1: 7.514,
    y1: 69.2706,
    x2: 27.1897,
    y2: 69.2706,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25054D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#45108A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#25054D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_2164_2451",
    x1: 7.514,
    y1: 68.8437,
    x2: 27.1897,
    y2: 68.8437,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7C1DC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#6E41D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#4C9BE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#2AF6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#37D3F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#5093E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#6360DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#703BD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#7925CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#7C1DC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_2164_2451",
    x1: 6.71875,
    y1: 67.7519,
    x2: 27.9836,
    y2: 67.7519,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#B086CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#B289CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#B791D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#C1A1D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#C8ABDA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#DAC6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#EFE5F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#E3D1EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#D1B4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#B395D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#9C7DCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#8E6EC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8969C3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_2164_2451",
    x1: 22.1261,
    y1: 54.5044,
    x2: 15.4792,
    y2: 72.6291,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F79C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#A580CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#B492D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#CDB0E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#D1B4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#DBC4E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBDEF3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint23_radial_2164_2451",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(17.3481 69.0905) scale(7.84023 7.42356)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_2164_2451",
    x1: 7.514,
    y1: 64.9561,
    x2: 27.1897,
    y2: 64.9561,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25054D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#45108A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#25054D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_2164_2451",
    x1: 7.514,
    y1: 64.529,
    x2: 27.1897,
    y2: 64.529,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7C1DC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#6E41D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#4C9BE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#2AF6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#37D3F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#5093E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#6360DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#703BD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#7925CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#7C1DC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_2164_2451",
    x1: 6.71875,
    y1: 63.4515,
    x2: 27.9836,
    y2: 63.4515,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#B086CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#B289CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#B791D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#C1A1D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#C8ABDA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#DAC6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#EFE5F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#E3D1EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#D1B4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#B395D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#9C7DCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#8E6EC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8969C3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_2164_2451",
    x1: 22.1261,
    y1: 50.2088,
    x2: 15.4792,
    y2: 68.3336,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F79C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#A580CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#B492D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#CDB0E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#D1B4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#DBC4E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBDEF3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint28_radial_2164_2451",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(17.3437 64.79) scale(7.84023 7.42356)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_2164_2451",
    x1: 7.514,
    y1: 60.6605,
    x2: 27.1897,
    y2: 60.6605,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25054D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#45108A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#25054D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_2164_2451",
    x1: 7.514,
    y1: 60.2287,
    x2: 27.1897,
    y2: 60.2287,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7C1DC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#6E41D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#4C9BE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#2AF6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#37D3F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#5093E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#6360DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#703BD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#7925CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#7C1DC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_2164_2451",
    x1: 6.71875,
    y1: 59.1369,
    x2: 27.9836,
    y2: 59.1369,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#B086CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#B289CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#B791D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#C1A1D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#C8ABDA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#DAC6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#EFE5F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#E3D1EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#D1B4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#B395D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#9C7DCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#8E6EC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8969C3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_2164_2451",
    x1: 22.1216,
    y1: 45.8942,
    x2: 15.4748,
    y2: 64.019,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F79C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#A580CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#B492D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#CDB0E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#D1B4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#DBC4E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBDEF3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint33_radial_2164_2451",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(17.3437 60.4756) scale(7.84023 7.42356)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint34_radial_2164_2451",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16.5769 60.5734) scale(5.49526 2.64571)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#5F5C5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_2164_2451",
    x1: 12.9977,
    y1: 58.0879,
    x2: 21.8455,
    y2: 58.0879,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#C1A1D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#C8ABDA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#DAC6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#F7F2F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#F9F5FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E9DBF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#D1B4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#B395D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#9C7DCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#8E6EC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#8969C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#9471C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B086CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_2164_2451",
    x1: 22.7283,
    y1: 50.6645,
    x2: 16.0189,
    y2: 58.2592,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F79C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#A580CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#B492D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#CDB0E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#D1B4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#DBC4E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBDEF3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_2164_2451",
    x1: 20.7364,
    y1: 55.6245,
    x2: 13.7934,
    y2: 55.6245,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#C1A1D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#C8ABDA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#DAC6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#F7F2F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#F9F5FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E9DBF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#D1B4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#B395D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#9C7DCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#8E6EC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#8969C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#9471C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B086CC"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint38_radial_2164_2451",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16.0054 58.1591) scale(3.31354 3.13745)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_2164_2451",
    x1: 43.9519,
    y1: 96.4446,
    x2: 74.0396,
    y2: 96.4446,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#9F79B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#A17BBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#A783BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#B290C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#C1A1D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#C4A5D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#CDB3DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#DBC8E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#EFE7F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#ECE0F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#DDC8EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#D4B9E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#D1B4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#B395D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#9C7DCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#8E6EC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#8969C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B086CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_2164_2451",
    x1: 52.5131,
    y1: 98.2767,
    x2: 65.7942,
    y2: 90.5185,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F79C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#A27DCA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#AC88CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#BC9BD7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#D1B4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#DBC4E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#F4EDF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_2164_2451",
    x1: 43.9489,
    y1: 100.612,
    x2: 74.0366,
    y2: 100.612,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#9F79B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#A17BBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#A783BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#B290C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#C1A1D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#C4A5D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#CDB3DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#DBC8E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#EFE7F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#ECE0F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#DDC8EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#D4B9E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#D1B4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#B395D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#9C7DCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#8E6EC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#8969C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B086CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_2164_2451",
    x1: 59.7466,
    y1: 94.8973,
    x2: 62.2135,
    y2: 90.5305,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_2164_2451",
    x1: 13.8888,
    y1: 36.9043,
    x2: 84.1565,
    y2: 101.371,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F79C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#A27DCA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#AC88CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#BC9BD7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#D1B4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#DBC4E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#F4EDF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_2164_2451",
    x1: 35.5356,
    y1: 42.0259,
    x2: 78.3697,
    y2: 105.694,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#2AF6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#3EC0F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#518FE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#6066DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#6C46D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#752FCE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#7A22CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#7C1DC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#5E1699"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#300B4E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#13051F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#08020D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_2164_2451",
    x1: 91.6132,
    y1: 104.604,
    x2: 58.145,
    y2: 48.1277,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#9F79B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#A17BBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#A783BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#B290C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#C1A1D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#C4A5D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#CDB3DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#DBC8E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#EFE7F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#ECE0F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#DDC8EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#D4B9E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#D1B4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#B395D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#9C7DCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#8E6EC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#8969C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B086CC"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint46_radial_2164_2451",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(81.4302 70.951) scale(6.1709 5.84297)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_2164_2451",
    x1: 8.37433,
    y1: 100.512,
    x2: 53.1798,
    y2: 100.512,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#9F79B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#A17BBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#A783BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#B290C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#C1A1D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#C4A5D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#CDB3DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#DBC8E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#EFE7F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#ECE0F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#DDC8EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#D4B9E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#D1B4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#B395D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#9C7DCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#8E6EC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#8969C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B086CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_2164_2451",
    x1: 7.42304,
    y1: 99.4015,
    x2: 50.5241,
    y2: 99.4015,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F79C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#A580CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#B492D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#CDB0E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#D1B4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#DBC4E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBDEF3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_2164_2451",
    x1: 8.3709,
    y1: 106.194,
    x2: 53.1764,
    y2: 106.194,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#9F79B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#A17BBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#A783BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#B290C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#C1A1D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#C4A5D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#CDB3DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#DBC8E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#EFE7F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#ECE0F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#DDC8EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#D4B9E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#D1B4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#B395D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#9C7DCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#8E6EC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#8969C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B086CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_2164_2451",
    x1: 7.90625,
    y1: 99.4017,
    x2: 50.0449,
    y2: 99.4017,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3D065F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F27BD"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint51_radial_2164_2451",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(29.536 84.7542) rotate(-18.2065) scale(6.02592 3.39272)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#972A74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#8A266A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#601B4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#3D112F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#230A1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#0F040C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#040103"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_2164_2451",
    x1: 30.2735,
    y1: 104.144,
    x2: 30.7965,
    y2: 90.5866,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3D065F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#10054D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_2164_2451",
    x1: 25.7259,
    y1: 90.0226,
    x2: 35.8945,
    y2: 106.883,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#9F79B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#A17BBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#A883C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#B490CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#C5A3DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#DBBBF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#E6C6FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#D6B6F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#B595DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#9D7DCF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#8E6EC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#8969C3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_2164_2451",
    x1: 9.66368,
    y1: 60.7412,
    x2: 52.3891,
    y2: 99.9329,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F79C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#A27DCA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#AC88CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#BC9BD7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#D1B4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#DBC4E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#F4EDF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_2164_2451",
    x1: 17.789,
    y1: 61.5388,
    x2: 57.7182,
    y2: 111.162,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#2AF6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#3EC0F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#518FE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#6066DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#6C46D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#752FCE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#7A22CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#7C1DC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#5E1699"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#300B4E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#13051F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#08020D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_2164_2451",
    x1: 21.4234,
    y1: 65.5496,
    x2: 50.5484,
    y2: 101.821,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7C1DC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#741BBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#56148B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#3B0E60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#26093E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#150523"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#09020F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#020104"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_2164_2451",
    x1: 56.8513,
    y1: 101.946,
    x2: 36.4975,
    y2: 67.5919,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#9F79B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#A17BBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#A783BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#B290C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#C1A1D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#C4A5D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#CDB3DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#DBC8E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#EFE7F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#ECE0F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#DDC8EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#D4B9E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#D1B4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#B395D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#9C7DCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#8E6EC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#8969C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B086CC"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint58_radial_2164_2451",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.5637 81.455) scale(3.74464 3.54565)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint59_radial_2164_2451",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(61.4335 70.9843) rotate(66.432) scale(1.66748 1.14705)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#972A74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#8A266A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#601B4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#3D112F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#230A1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#0F040C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#040103"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_2164_2451",
    x1: 63.3919,
    y1: 83.8852,
    x2: 74.3721,
    y2: 103.979,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#9F79B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#A17BBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#A783BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#B290C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#C1A1D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#C4A5D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#CDB3DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#DBC8E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#EFE7F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#ECE0F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#DDC8EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#D4B9E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#D1B4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#B395D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#9C7DCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#8E6EC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#8969C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B086CC"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint61_radial_2164_2451",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(78.0114 89.9608) scale(12.7479 12.0704)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AF8AFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#10054D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear_2164_2451",
    x1: 79.7773,
    y1: 115.317,
    x2: 62.8184,
    y2: 77.473,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F79C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#A27DCA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#AC88CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#BC9BD7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#D1B4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#DBC4E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#F4EDF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear_2164_2451",
    x1: 66.3828,
    y1: 99.0932,
    x2: 77.6219,
    y2: 99.0932,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25054D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45108A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint64_linear_2164_2451",
    x1: 60.1884,
    y1: 92.9143,
    x2: 61.1095,
    y2: 94.607,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#311B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#290F52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#200041"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0F001F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint65_linear_2164_2451",
    x1: 79.2477,
    y1: 95.6329,
    x2: 77.8646,
    y2: 95.5694,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3D065F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F27BD"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint66_radial_2164_2451",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(78.5504 95.0728) scale(0.811885 0.768941)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#711F56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#6C1E52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#5C1946"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#431233"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#200918"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint67_linear_2164_2451",
    x1: 62.9344,
    y1: 81.849,
    x2: 81.3484,
    y2: 120.913,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#2AF6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#3EC0F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#518FE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#6066DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#6C46D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#752FCE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#7A22CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#7C1DC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#5E1699"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#300B4E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#13051F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#08020D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint68_linear_2164_2451",
    x1: 71.8871,
    y1: 115.834,
    x2: 72.9981,
    y2: 113.76,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7B4FAB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#7E53AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#885EB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#9871BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#AE8BCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#CBADDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#D1B4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#DBC4E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#F4EDF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint69_linear_2164_2451",
    x1: 76.0367,
    y1: 112.701,
    x2: 78.4864,
    y2: 119.549,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#9F79B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#A17BBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#A783BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#B290C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#C1A1D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#C4A5D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#CDB3DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#DBC8E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#EFE7F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#ECE0F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#DDC8EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#D4B9E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#D1B4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#CAADDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#AE91CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#A487C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#9679BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#7E61AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#7052A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#6B4DA1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint70_linear_2164_2451",
    x1: 79.9448,
    y1: 19.4751,
    x2: 19.7768,
    y2: 56.456,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2AF6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#635FDA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#7C1DC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint71_linear_2164_2451",
    x1: 51.5783,
    y1: 1.85596,
    x2: 80.2108,
    y2: 51.9817,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1BB0D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#20C5E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#25DFF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#2AF6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#28EDFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#1DBBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#1BB0D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#25B2D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#40B9DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#6DC4E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#A9D2F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#D6DDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#CCDEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#B2E2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#88E8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#4EF1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#2AF6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#3ACBF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#4E96E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#5F6BDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#6B49D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#7531CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#7A22CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#7C1DC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#6B22BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#4A2CA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#383E9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#1C77B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#138BBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#8CEDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#62F1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#43F4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#2AF6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#46ABEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#635FD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#752FCE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C1DC9"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint72_radial_2164_2451",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(62.2116 10.216) rotate(-21.2614) scale(11.8362 5.11979)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#972A74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#8A266A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#601B4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#3D112F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#230A1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#0F040C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#040103"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint73_radial_2164_2451",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(73.5735 23.4158) rotate(-28.0705) scale(8.31352 2.67773)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4B61B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#38498A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#273360"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#19203E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#0E1223"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#06080F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#020204"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint74_radial_2164_2451",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(38.2395 13.2285) scale(3.48898 3.30357)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint75_radial_2164_2451",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(61.3487 22.1853) scale(21.3099 20.1775)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint76_linear_2164_2451",
    x1: 42.8292,
    y1: 23.3816,
    x2: 29.4734,
    y2: 31.5865,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#F5F3FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#6F4EB5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#390C99"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint77_linear_2164_2451",
    x1: 31.1369,
    y1: 22.3847,
    x2: -7.01055,
    y2: 45.8314,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2AF6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#635FDA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#7C1DC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint78_linear_2164_2451",
    x1: 13.1495,
    y1: 11.2114,
    x2: 31.3042,
    y2: 42.9934,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1BB0D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#20C5E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#25DFF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#2AF6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#28EDFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#1DBBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#1BB0D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#25B2D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#40B9DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#6DC4E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#A9D2F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#D6DDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#CCDEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#B2E2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#88E8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#4EF1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#2AF6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#3ACBF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#4E96E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#5F6BDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#6B49D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#7531CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#7A22CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#7C1DC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#6B22BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#4A2CA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#383E9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#1C77B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#138BBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#8CEDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#62F1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#43F4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#2AF6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#46ABEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#635FD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#752FCE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C1DC9"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint79_radial_2164_2451",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(20.3312 17.4492) rotate(-21.2614) scale(7.50779 3.24748)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#972A74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#8A266A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#601B4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#3D112F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#230A1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#0F040C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#040103"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint80_radial_2164_2451",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.9163 20.391) rotate(-28.0704) scale(5.26886 1.69706)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4B61B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#38498A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#273360"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#19203E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#0E1223"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#06080F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#020204"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint81_radial_2164_2451",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(4.693 18.4261) scale(2.21072 2.09319)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint82_radial_2164_2451",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(19.3501 24.1029) scale(13.5099 12.7919)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint83_linear_2164_2451",
    x1: 72.4009,
    y1: 79.5564,
    x2: 71.1565,
    y2: 86.866,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#45108A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#300B60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#1F073D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#110423"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#08020F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#020004"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint84_linear_2164_2451",
    x1: 32.3353,
    y1: 81.6783,
    x2: 31.3478,
    y2: 87.4547,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#45108A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#300B60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#1F073D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#110423"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#08020F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#020004"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint85_linear_2164_2451",
    x1: 72.4198,
    y1: 100.911,
    x2: 71.1077,
    y2: 108.588,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#45108A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#300B60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#1F073D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#110423"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#08020F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#020004"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint86_linear_2164_2451",
    x1: 45.3807,
    y1: 57.7983,
    x2: 44.0641,
    y2: 65.5033,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#45108A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#300B60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#1F073D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#110423"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#08020F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#020004"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint87_linear_2164_2451",
    x1: 54.1307,
    y1: 72.9019,
    x2: 52.8322,
    y2: 80.5116,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#45108A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#300B60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#1F073D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#110423"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#08020F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#020004"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint88_linear_2164_2451",
    x1: 63.7392,
    y1: 69.1141,
    x2: 62.639,
    y2: 75.5571,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#45108A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#300B60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#1F073D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#110423"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#08020F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#020004"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint89_linear_2164_2451",
    x1: 45.7946,
    y1: 74.7578,
    x2: 43.8738,
    y2: 85.9962,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#45108A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#300B60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#1F073D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#110423"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#08020F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#020004"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint90_linear_2164_2451",
    x1: 72.4549,
    y1: 60.7271,
    x2: 71.0842,
    y2: 68.7606,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#45108A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#300B60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#1F073D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#110423"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#08020F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#020004"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint91_radial_2164_2451",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(34.7619 62.3997) rotate(121.559) scale(3.03794 3.11753)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#B37CE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#7B1DC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#62179E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#4B1179"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#360D58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#25093D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#180626"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#0D0315"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#050109"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#010002"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint92_radial_2164_2451",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(51.5497 107.323) rotate(122.059) scale(2.65872 2.72609)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#B37CE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#7B1DC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#62179E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#4B1179"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#360D58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#25093D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#180626"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#0D0315"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#050109"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#010002"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint93_radial_2164_2451",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(51.5458 109.382) rotate(122.059) scale(2.27821 2.33594)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#B37CE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#7B1DC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#62179E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#4B1179"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#360D58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#25093D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#180626"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#0D0315"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#050109"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#010002"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint94_radial_2164_2451",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(51.5358 111.227) rotate(122.059) scale(1.89771 1.9458)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#B37CE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#7B1DC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#62179E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#4B1179"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#360D58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#25093D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#180626"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#0D0315"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#050109"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#010002"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint95_radial_2164_2451",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(51.5286 112.943) rotate(122.06) scale(1.52203 1.56061)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#B37CE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#7B1DC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#62179E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#4B1179"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#360D58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#25093D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#180626"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#0D0315"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#050109"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#010002"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2164_2451"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 97,
    height: 119,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg6);
export default __webpack_public_path__ + "static/media/6.ded44f03c5c71a6417c75f91101ae040.svg";
export { ForwardRef as ReactComponent };